// monacotto App.js

import React, { useState, useReducer, useContext, useEffect, useLayoutEffect, useRef, useCallback, useMemo } from 'react';
import { Outlet, Link, useNavigate, useLocation, useBlocker } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useDropzone } from 'react-dropzone';
import { CSSTransition } from 'react-transition-group';
import { useCookies } from 'react-cookie';
// import QRCode from 'qrcode.react';
import jsQR from 'jsqr';
import decimal from 'decimal.js';
import * as bip39 from 'bip39';
import BIP32Factory from 'bip32';
import ECPairFactory from 'ecpair';
import ecc from '@bitcoinerlab/secp256k1';
import coininfo from 'coininfo';
import * as bitcoin from 'bitcoinjs-lib';
import * as bitcoinMessage from 'bitcoinjs-message';
import { TwitterShareButton, TwitterIcon } from 'react-share';
import {
  UserRegistrationPopup,
  ReadMnemonicForRegistrationPopup,
  ReadWifForRegistrationPopup,
  UserRegistrationButton,
  SelectMakeMyHomeOrNot,
  TermsAndConditionsPopup,
} from './UserRegistrationUI';
import {
  LoginSection,
  RegistrationAndAgreementListPopup,
  LoginPopup,
} from './LoginUI';
import {
  ItemDetailMore,
  MonadomInfo,
  CreatorInformation,
} from './ItemDetailUI';
import {
  NoteMenuSpPopup,
  ManageComponentPopup,
  EditPopupDisplayPopup,
  PopupDisplay,
  ChangePublicationTypeButton,
} from './NoteUI';
import {
  ExhibitRecordDetailChange,
  ExhibitRecordDetailResume,
  ExhibitRecordDetailFinished,
  PurchaseRecordDetail,
} from './HistoryUI';
import { TokenFilterPopup } from './TokenFilter';
import { ConfirmMnemonicPopup } from './KeyBox';
import {
  SelectWalletBox,
  MnemonicInputPopup,
  WifInputPopup,
  SelectSessionPopup,
  SelectSubAddressPopup,
  SelectAddressFromKeypoolPopup,
  SelectSecretPopup,
  DisplayWifPopup,
 } from './KeysAndSigningUI';
import {
  Header,
  AddressSection,
  AddressHistoryPopup,
  UserName,
  ForDevelopment,
  Item,
} from './MonacottoMiscUI';
import {
  ConfirmationPopup,
  QrCodeScannerPopup,
  QrCodeReaderPopup,
  DisplayQrPopup,
} from './UtilComponents';
import { NativeAppKeyCardReaderPopup } from './NativeAppUI';
import {
  GlobalStateCS,
  useGlobalStateSelector,
  words,
  royaltyPercentageDigit,
  priceDigit,
  marginOfSessionTime,
  getInitialConfigureState,
  setWallet,
} from './globalState';
import {
  getNote,
  getNotesAndUserResources,
  handleClickSaveNote,
  getUserResource,
  getComponents,
} from './note';
import {
  getUtxo,
  getFeeRate,
  broadcastTransaction,
  getAssetInfoByItems
} from './blockchain';
import {
  getUser,
  setAddressesInCookie,
  getItem,
  getItemNew,
  handleClickAddressHistory
} from './monacottoMisc'
import {
  useCallbackPrompt,
  jconfirm,
  urlParamsStringify,
  copyToClipboard,
  getContentTypeAndSuffix,
  devLog,
  initialWalletType,
} from './utils';
import './App.css';
import iconMpurse from './mpurse.png';
import iconLeftBlack from './baseline_arrow_left_black_18dp.png';
import iconRightBlack from './baseline_arrow_right_black_18dp.png';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconLogin from './login_black_24dp.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign1 from './border_color_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';
import iconHandShake from './handshake_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import iconCard from './book_FILL0_wght400_GRAD0_opsz48.svg';
import iconLock from './lock_FILL0_wght400_GRAD0_opsz48.svg';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';
import iconHome from './home_FILL0_wght400_GRAD0_opsz48.svg';
import iconLoginList from './patient_list_FILL0_wght400_GRAD0_opsz48.svg';
import iconReload from './refresh_black_24dp.svg';
import iconZero from './counter_0_FILL0_wght400_GRAD0_opsz48.svg';
import iconSwords from './swords_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import iconEdit from './edit_FILL0_wght400_GRAD0_opsz48.svg';
import iconCotto from './cotto.png';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconKeyCard from './playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconQr from './qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconFilter from './filter_alt_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import iconExpand from './expand_all_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconCollapse from './collapse_all_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconAddress from './slab_serif_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconShare from './share_FILL0_wght400_GRAD0_opsz48.svg';
import iconMenu from './menu_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconCheck from './check_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import logoMonacotto from './logoMonacotto.png';
import imageManualMonachen from './howToUse_monachen.png';
import imageManualPurchase03 from './howToUse_purchase03.png';
import imageManualPurchase04 from './howToUse_purchase04.png';
import imageManualPurchase05 from './howToUse_purchase05.png';
import imageManualPurchaseImageButton from './howToUse_purchase_imageButton.png';
import imageManualExhibit03 from './howToUse_exhibit03.png';
import imageManualExhibit04 from './howToUse_exhibit04.png';
import imageManualExhibit05 from './howToUse_exhibit05.png';
import imageManualExhibit06 from './howToUse_exhibit06.png';
import imageManualMpurse01 from './mpurse01.png';
import imageManualMpurse02 from './mpurse02.png';
import imageManualMpurse03 from './mpurse03.png';
import imageManualMpurse04 from './mpurse04.png';
import imageManualMpurse05 from './mpurse05.png';
import imageManualMpurse06 from './mpurse06.png';
import imageManualMpurse07 from './mpurse07.png';
import imageManualMpurse08 from './mpurse08.png';
import imageManualMpurse09 from './mpurse09.png';
import imageManualMpurse10 from './mpurse10.png';
import imageManualMpurseSp01 from './Mpurse_SP_AppStore.jpg';
import imageManualMpurseSp02 from './Mpurse_SP_DTV.jpg';
import imageManualMpurseSp03 from './Mpurse_SP_password.jpg';
import imageManualMpurseSp04 from './Mpurse_SP_seedPhrase.png';
import imageManualMpurseSp05 from './Mpurse_SP_acount1.png';
import imageManualPurchaseSp01 from './Mpurse_SP_menu_browser.png';
import imageManualPurchaseSp02 from './Mpurse_SP_browser.jpg';
import imageManualPurchaseSp03 from './Mpurse_SP_exte_card.png';
import imageManualExhibitSP01 from './Mpurse_SP_exte.png';
import imageManualExhibitSP02 from './Mpurse_SP_exte_issue.png';
import imageManualExhibitSP03 from './Mpurse_SP_menu_wallet.png';
import imageNotAMonacard from './notAMonacard.png';
// import cottoRolling from './cottoRolling.png';
import termsAndConditionsExhibitorHtml from './tac_exhibitor.static.link';
import termsAndConditionsPurchaserHtml from './tac_purchaser.static.link';
import termsAndConditionsOwnerHtml from './tac_owner.static.link';
import privacyPolicyHtml from './privacypolicy.static.link';

// const words = require('./words.json');
const bip32 = BIP32Factory(ecc);
const ECPair = ECPairFactory(ecc);
const networkMona = coininfo('MONA').toBitcoinJS();

const notificationMaxLength = 100;
// const signatureVersion = '1';
// const versionOfPrivacyPolicy = '1';
// const royaltyPercentageDigit = -6;
// const priceDigit = -6;
// const marginOfSessionTime = 60000;

// let GlobalState = React.createContext(null);
// let wallet;


// AppConnect対応
// porting nodejs EventEmitter
const EventEmitter=function(){
  function EventEmitter(){
    this._events=this._events||{};
    this._maxListeners=this._maxListeners||undefined
  }

  EventEmitter.EventEmitter=EventEmitter;
  EventEmitter.prototype._events=undefined;
  EventEmitter.prototype._maxListeners=undefined;
  EventEmitter.defaultMaxListeners=10;

  EventEmitter.prototype.setMaxListeners=function(n){
    if(!isNumber(n)||n<0||isNaN(n))
      throw TypeError("n must be a positive number");

    this._maxListeners=n;
    return this
  };

  EventEmitter.prototype.emit=function(type){
    var er,handler,len,args,i,listeners;
    if(!this._events)
      this._events={};
    if(type==="error"){
      if(!this._events.error||isObject(this._events.error)&&!this._events.error.length){
        er=arguments[1];

        if(er instanceof Error){
          throw er
        }
        else{
          var err=new Error('Uncaught, unspecified "error" event. ('+er+")");
          err.context=er;
          throw err
        }
      }
    }

    handler=this._events[type];

    if(isUndefined(handler))
      return false;

    if(isFunction(handler)){
      switch(arguments.length){
        case 1:
          handler.call(this);
          break;
        case 2:
          handler.call(this,arguments[1]);
          break;
        case 3:
          handler.call(this,arguments[1],arguments[2]);
          break;
        default:args=Array.prototype.slice.call(arguments,1);
          handler.apply(this,args)
      }
    }
    else if(isObject(handler)){
      args=Array.prototype.slice.call(arguments,1);
      listeners=handler.slice();
      len=listeners.length;
      for(i=0;i<len;i++)
        listeners[i].apply(this,args)
    }

    return true
  };

  EventEmitter.prototype.addListener=function(type,listener){
    var m;

    if(!isFunction(listener))
      throw TypeError("listener must be a function");

    if(!this._events)
      this._events={};

    if(this._events.newListener)
      this.emit("newListener",type,isFunction(listener.listener)?listener.listener:listener);

    if(!this._events[type])
      this._events[type]=listener;
    else if(isObject(this._events[type]))
      this._events[type].push(listener);
    else
      this._events[type]=[this._events[type],listener];

    if(isObject(this._events[type])&&!this._events[type].warned){
      if(!isUndefined(this._maxListeners)){
        m=this._maxListeners
      }
      else{
        m=EventEmitter.defaultMaxListeners
      }
      if(m&&m>0&&this._events[type].length>m){
        this._events[type].warned=true;
        console.error("(node) warning: possible EventEmitter memory "+"leak detected. %d listeners added. "+"Use emitter.setMaxListeners() to increase limit.",this._events[type].length);

        if(typeof console.trace==="function"){
          console.trace()
        }
      }
    }

    return this
  };

  EventEmitter.prototype.on=EventEmitter.prototype.addListener;
  EventEmitter.prototype.once=function(type,listener){
    if(!isFunction(listener))
      throw TypeError("listener must be a function");

    var fired=false;

    function g(){
      this.removeListener(type,g);

      if(!fired){
        fired=true;
        listener.apply(this,arguments)
      }
    }

    g.listener=listener;
    this.on(type,g);
    return this
  };

  EventEmitter.prototype.removeListener=function(type,listener){
    var list,position,length,i;

    if(!isFunction(listener))
      throw TypeError("listener must be a function");

    if(!this._events||!this._events[type])
      return this;

    list=this._events[type];
    length=list.length;
    position=-1;

    if(list===listener||isFunction(list.listener)&&list.listener===listener){
      delete this._events[type];
      if(this._events.removeListener)this.emit("removeListener",type,listener)
    }
    else if(isObject(list)){
      for(i=length;i-- >0;){
        if(list[i]===listener||list[i].listener&&list[i].listener===listener){
          position=i;
          break
        }
      }

      if(position<0)
        return this;

      if(list.length===1){
        list.length=0;
        delete this._events[type]
      }
      else{
        list.splice(position,1)
      }

      if(this._events.removeListener)
        this.emit("removeListener",type,listener)
    }

    return this
  };

  EventEmitter.prototype.removeAllListeners=function(type){
    var key,listeners;
    if(!this._events)
      return this;

    if(!this._events.removeListener){
      if(arguments.length===0)
        this._events={};
      else if(this._events[type])
        delete this._events[type];

      return this
    }

    if(arguments.length===0){
      for(key in this._events){
        if(key==="removeListener")
          continue;

        this.removeAllListeners(key)
      }

      this.removeAllListeners("removeListener");
      this._events={};
      return this
    }

    listeners=this._events[type];

    if(isFunction(listeners)){
      this.removeListener(type,listeners)
    }
    else if(listeners){
      while(listeners.length)
        this.removeListener(type,listeners[listeners.length-1])
    }

    delete this._events[type];
    return this
  };

  EventEmitter.prototype.listeners=function(type){
    var ret;

    if(!this._events||!this._events[type])
      ret=[];
    else if(isFunction(this._events[type]))
      ret=[this._events[type]];
    else
      ret=this._events[type].slice();

    return ret
  };

  EventEmitter.prototype.listenerCount=function(type){
    if(this._events){
      var evlistener=this._events[type];

      if(isFunction(evlistener))
        return 1;
      else if(evlistener)
        return evlistener.length
    }
    return 0
  };

  EventEmitter.listenerCount=function(emitter,type){
    return emitter.listenerCount(type)
  };

  function isFunction(arg){
    return typeof arg==="function"
  }

  function isNumber(arg){
    return typeof arg==="number"
  }

  function isObject(arg){
    return typeof arg==="object"&&arg!==null
  }

  function isUndefined(arg){
    return arg===void 0
  }

  return EventEmitter
}();

const ORIGIN = 'https://monapalette.komikikaku.com';
const SUPPORTED_METHODS = ['getAddress', 'sendAsset', 'signRawTransaction', 'signMessage', 'sendRawTransaction', 'counterBlock', 'counterParty'];
const monapaletteConnect = {};
const id2messageListener = {};
const sendMethod = async(method, params) => {
    if (!window.parent) throw new Error('AppConnect not found');
    const id = Math.random().toFixed(10).slice(-10);
    return await new Promise((resolve, reject) => {
        id2messageListener[id] = (event) => {
            try {
                if (event.origin !== ORIGIN) return;
                const data = event.data;
                if (data.id !== id) return;
                delete id2messageListener[id];
                if (data.error) reject(data.error);
                else resolve(data.value);
            }
            catch (error) { reject(error) }
        };
        window.parent.postMessage({ id, method, params }, ORIGIN);
    });
};
for (const method of SUPPORTED_METHODS) monapaletteConnect[method] = (...params) => sendMethod(method, params);
monapaletteConnect.updateEmitter = new EventEmitter();
window.monapaletteConnect = monapaletteConnect;
window.addEventListener('message', (event) => {
    for (const id in id2messageListener) id2messageListener[id](event);
});

// console.log('ancestor', window.location.ancestorOrigins[0]);

if (window.location.ancestorOrigins !== undefined && window.location.ancestorOrigins[0] === ORIGIN) {
  setWallet({ walletName: 'MonaPallet' });
}
else {
  setWallet({ walletName: 'Mpurse' });
}


function App() {
  const urlParams = (new URL(document.location)).searchParams;

  const initialState = {
    networkMona: coininfo('MONA').toBitcoinJS(),
    marginOfSessionTime: 60000,
    config: {
      clientParameters: {
        versionOfTheTermsAndConditions: 'dummy',
      },
    },
    configKB: {
      clientParameters: {
        versionOfTheTermsAndConditions: 'dummy',
      },
    },
    balance: {
      monaparty: {},
    },
    balanceKOM: {}, // balance.monaparty を使うように修正すべし。
    language: urlParams.get('language') === null ? 'japanese' : urlParams.get('language'),
    device: {
      hasCamera: undefined,
    },
    permit: {
      action: 'grant',
      mode: 'individual', // inclusive
      addressOwner: '',
      // addressOwnerCoinType: 'mona',
      addressPermitTo: '',
      addressPayRoyaltyTo: '',
      // ownerName: '',
      royaltyPercentage: { face: 0, value: 0 },
    },
    requestPermission: {
      addressMain: '',
      addressOwner: '',
      royaltyPercentage: { face: 0, value: 0 },
    },
    login: {
      addressMain: '',
      // addressMainCoinType: 'mona',
      displayAddressSection: false,
    },
    configure: getInitialConfigureState(),
    active: {
      addressMain: null,
      parent: null,
    },
    privateInformation: {},
    keyPairs: {},
    delegate: {
      action: 'request',
      addressDelegateFrom: '',
      addressDelegateTo: '',
    },
    exhibit: {
      exhibitNo: null,
      addressMain: '',
      // addressMainCoinType: 'mona',
      addressCardFrom: '',
      addressPayProceedsTo: '',
      monacottoAddressMonaparty: '',
      tokenName: '',
      amountToSell: '',
      priceMona: { face: '', value: '' },
      priceMonaWatanabe: '',
      signatureByAddressMain: '',
      signatureByAddressCardFrom: '',
      divisible: null,
      disabled: false,
      status: 'waitingForSignature',
    },
    cancelExhibit: {
      exhibitNo: null,
      addressMain: '',
      // addressMainCoinType: 'mona',
      // amountFree: null,
      tokenName: null,
      amountToSell: null,
      signatureByAddressMainCancel: null,
      status: 'waitingForSignature',
    },
    changeExhibit: {
      exhibitNo: null,
      addressMain: '',
      // addressMainCoinType: 'mona',
      addressPayProceedsTo: '',
      // amountToSell: null,
      priceMona: { face: '', value: '' },
      // priceMonaWatanabe: '',
      tokenName: null,
      amountToSell: null,
      signatureByAddressMainChange: null,
      disabled: false,
      status: 'waitingForSignature',
    },
    getHistory: {
      addressMain: '',
      addressType: 'addressOwner',
      action: 'exhibit',
      lastEvaluatedKey: {
        exhibit: [],
        purchase: [],
        sales: [],
        royaltyAddressOwner: [],
        royaltyAddressPayRoyaltyTo: [],
      },
      pagingIndex: {
        exhibit: 0,
        purchase: 0,
        sales: 0,
        royaltyAddressOwner: 0,
        royaltyAddressPayRoyaltyTo: 0,
      },
      cancelAction: 'cancel',
    },
    getPermissionHistory: {
      addressMain: '',
      action: 'permit' ,
      lastEvaluatedKey: {
        permit: [],
        permitted: [],
        permittedInclusively: [],
        requestPermission: [],
        requestedPermission: [],
        delegate: [],
        delegated: [],
      },
      pagingIndex: {
        permit: 0,
        permitted: 0,
        permittedInclusively: 0,
        requestPermission: 0,
        requestedPermission: 0,
        delegate: 0,
        delegated: 0,
      }
    },
    getUser: {
      addressMain: '',
    },
    getItem: {
      addressMain: '',
    },
    purchase: {
      purchaseNo: null,
      addressMain: '',
      addressPayFrom: '',
      addressSendCardTo: '',
      addressMainExhibitor: '',
      exhibitNo: '',
      amountToBuy: 1,
      signatureByAddressMain: '',
      signatureByAddressPayFrom: '',
      addressPayRoyaltyTo: null,
      disabled: false,
      status: 'waitingForSignature',
    },
    addressCheck: 'off',
    gallery: {
      addressMain: urlParams.get('mainaddress') === null ? null : urlParams.get('mainaddress'),
    },
    itemDetail: {
      exhibitor: {},
      item: {},
    },
    itemPlacement: [
    ],
    user: {},
    usersGeneral: [],
    usersGeneralIndex: {},
    exhibitHistory: {},
    items: {},
    itemsNew: {},
    itemsAll: {
      item: [],
    },
    purchaseHistory: {},
    salesHistory: {},
    royaltyAddressOwnerHistory: {},
    royaltyAddressPayRoyaltyToHistory: {},
    assetInfo: {},
    monacard: {},
    permitHistory: {},
    permittedHistory: {},
    permittedInclusivelyHistory: {},
    requestPermissionHistory: {},
    requestedPermissionHistory: {},
    delegateHistory: {},
    delegatedHistory: {},
    session: {},
    // acceptTheTermsAndConditions: '1',
    notification: {
      body: [ '' ],
      index: 0,
      fixed: false,
      inAnimation: false,
    },
    popup: [
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
    ],
    accessing: false,
    screen: null,
    balanceFilter: false,
    registeredCard: {},
    creatorInformation: {
      creater: '',
      createrText: '',
      monacottoAddressMain: '',
      createrLink: [
        {
          title: '',
          url: '',
        },
        {
          title: '',
          url: '',
        },
        {
          title: '',
          url: '',
        },
      ],
    },
    walletType: initialWalletType({ walletTypeParam: urlParams.get('wallettype') }),
    qrCodeScanner: {
      qrCode: undefined,
    },
    tokenFilter: {
      conditions: [
        {
          assetCommon: [],
          addressOwners: [],
          lockStatus: [],
          monacardName: [],
          monacardIssuerNames: [],
          monacardDescription: [],
          monacardTags: [],
          monadom: [],
        },
      ],
      addressOwner: null,
      lockStatus: null,
      monacardName: null,
      monacardIssuerName: null,
      monacardDescription: null,
      monacardTag: null,
      monadom: null,
      conditionIndex: 0,
    },
    cartMonaparty: {
    },
    cartMona: {
    },
    notes: {
    },
    editNote: {
      publicationType: 'draft',
      accessMode: 'edit',
      rightMenuStatus: 'neutral',
      popupDisplayMenuStatus: 'neutral',
      headerHeight: 0,
      loaded: {
        popupDisplay: {},
        components: {},
      },
      maybeNotSaved: {},
    },
    viewNote: {
      viewerMenuStatus: 'neutral',
    },
    subAddresses: {},
    passkey: {
      busy: false,
    },
    unregisteredAddress: {
      address: '',
    },
    savePasswordEncryptedMnemonic: {
      password: '',
      passwordExpressionType: 'kana',
      wordCount: '5',
    },
    loadPasswordEncryptedMnemonic: {
      password: '',
    },
    displaySecret: {
      mnemonic: '',
      mnemonicHidden: '',
      wif: '',
      address: '',
      swapMnemonics: '',
      mnemonicToWif: '',
      wifFromMnemonic: '',
    },
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();
  // GlobalState = React.createContext([state, dispatch, navigate, cookies, setCookie, removeCookie]);

  const value = useMemo(
    () => ({ state, dispatch, navigate, cookies, setCookie, removeCookie }),
    [state, dispatch, navigate, cookies, setCookie, removeCookie]
  )

  useEffect( () => {
    devLog('useEffect; getConfig');

    const func = async () => {
      // AppConnect対応
      window.monapaletteConnect.getAddress().then(() => window.mpurse = window.monapaletteConnect).catch(() => {});

      // カメラある？

      hasCamera().then((hasCamera) => {
        dispatch({ type: 'setStateMultiLayers', keys: ['device', 'hasCamera'], value: hasCamera });
        devLog('has camera; ', hasCamera);
      });

      // 各種設定値取得
      devLog('mainaddress', urlParams.get('mainaddress'));

      // -- cookie情報取得
      if (cookies.addressCheck !== undefined) {
        dispatch({ type: 'setState', key: 'addressCheck', value: cookies.addressCheck });
      }

      dispatch({ type: 'setState', key: 'accessing', value: true });

      const configKeys = ['clientParameters', 'monacottoAddress', 'initialNotification', 'blockbook'];
      getConfig(dispatch, 'monacotto', configKeys, 'config');

      const configKeysKB = ['clientParameters'];
      getConfig(dispatch, 'keybox', configKeysKB , 'configKB');

      // 初期通知表示
      // dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'body', 0], value: config.body.initialNotification.value });

      // -- ユーザ情報取得

      const usersGeneral = await getUser({ dispatch, getType: 'all' });
      devLog('usersGeneral', JSON.stringify(usersGeneral));

      dispatch({ type: 'setState', key: 'accessing', value: false });

      let usersGeneralIndex = {};

      for (const user of usersGeneral.body) {
        usersGeneralIndex[user.addressMain] = user;
      }

      dispatch({ type: 'setState', key: 'usersGeneralIndex', value: usersGeneralIndex });

      // -- モナダム情報取得

      getRegisteredCard(state, dispatch);

      devLog('domain', document.domain);
      // console.log('domain', document.domain);
    };

    func();
  }, []);

  return (
    <div className="App ">
      <GlobalStateCS.Provider value={value}>
        <Outlet />
        {/* popup */}
        {state.popup.map((_, layer) => (
          <Popup key={layer} layer={layer} />
        ))}
      </GlobalStateCS.Provider>
      {/*
        <div className="">
            <Routes>
              {/ <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<LP />} /> /}
              {/ <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<LP />} /> /}
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<NewCard />} />
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<NewCard />} />
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/plaza' : '/plaza'} element={<Village />} />
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/config' : '/config'} element={<ManagementScreen />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/exhibit' : '/exhibit'} element={<Exhibit />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'} element={<Gallery />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/item' : '/item'} element={<ItemDetail />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard'} element={<NewCard />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/allcard' : '/allcard'} element={<AllCard />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/history' : '/history'} element={<History />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/permission' : '/permission'} element={<Permission />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/note' : '/note'} element={<Note />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/redirect' : '/redirect'} element={<Redirect />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouse' : '/howtouse'} element={<HowToUse />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouseadvanced' : '/howtouseadvanced'} element={<HowToUseAdvanced />}/>
              <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'} element={<HowToUseMpurse />}/>
            </Routes>
        </div>
      */}
    </div>
  );
}

// REDIRECT
function Redirect() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const urlParams = (new URL(document.location)).searchParams;
  const addressMain = urlParams.get('mainaddress') === null ? null : urlParams.get('mainaddress');
  const exhibitNo = urlParams.get('exhibitno') === null ? null : parseInt(urlParams.get('exhibitno'), 10);
  const noteNo = urlParams.get('noteno') === null ? null : parseInt(urlParams.get('noteno'), 10);
  const ranRef = useRef(false);
  devLog('addressMain', addressMain);
  devLog('exhibitNo', exhibitNo);
  devLog('noteNo', noteNo);
  console.count('Header mounted'); 

  useEffect( () => {
    if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
      if (ranRef.current) return;  // ２回目以降は何もしない
      ranRef.current = true;
    }

    const func = async () => {
      if (addressMain !== undefined && addressMain !== null && addressMain !== '') {
        if (exhibitNo !== undefined && exhibitNo !== null && exhibitNo !== '') {
          // -- アイテム情報取得
          await getItem(state, dispatch, [addressMain]) // 待たなくてもよさそう。
          .then( items => {
            devLog('items', JSON.stringify(items));

            // -- アセット情報取得

            getAssetInfoByItems(state, dispatch, items);

            // -- モナカード情報取得
            const assetCommons = Object.keys(items.body).reduce( (acc, cur) => {
              devLog('cur', cur);
              devLog('item', JSON.stringify(items.body[cur].item));
              const assetCommons = items.body[cur].item.map( item => item.asset_longname === null ? item.asset : item.asset_longname );
              return acc.concat(assetCommons);
            }, []);

            getMonacard(state, dispatch, assetCommons);

            // itemDetailセット

            const itemsArray = items.body[addressMain].item.filter( item => item.exhibitNo === exhibitNo );

            if (itemsArray[0] !== undefined && (itemsArray[0].status === 'onSale' || itemsArray[0].status === 'soldOut')) {
              devLog('redirect to ItemDetail');

              dispatch({ type: 'setStateMultiLayers', keys: ['itemDetail', 'item'], value: itemsArray[0] });
              dispatch({ type: 'setStateMultiLayers', keys: ['itemDetail', 'exhibitor'], value: itemsArray[0].addressMain });
              navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/item' : '/item');
            }
            else if (
              state.gallery.addressMain !== undefined && state.gallery.addressMain !== null && state.gallery.addressMain !== '' &&
              state.usersGeneralIndex[state.gallery.addressMain] !== undefined
            ) {
              devLog('redirect to Gallery');
              navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home');
            }
            else {
              devLog('redirect to Village');
              navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
            }
          })
        }
        else if (noteNo !== undefined && noteNo !== null && noteNo !== '') {
          const notes = await getNote({
            dispatch,
            searchType: 'specificNotes',
            addressesMain: [addressMain],
            noteNos: [noteNo],
            session: state.session,
            marginOfSessionTime: state.marginOfSessionTime,
            notes: state.notes,
          })
          .then( result => {
            const notes = result[addressMain].notes;

            const components = notes.map( note => {
              return ['components', 'popupDisplay'].map( componentContainer => {
                return getComponents({
                  note,
                  componentContainer,
                  session: state.session,
                  marginOfSessionTime: state.marginOfSessionTime,
                });
              }).flat();
            }).flat();

            getUserResource({
              dispatch,
              userResources: components,
              session: state.session,
              marginOfSessionTime: state.marginOfSessionTime,
            });

            return notes;
          })
          devLog('notes', JSON.stringify(notes, null, 2));

          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'popupDisplay', addressMain], value: false });
          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', addressMain], value: {} });

          if (notes[0] !== undefined && notes[0].status === 'published') {
            devLog('redirect to note');
            navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/note' : '/note', { state: { mode: 'update', addressMain, noteNo } });
          }
          else if (
            state.gallery.addressMain !== undefined && state.gallery.addressMain !== null && state.gallery.addressMain !== '' &&
            state.usersGeneralIndex[state.gallery.addressMain] !== undefined
          ) {
            devLog('redirect to Gallery');
            navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home');
          }
          else {
            devLog('redirect to Village');
            navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
          }
        }
        else if (
          state.gallery.addressMain !== undefined && state.gallery.addressMain !== null && state.gallery.addressMain !== '' &&
          state.usersGeneralIndex[state.gallery.addressMain] !== undefined
        ) {
          devLog('redirect to Gallery');
          navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home');
        }
      }
      else {
        devLog('redirect to Village');
        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
      }
    }

    func();
  });

  return (
    <div>
    </div>
  );
}

// USER REGISTRATION POPUP
// eslint-disable-next-line no-unused-vars
function _UserRegistrationPopup(props) {
  const popupLayer = props.popupLayer;

  // return <UserRegistration popupLayer={popupLayer} />;
}

// ウォレット選択ボックス
// SELECT WALLET BOX
// DEPRECATED
// eslint-disable-next-line no-unused-vars
function _SelectWalletBox(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  let walletSelectBox;

  // ウォレット選択ボタン

  const mpurseButton =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'mpurse' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'mpurse'});
    }}
  >
    <div>
      {words.mpurse[state.language]}
    </div>
  </button>;

  const nfcButton =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'nfc' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'nfc'});
    }}
  >
    <div>
      {words.keyCard[state.language]}
    </div>
    <div>
      {words.nfc[state.language]}
    </div>
  </button>;

  const bcButton =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'qr' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'qr'});
    }}
  >
    <div>
      {words.keyCard[state.language]}
    </div>
    <div>
      {words.bc[state.language]}
    </div>
  </button>

  if ('NDEFReader' in window && state.device.hasCamera) {
    walletSelectBox =
    <div className='flexRow justifyContentSpaceAround widthMax '>
      { mpurseButton }
      { nfcButton }
      { bcButton }
    </div>;
  }
  else if ('NDEFReader' in window) {
    walletSelectBox =
    <div className='flexRow justifyContentSpaceAround widthMax '>
      { mpurseButton }
      { nfcButton }
    </div>;
  }
  else if (state.device.hasCamera) {
    walletSelectBox =
    <div className='flexRow justifyContentSpaceAround widthMax '>
      { mpurseButton }
      { bcButton }
    </div>;
  }
  else {
    walletSelectBox = null;
  }

  
  return walletSelectBox;
}

// SIGN ICON
function SignIcon() {
  const state = useGlobalStateSelector( ({ state }) => state );
  let signIcon;

  if (state.walletType === 'mpurse') {
    signIcon = iconMpurse;
  }
  else if (state.walletType === 'nfc') {
    signIcon = iconKeyCard;
  }
  else { // qr
    signIcon = iconQr;
  }


  return <img className='size2x2 margin0p5' src={signIcon} alt='' />;
}

// // SELECT SESSION POPUP
// function SelectSessionPopup(props) {
//   const [state, dispatch] = useContext(GlobalState);
//   const popupLayer = props.popupLayer;
//   const keysArray = state.popup[popupLayer].body.keysArray;
//   const qr = state.popup[popupLayer].body.qr;
// 
//   let sessionAddresses = Object.keys(state.session);
// 
//   sessionAddresses = sessionAddresses.filter( address =>
//     state.session[address].expirationOfSession >= Date.now() && state.balance.monaparty[address] !== undefined
//   );
// 
//   let qrButtonDummy;
// 
//   if (qr === true) {
//     qrButtonDummy =
//     <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
//     </button>
//   }
// 
//   const title =
//   <div className='widthMax'>
//     {/* PC */}
//     <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
//       <div className='marginSide1 widthMin25' >
//         { words.loggedInAddress[state.language] }
//       </div>
//       <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
//       </button>
//       { qrButtonDummy }
//     </div>
//     {/* SP */}
//     <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
//       <div className='textCenter' >
//         { words.loggedInAddress[state.language] }
//       </div>
//       <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
//       </button>
//       { qrButtonDummy }
//     </div>
//   </div>
// 
//   const records = sessionAddresses.map( address => {
//     let qrButton;
// 
//     const selectButton =
//     <button className='button1' tabindex='0'
//       onClick={ () => {
//         for (const keys of keysArray) {
//           dispatch({ type: 'setStateMultiLayers', keys: keys, value: address });
//         }
// 
//         dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
//       }}
//     >
//       <img className='size2x2' src={iconCheck} alt='' />
//     </button>
// 
//     if (qr === true) {
//       qrButton =
//       <button className='button1' tabindex='0'
//         onClick={ () => {
//           const popup = {
//             type: 'displayQrPopup',
//             body: {
//               data: address,
//             },
//           };
// 
//           dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
//         }}
//       >
//         <img className='size2x2' src={iconQr} alt='' />
//       </button>
//     }
// 
//     // アクティブカラー
// 
//     let activeColor = '';
// 
//     if (state.active.addressMain === address) {
//       activeColor = ' backgroundColorPinkPale';
//     }
// 
//     return (
//       <div className=''>
//         {/* PC */}
//         <div className={'visibleMiddleOrMore boxMonacotto1 margin0p5' + activeColor} >
//           <div className='marginSide1 widthMin25' >
//             { address }
//           </div>
//           { selectButton }
//           { qrButton }
//         </div>
//         {/* SP */}
//         <div className={'visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' + activeColor} >
//           <div className='textCenter' >
//             { address }
//           </div>
//           { selectButton }
//           { qrButton }
//         </div>
//       </div>
//     );
//   });
// 
// 
//   return (
//     <div className=''>
//       {/* PC */}
//       <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
//         <div className='flexColumn alignItemsCenter'>
//           { title }
//         </div>
//         <div className='flexColumn alignItemsCenter'>
//           { records }
//         </div>
//       </div>
//       {/* SP */}
//       <div className='visibleSmallOrLess flexColumn widthMax'>
//         <div className='flexColumn alignItemsCenter widthMax'>
//           { title }
//         </div>
//         <div className='flexColumn alignItemsCenter widthMax'>
//           { records }
//         </div>
//       </div>
//     </div>
//   );
// }

// VIEW SESSION POPUP
function ViewSessionPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;

  let sessionAddresses = Object.keys(state.session);

  sessionAddresses = sessionAddresses.filter( address =>
    state.session[address].expirationOfSession >= Date.now() && state.balance.monaparty[address] !== undefined
  );

  const title =
  <div className='widthMax'>
    {/* PC */}
    <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
      <div className='marginSide1 widthMin25' >
        { words.loggedInAddress[state.language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
    </div>
    {/* SP */}
    <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
      <div className='textCenter' >
        { words.loggedInAddress[state.language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
    </div>
  </div>

  const records = sessionAddresses.map( address =>
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { address }
        </div>
        <button className='button1' tabindex='0'
          onClick={ () => {
            const popup = {
              type: 'displayQrPopup',
              body: {
                data: address,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
          }}
        >
          <img className='size2x2' src={iconQr} alt='' />
        </button>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
        <div className='textCenter' >
          { address }
        </div>
        <button className='button1' tabindex='0'
          onClick={ () => {
            const popup = {
              type: 'displayQrPopup',
              body: {
                data: address,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
          }}
        >
          <img className='size2x2' src={iconQr} alt='' />
        </button>
      </div>
    </div>
  );


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { records }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { records }
        </div>
      </div>
    </div>
  );
}

// // DISPLAY QR POPUP
// function DisplayQrPopup(props) {
//   const [state, dispatch] = useContext(GlobalState);
//   const popupLayer = props.popupLayer;
//   const data = state.popup[popupLayer].body.data;
// 
//   return (
//     <div className='flexColumn alignItemsCenter '>
//       <QRCode value={data} />
//     </div>
//   );
// }

// USER REGISTRATION
// eslint-disable-next-line no-unused-vars
function _UserRegistration(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;


  return (
    <div>
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter borderKOM marginTop1 padding1">
        <div className=''>
          { words.userRegistration[state.language] }
        </div>
        <SelectWalletBox />
        <div className='marginTop0p5 '>
          {/* <AddressIfNotHiddenSections keys={['configure', 'addressMain']} /> */}
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <UserName keys={['configure', 'userName']} />
          {/* <SwitchIcon /> */}
        </div>
        <div className='marginTop1 '>
          <SelectMakeMyHomeOrNot />
        </div>
        <div className='marginTopBottom0p5 '>
          {/* <TermsAndConditions /> */}
        </div>
        <UserRegistrationButton popupLayer={popupLayer} />
      </div>
      <div className="visibleSmallOrLess flexColumn alignItemsCenter borderKOM marginTop1 padding1">
        <div className=''>
          { words.userRegistration[state.language] }
        </div>
        <SelectWalletBox />
        <div className='marginTop0p5 '>
          {/* <AddressIfNotHiddenSections keys={['configure', 'addressMain']} /> */}
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
          <UserName keys={['configure', 'userName']} />
          {/* <SwitchIcon /> */}
        </div>
        <div className='marginTop1 '>
          <SelectMakeMyHomeOrNot />
        </div>
        <div className='marginTopBottom0p5 '>
          {/* <TermsAndConditions /> */}
        </div>
        <UserRegistrationButton popupLayer={popupLayer} />
      </div>
    </div>
  );
}

// eslint-disable-next-line no-unused-vars
function _TermsAndConditionsPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  const termsAndConditions = {
    exhibitor: {
      face: words.forExhibitor[state.language],
      html: termsAndConditionsExhibitorHtml,
    },
    purchaser: {
      face: words.forPurchaser[state.language],
      html: termsAndConditionsPurchaserHtml,
    },
    owner: {
      face: words.forOwner[state.language],
      html: termsAndConditionsOwnerHtml,
    },
    privacyPolicy: {
      face: words.privacyPolicy[state.language],
      html: privacyPolicyHtml,
    },
  };

  const buttons = ['exhibitor', 'purchaser', 'owner', 'privacyPolicy'].filter( target1 => target1 !== props.target ).map( target2 =>
    <button className='backgroundColorMonacottoPale borderMonacotto margin0p5'
      onClick={ () => {
        const popup = { type: 'generalItems', body: <TermsAndConditionsPopup target={target2} /> };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
      }}
    >
      { termsAndConditions[target2].face }
    </button>
  );

  return (
    <div>
      <div>
        { buttons }
      </div>
      <div dangerouslySetInnerHTML={ { __html: termsAndConditions[props.target].html } } />
    </div>
  );
}

function PrivacyPolicy() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  if (state.configure.acceptedVersionOfPrivacyPolicy !== state.config.clientParameters.versionOfPrivacyPolicy) {
    return (
      <button className='borderNone backgroundColorWhite textLeft focusEffect01 colorRed cursor borderRadius2 riseOut2 marginTopBottom0p5' tabindex='0'
        onClick={ () => {
          if (state.configure.readPrivacyPolicy === true) {
            dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'acceptedVersionOfPrivacyPolicy'], value: state.config.clientParameters.versionOfPrivacyPolicy });
          }
        }
      }>
        {words.iAcceptPrivacyPolicy[state.language]}
      </button>
    );
  }
  else {
    return (
      <button className='borderNone backgroundColorWhite textLeft focusEffect01 borderRadius2 riseOut2 marginTopBottom0p5'>
        {words.privacyPolicyHasBeenAccepted[state.language]}
      </button>
    );
  }
}

// VILLAGE
function Village() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  let homes;

  /*
  useEffect( () => {
    // 出品物取得
    const func = async () => {
      // -- ユーザ情報取得
      const usersGeneral = await getUser(state, dispatch, 'all');
      devLog('usersGeneral', JSON.stringify(usersGeneral));
    };

    // // usersGeneral index作成
    // for (const [index, item] of state.items[state.gallery.addressMain].itemPlacement[0].items.entries()) {
    //   itemPlacementIndex[item.itemType][item.no.toString()] = index;
    // }

    func();
  }, []);
  */

  if (state.usersGeneral.length > 0) {
    homes = state.usersGeneral.filter( user => user.homed === true ).map( user => <HomeGate user={user} /> )
  }
  else {
    homes = null;
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <Header screen='village' />
        <div className='flexColumn alignItemsCenter ' >
          {/*
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            <TextLine3 fieldName='getItemAddressMain' keys={['gallery', 'addressMain']} face='main address' tooltip={true} />
            <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['gallery', 'addressMain']) }>
              <img className='size2x2' src={iconMpurse} />
            </button>
          </div>
          */}
          <div className='flexRow justifyContentFlexStart widthMax '>
            { homes }
          </div>
        </div>
        <div>
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <Header screen='village' />
        <div className='flexColumn alignItemsCenter ' >
          {/*
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            <TextLine3 fieldName='getItemAddressMain' keys={['gallery', 'addressMain']} face='main address' tooltip={true} />
            <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['gallery', 'addressMain']) }>
              <img className='size2x2' src={iconMpurse} />
            </button>
          </div>
          */}
          <div className='flexColumn '>
            { homes }
          </div>
        </div>
      </div>
    </div>
  );
}

// HOME GATE
function HomeGate(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );

  const user = props.user;
  let mainImage;

  // メインイメージ
  if (user.images.main === true) {
    if (user.images.mainNumber !== undefined) {
      mainImage = <img className='mainImage' src={`https://${process.env.REACT_APP_MONACOTTO_USER_IMAGE}${user.addressMain}_main_${user.images.mainNumber.toString().padStart(4, '0')}.img`} alt='' />
    }
    else {
      mainImage = <img className='mainImage' src={`https://${process.env.REACT_APP_MONACOTTO_USER_IMAGE}${user.addressMain}_main.img`} alt='' />
    }
  }
  else {
    mainImage = null;
  }

  return (
    <div className='maxWidthMax' >
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <button className='gate ' disabled={props.disabled ? true : false}
          onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: user.addressMain });
            dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'userName'], value: user.userName }); // これいらないんじゃないかと思う。
            navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'); 
          }}
        >
          <div className='flexColumn justifyContentFlexStart'>
            { mainImage }
            <div className='flexRow justifyContentFlexStart font1p5 '>
              {user.userName}
            </div>
            <div className='flexRow justifyContentSpaceBetween '>
              {user.addressMain}
            </div>
          </div>
        </button>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess">
        <button className='gateSmallScreen ' disabled={props.disabled ? true : false}
          onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: user.addressMain });
            dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'userName'], value: user.userName }); // これいらないんじゃないかと思う。
            navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'); 
          }}
        >
          <div className='flexColumn justifyContentFlexStart'>
            <MainImage user={user} imageClass='mainImageSmallScreen' />
            <div className='flexRow justifyContentFlexStart font1p5 '>
              {user.userName}
            </div>
            <div className='flexRow justifyContentSpaceBetween '>
              {user.addressMain}
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

// MAIN IMAGE
function MainImage(props) {

  const user = props.user;
  const imageClass = props.imageClass;
  let mainImage;

  if (user.images.main === true) {
    if (user.images.mainNumber !== undefined) {
      mainImage = <img className={imageClass} src={`https://${process.env.REACT_APP_MONACOTTO_USER_IMAGE}${user.addressMain}_main_${user.images.mainNumber.toString().padStart(4, '0')}.img`} alt='' />
    }
    else {
      mainImage = <img className={imageClass} src={`https://${process.env.REACT_APP_MONACOTTO_USER_IMAGE}${user.addressMain}_main.img`} alt='' />
    }
  }
  else {
    mainImage = null;
  }

  return (
    <div className='' >
      { mainImage }
    </div>
  );
}

// GALLERY
function Gallery() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const addressMain = state.gallery.addressMain;

  const usersGeneralExhibitor = state.usersGeneralIndex[state.gallery.addressMain];
  const exhibitor = {
    addressMain: state.gallery.addressMain,
    userName: usersGeneralExhibitor !== undefined ? usersGeneralExhibitor.userName : null,
    images: usersGeneralExhibitor !== undefined ? usersGeneralExhibitor.images : {},
  };

  const [ maybeItemPlacementNotSaved, setMaybeItemPlacementNotSaved ] = useState(false);
  useCallbackPrompt(state, dispatch, maybeItemPlacementNotSaved, words.yourSortOrderHasNotBeenSavedAreYouSureYouWantToLeaveThisScreen[state.language], null);

  let itemPlacementIndex = {
    exhibitToken: {},
    note: {},
  };
  let itemsSorted = [
    [],
  ];
  let replaceItemButton;
  let mainImage;
  let mainImageNumber;

  // useEffect( () => {
  //   devLog('Gallery useEffect3', state.gallery.addressMain);
  //   if (state.gallery.addressMain === undefined || state.gallery.addressMain === null || state.gallery.addressMain === '') {
  //     devLog('Gallery useEffect');
  //     navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
  //   }
  //   else {
  //     // スクリーン設定
  //     dispatch({ type: 'setState', key: 'screen', value: 'gallery' });
  //   }
  // });

  useEffect( () => {
    if (state.gallery.addressMain === undefined || state.gallery.addressMain === null || state.gallery.addressMain === '') {
      navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
    }
    else {
      // スクリーン設定
      dispatch({ type: 'setState', key: 'screen', value: 'gallery' });
    }

    // 出品物・ノート取得
    const func = async () => {
      /*
      // -- ユーザ情報取得
      const usersGeneral = await getUser(state, dispatch, 'all');
      devLog('usersGeneral', JSON.stringify(usersGeneral));
      */

      if (state.gallery.addressMain !== undefined && state.gallery.addressMain !== null && state.gallery.addressMain !== '') {

        dispatch({ type: 'setState', key: 'accessing', value: true });

        // -- 出品情報取得
        // -- getItemで、itemPlacementもリロードされる点に注意！

        const getExhibitPromise = getItem(state, dispatch, [state.gallery.addressMain])
        .then( items => {
          devLog('items', JSON.stringify(items));

          // -- アセット情報取得

          getAssetInfoByItems(state, dispatch, items);

          // -- モナカード情報取得
          const assetCommons = Object.keys(items.body).reduce( (acc, cur) => {
            devLog('cur', cur);
            devLog('item', JSON.stringify(items.body[cur].item));
            const assetCommons = items.body[cur].item.map( item => item.asset_longname === null ? item.asset : item.asset_longname );
            return acc.concat(assetCommons);
          }, []);

          getMonacard(state, dispatch, assetCommons);
        })

        // -- ノート情報取得

        let getNotePromise;

        if (state.editNote.loaded.popupDisplay[addressMain] !== true) {
          getNotePromise = getNotesAndUserResources({
            dispatch,
            addressMain,
            componentContainers: ['popupDisplay'],
            session: state.session,
            marginOfSessionTime: state.marginOfSessionTime,
            notes: state.notes,
          });
        }
        else {
          getNotePromise = Promise.resolve();
        }

        await Promise.all([getExhibitPromise, getNotePromise])
        .then( () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'popupDisplay', addressMain], value: true });
          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', addressMain], value: {} });
        })
        .catch( error => {
        });

        dispatch({ type: 'setState', key: 'accessing', value: false });

        // dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: state.getItem.addressMain });
      }
    };

    func();
  }, []);

  if ( state.gallery.addressMain === undefined || state.items[state.gallery.addressMain] === undefined || state.notes[addressMain] === undefined) {
    return (
      <div>
        <Header screen='gallery' />
      </div>
    );
  }

  // itemPlacement index作成

  for (let room = 0; room <= state.items[state.gallery.addressMain].itemPlacement.length - 1; room++) {
    for (const [index, item] of state.items[state.gallery.addressMain].itemPlacement[room].items.entries()) {
      itemPlacementIndex[item.itemType][item.no.toString()] = {
        room: room,
        index: index,
      }
    }
  }

  // item並べ替え

  for (const item of state.items[state.gallery.addressMain].item) {
    itemsSorted[itemPlacementIndex.exhibitToken[item.exhibitNo.toString()].room][itemPlacementIndex.exhibitToken[item.exhibitNo.toString()].index] = {
      itemType: 'exhibitToken',
      item: item,
    };
  }

  for (const noteNo of Object.keys(state.notes[addressMain])) {
    if (itemPlacementIndex.note[noteNo.toString()] !== undefined) {
      itemsSorted[itemPlacementIndex.note[noteNo.toString()].room][itemPlacementIndex.note[noteNo.toString()].index] = {
        itemType: 'note',
        item: state.notes[addressMain][noteNo],
      };
    }
  }

  const itemComponents = itemsSorted[0].map( itemTyped => {
    if (itemTyped.itemType === 'exhibitToken') {
      return (
        <Item
          item={itemTyped.item}
          index={itemPlacementIndex.exhibitToken[itemTyped.item.exhibitNo.toString()].index}
          exhibitor={exhibitor}
          stateSetterForChange={setMaybeItemPlacementNotSaved}
        />
      );
    }
    else if (itemTyped.itemType === 'note') {
      return (
        <PopupDisplay
          note={itemTyped.item}
          index={itemPlacementIndex.note[itemTyped.item.noteNo.toString()].index}
          stateSetterForChange={setMaybeItemPlacementNotSaved}
        />
      );
    }
    else {
      return null;
    }
  });

  if (
    state.session[state.gallery.addressMain] !== undefined &&
    state.session[state.gallery.addressMain].expirationOfSession > Date.now() + marginOfSessionTime &&
    state.items[state.gallery.addressMain].itemPlacement[0] !== undefined
  ) {
    replaceItemButton =
    <div>
      <button className='buttonMainColor widthMin12 height3 ' tabindex='0'
        onClick={ async () => {
          await handleClickReplaceItem(state, dispatch);
          setMaybeItemPlacementNotSaved(false);
        }}
      >
        {words.commitReplacement[state.language]}
      </button>
    </div>;
  }
  else {
    replaceItemButton = null;
  }

  // メインイメージ
  if (exhibitor.images.main === true) {
    if (exhibitor.images.mainNumber !== undefined) {
      mainImage = <img className='mainImage ' src={`https://${process.env.REACT_APP_MONACOTTO_USER_IMAGE}${exhibitor.addressMain}_main_${exhibitor.images.mainNumber.toString().padStart(4, '0')}.img`} alt='' />
      mainImageNumber = exhibitor.images.mainNumber;
    }
    else {
      mainImage = <img className='mainImage ' src={`https://${process.env.REACT_APP_MONACOTTO_USER_IMAGE}${exhibitor.addressMain}_main.img`} alt='' />
      mainImageNumber = 0;
    }
  }
  else {
    mainImage = null;
    mainImageNumber = 'default';
  }

  // Twitterボタン
  const urlParams = [`mainaddress=${exhibitor.addressMain}`];
  if (mainImageNumber !== 'default') {
    urlParams.push(`mainimageno=${mainImageNumber}`);
  }
  if (state.language !== 'japanese') {
    urlParams.push(`language=${state.language}`);
  }
  const urlParamsStr = urlParamsStringify(urlParams);
  const url = `https://${process.env.REACT_APP_MONACOTTO_EXTENSION_URL}redirect${urlParamsStr}`;
  const title = `もなこっと ${exhibitor.userName}のマイホームです。`
  const hashtags = ['monacotto', 'もなこっと'];

  // 新規ノート作成ボタン

  let createNoteButton;

  if (state.session[addressMain] !== undefined && state.session[addressMain].expirationOfSession > Date.now() + marginOfSessionTime) {
    createNoteButton =
    <button className='buttonMainColor widthMin12 height3 ' tabindex='0'
      onClick={ () => {
        const noteNoNew = state.privateInformation[addressMain].noteNo !== undefined ? state.privateInformation[addressMain].noteNo + 1 : 1

        const note = {
          addressMain: addressMain,
          noteNo: noteNoNew,
          visibility: 'public',       
          draft: {
            title: '',
            components: [],
            resourceIdMax: 0,
            popupDisplay: [],
            texts: {},
            images: {},
          },
          status: 'draft',
        };

        const itemPlacement0 = state.items[addressMain].itemPlacement[0] !== undefined
          ? state.items[addressMain].itemPlacement[0]
          : { items: [] };
        const items = [...itemPlacement0.items];
        items.push({ itemType: 'note', no: noteNoNew });

        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNoNew], value: note });
        dispatch({ type: 'setStateMultiLayers', keys: ['privateInformation', addressMain, 'noteNo'], value: noteNoNew });
        dispatch({ type: 'setStateMultiLayers', keys: ['items', addressMain, 'itemPlacement', 0, 'items'], value: items });

        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/note' : '/note', { state: { mode: 'insert', addressMain: addressMain, noteNo: noteNoNew } });
        handleClickSaveNote(state, dispatch, 'insert', addressMain, null, { note });
      }}
    >
      {words.createNewNote[state.language]}
    </button>;
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <Header screen='gallery' noteInfo={{ addressMain, screen: 'gallery' }} />
        <div className='flexColumn alignItemsCenter ' >
          <div className='flexRow justifyContentFlexStart widthMax' >
            <div className='margin1 '>
              { mainImage }
            </div>
            <div className='flexColumn justifyContentFlexStart width24 margin1'>
              <div className='flexRow justifyContentFlexStart font1p5 '>
                {usersGeneralExhibitor.userName}
              </div>
              <div className='flexRow justifyContentSpaceBetween '>
                {usersGeneralExhibitor.addressMain}
              </div>
              <div className='flexRow justifyContentSpaceBetween marginTopBottom1 preWrap'>
                {usersGeneralExhibitor.profileText}
              </div>
            </div>
            <div className='flexColumn justifyContentFlexStart margin1'>
              <div>
                {createNoteButton}
              </div>
              <div>
                {replaceItemButton}
              </div>
              <div>
                <ChangePublicationTypeButton addressMain={addressMain} />
              </div>
              <div className='marginTop1'>
                <TwitterShareButton
                  url={url}
                  title={title}
                  hashtags={hashtags}
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
              </div>
            </div>
          </div>
          {/*
          <button className='borderNone backgroundColorTransparent font2 cursor marginTop1'
                   onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['session', state.gallery.addressMain], value: { expirationOfSession: 0 } }) }
          >
            log out
          </button>
          */}
          <div className='flexRow justifyContentFlexStart widthMax'>
            {
              itemComponents
              // itemsSorted[0].map( item => <Item item={item} index={itemPlacementIndex.exhibitToken[item.exhibitNo.toString()].index} exhibitor={exhibitor} /> )
            }
          </div>
          {/* development */}
          {/*
            <div>
              { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
            </div>
          */}
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <Header screen='gallery' />
        <div className='flexColumn alignItemsCenter ' >
          <div className=''>
            <MainImage user={exhibitor} imageClass='mainImageSmallScreen' />
          </div>
          <div className='flexColumn justifyContentFlexStart width95vw '>
            <div className='flexRow justifyContentFlexStart widthMax breakWord font1p5 '>
              {usersGeneralExhibitor.userName}
            </div>
            <div className='flexRow justifyContentSpaceBetween widthMax breakAll '>
              {usersGeneralExhibitor.addressMain}
            </div>
            <div className='flexRow justifyContentSpaceBetween widthMax breakWord marginTopBottom1'>
              {usersGeneralExhibitor.profileText}
            </div>
          </div>
          <div className='flexColumn alignItemsCenter width95vw '>
            <div>
              {createNoteButton}
            </div>
            <div className='' >
              {replaceItemButton}
            </div>
            <div className='' >
              <ChangePublicationTypeButton addressMain={addressMain} />
            </div>
            <div className='marginTopBottom1 '>
              <TwitterShareButton
                url={url}
                title={title}
                hashtags={hashtags}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
            </div>
          </div>
          {/*
          <button className='borderNone backgroundColorTransparent font2 cursor marginTop1'
                   onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['session', state.gallery.addressMain], value: { expirationOfSession: 0 } }) }
          >
            log out
          </button>
          */}
          <div className='flexRow justifyContentSpaceAround'>
            {
              itemComponents
              // itemsSorted[0].map( item => <Item item={item} index={itemPlacementIndex.exhibitToken[item.exhibitNo.toString()].index} exhibitor={exhibitor} /> )
            }
          </div>
        </div>
      </div>
    </div>
  );
}



// NEW CARD
function NewCard(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  useEffect( () => {
    // 出品物取得
    const func = async () => {
      if (state.itemsNew.item === undefined) {
        dispatch({ type: 'setState', key: 'accessing', value: true });

        // -- アイテム情報取得
        await getItemNew(state, dispatch, 'new', 'itemsNew') // 待たなくてもよさそう。
        .then( items => {
          devLog('items', JSON.stringify(items));

          // -- アセット情報取得

          getAssetInfo(state, dispatch, items.body.item.map( item => item.asset ));

          // -- モナカード情報取得
          const assetCommons = items.body.item.map( item => item.asset_longname === null ? item.asset : item.asset_longname );
          getMonacard(state, dispatch, assetCommons);
        })

        dispatch({ type: 'setState', key: 'accessing', value: false });
      }
    };

    func();

    // スクリーン設定
    dispatch({ type: 'setState', key: 'screen', value: 'newCard' });
  }, []);


  return (
    <div className=''>
      {/* PC */}
      <div className="flexColumn visibleMiddleOrMore">
        <Header screen='newCard' />
        <div className='flexColumn alignItemsCenter ' >
          <div className='flexRow justifyContentFlexStart widthMax'>
            {
              state.itemsNew.item !== undefined ?
              state.itemsNew.item.map( item => <Item item={item} exhibitor={item.addressMain} /> )
              : null
            }
          </div>
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <Header screen='newCard' />
        <div className='flexColumn alignItemsCenter ' >
          <div className='flexRow justifyContentSpaceAround'>
            {
              state.itemsNew.item !== undefined ?
              state.itemsNew.item.map( item => <Item item={item} exhibitor={item.addressMain} /> )
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
}

// ALL CARD
function AllCard(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  useEffect( () => {
    // 出品物取得
    const func = async () => {
      if (state.itemsAll.item.length === 0) {
        dispatch({ type: 'setState', key: 'accessing', value: true });

        // -- アイテム情報取得
        await getItemNew(state, dispatch, 'all', 'itemsAll')
        .then( items => {
          devLog('items', JSON.stringify(items));

          // -- アセット情報取得

          getAssetInfo(state, dispatch, items.body.item.map( item => item.asset ));

          // -- モナカード情報取得
          const assetCommons = items.body.item.map( item => item.asset_longname === null ? item.asset : item.asset_longname );
          getMonacard(state, dispatch, assetCommons);
        })

        dispatch({ type: 'setState', key: 'accessing', value: false });
      }
    };

    func();

    // スクリーン設定
    dispatch({ type: 'setState', key: 'screen', value: 'allCard' });
  }, []);


  let items = state.itemsAll.item

  // 本命フィルタ
  items = state.tokenFilter.conditions.reduce( (acc, cur) =>
    acc.filter( item => {
      let attributesUnified = {};

      if (state.assetInfo[item.asset]?.asset_longname !== undefined && state.assetInfo[item.asset].asset_longname !== null) {
        attributesUnified.assetCommon = state.assetInfo[item.asset].asset_longname;
      }
      else {
        attributesUnified.assetCommon = item.asset;
      }

      if (state.assetInfo[item.asset] !== undefined) {
        attributesUnified.addressOwners = state.assetInfo[item.asset].owner;
        attributesUnified.lockStatus = state.assetInfo[item.asset].locked === true ? 'locked' : 'unlocked';
      }

      if (state.assetInfo[item.asset]?.description !== undefined && state.assetInfo[item.asset]?.description !== null && state.assetInfo[item.asset]?.description !== '' ) {
        try {
          const description = JSON.parse(state.assetInfo[item.asset].description);
          attributesUnified.monacardName = description.monacard.name;
          attributesUnified.monacardIssuerNames = description.monacard.owner;
          attributesUnified.monacardDescription = description.monacard.desc;
          attributesUnified.monacardTags = description.monacard.tag.split(',');
        }
        catch (err) {
          // モナカードのdescriptionじゃない。
        }
      }

      if (state.registeredCard[item.asset] !== undefined) {
        attributesUnified.monadom = 'registered';
      }
      else {
        attributesUnified.monadom = 'unregistered';
      }

      if (Object.keys(cur).some( key => cur[key].length >= 1 )) {
        return Object.keys(cur).some( key => {
          if (key === 'monacardName' || key === 'monacardDescription' || key === 'assetCommon') {
            return cur[key].some( condition => {
              return new RegExp(condition).test(attributesUnified[key]);
            });
          }
          // else if (key === 'assetCommon') {
          //   return cur[key].some( condition => {
          //     return new RegExp(condition).test(attributesUnified[key]);
          //   });
          // }
          else if (Array.isArray(attributesUnified[key])) {
            return attributesUnified[key].some( attribute => cur[key].includes(attribute) );
          }
          else { // scalar
            return cur[key].includes(attributesUnified[key]);
          }
        });
      }
      else {
        return true;
      }
    })
    , items
  );

  // トークン名でソート

  items = items.sort( (a, b) => {
    let aComp;
    let bComp;

    if (state.assetInfo[a.asset]?.asset_longname !== undefined && state.assetInfo[a.asset]?.asset_longname !== null) {
      aComp = state.assetInfo[a.asset].asset_longname; 
    }
    else {
      aComp = a.asset; 
    }

    if (state.assetInfo[b.asset]?.asset_longname !== undefined && state.assetInfo[b.asset]?.asset_longname !== null) {
      bComp = state.assetInfo[b.asset].asset_longname; 
    }
    else {
      bComp = b.asset; 
    }

    if (aComp < bComp) {
      return -1;
    }
    else if (aComp > bComp) {
      return 1;
    }
    else {
      return 0;
    }
  });


  return (
    <div className=''>
      {/* PC */}
      <div className="flexColumn visibleMiddleOrMore">
        <Header screen='allCard' />
        <div className='flexColumn alignItemsCenter ' >
          <div className='flexRow justifyContentFlexStart widthMax'>
            { items.map( item => <Item item={item} exhibitor={item.addressMain} /> ) }
          </div>
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <Header screen='allCard' />
        <div className='flexColumn alignItemsCenter ' >
          <div className='flexRow justifyContentSpaceAround'>
            { items.map( item => <Item item={item} exhibitor={item.addressMain} /> ) }
          </div>
        </div>
      </div>
    </div>
  );
}

// QR CODE SCANNER
function QrCodeScanner(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  // const [resultData, setResultData] = useState(undefined);
  const popupLayer = props.popupLayer;
  const callback = props.callback;
  const callbackType = props.callbackType;
  const options = props.options;
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  // const stopScanRef = useRef(false);
  devLog('QrCodeScanner rendered.');

  useEffect( () => {
    devLog('useEffect triggered.');
    // stopScanRef.current = false; // scanQrCode()のブレーキを外す。
    const abortController = new AbortController();
    const signal = abortController.signal;
    devLog('signal', signal);

    const constraints = {
      video: {
        facingMode: 'environment',
        width: { ideal: 300 },
        height: { ideal: 300 },
      },
    };

    // デバイスのカメラにアクセスする
    navigator.mediaDevices
    .getUserMedia(constraints)
    .then((stream) => {
      // デバイスのカメラにアクセスすることに成功したら、video要素にストリームをセットする
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
        devLog('signal2', signal);
        scanQrCode(signal);
      }
    })
    .catch((err) => console.error('Error accessing media devices:', err));

    const currentVideoRef = videoRef.current

    // コンポーネントがアンマウントされたら、カメラのストリームを停止する
    return () => {
      // stopScanRef.current = true; // scanQrCode()を止める。
      devLog('cleanup', signal);
      abortController.abort();

      if (currentVideoRef && currentVideoRef.srcObject) {
        const stream = currentVideoRef.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      }
    };
  }, []);

  const scanQrCode = (signal) => {
    devLog('scanQrCode called');
    if (signal.aborted) {
      devLog('Scanning stopped');
      return;
    }

    const canvas = canvasRef.current;
    const video = videoRef.current;

    if (canvas && video) {
      const ctx = canvas.getContext('2d');
      // canvas.width = video.videoWidth;
      // canvas.height = video.videoHeight;

      if (ctx) {
        // カメラの映像をcanvasに描画する
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        // QRコードをスキャンする
        const qrCodeData = jsQR(imageData.data, imageData.width, imageData.height);

        if (qrCodeData) {
          // スキャンされた内容を確認する
          // if (false) {
          //   setTimeout(scanQrCode, 100); // スキャンの頻度を制限
          //   return;
          // }

          // setResultData(qrCodeData.data)
          dispatch({ type: 'setStateMultiLayers', keys: ['qrCodeScanner', 'qrCode'], value: qrCodeData.data });
          dispatch({ type: 'setNotification', key: 'notification', value: 'scaned' });
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });

          if (callbackType === 'decryptMnemonic') {
            doSomethingWithEncryptedMnemonics(state, dispatch, [qrCodeData.data], callback, options);
          }
          else { // simpelCallback
            callback(qrCodeData.data);
          }

          return;
        }

        setTimeout(() => { scanQrCode(signal); }, 333);
      }
    }
  };

  // let scanner;

  // if (resultData === undefined) {
  //   scanner =
  //   <div className=''>
  //     <div className=''>
  //       <video ref={videoRef} autoPlay playsInline className='' />
  //       <canvas ref={canvasRef} width='300' height='300' className='' />
  //     </div>
  //   </div>;
  // }

  // let button;
  // 
  // if (resultData !== undefined) {
  //   button =
  //   <div className=''>
  //     <button>push</button>
  //   </div>
  // }


  return (
    <div className='flexColumn justifyContentCenter alignItemsCenter relative border'>
      <video ref={videoRef} autoPlay playsInline className='absoluteZero zM10' />
      <canvas ref={canvasRef} width='300' height='300' className='' />
    </div>
  );
}


// POPUP
function Popup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  const popup = state.popup[props.layer];

  const popupComponent = {
    // itemDetail: <ItemDetail popupLayer={props.layer} />,
    itemDetailMore: <ItemDetailMore popupLayer={props.layer} />,
    exhibitRecordDetailResume: <ExhibitRecordDetailResume popupLayer={props.layer} />,
    exhibitRecordDetailChange: <ExhibitRecordDetailChange popupLayer={props.layer} />,
    exhibitRecordDetailFinished: <ExhibitRecordDetailFinished popupLayer={props.layer} />,
    purchaseRecordDetail: <PurchaseRecordDetail popupLayer={props.layer} />,
    generalList: <GeneralList popupLayer={props.layer} />,
    generalItems: <GeneralItems popupLayer={props.layer} />,
    confirmationPopup: <ConfirmationPopup popupLayer={props.layer} />,
    sendMonaConfirmation: <SendMonaConfirmation popupLayer={props.layer} />,
    monadomInfo: <MonadomInfo popupLayer={props.layer} />,
    creatorInformation: <CreatorInformation popupLayer={props.layer} />,
    tokenFilterPopup: <TokenFilterPopup popupLayer={props.layer} />,
    loginPopup: <LoginPopup popupLayer={props.layer} />,
    userRegistrationPopup: <UserRegistrationPopup popupLayer={props.layer} />,
    // addComponentPopup: <AddComponentPopup popupLayer={props.layer} />,
    editPopupDisplayPopup: <EditPopupDisplayPopup popupLayer={props.layer} />,
    manageComponentPopup: <ManageComponentPopup popupLayer={props.layer} />,
    noteMenuSpPopup: <NoteMenuSpPopup popupLayer={props.layer} />,
    selectSessionPopup: <SelectSessionPopup popupLayer={props.layer} />,
    displayQrPopup: <DisplayQrPopup popupLayer={props.layer} />,
    displayWifPopup: <DisplayWifPopup popupLayer={props.layer} />,
    readMnemonicForRegistrationPopup: <ReadMnemonicForRegistrationPopup popupLayer={props.layer} />,
    readWifForRegistrationPopup: <ReadWifForRegistrationPopup popupLayer={props.layer} />,
    mnemonicInputPopup: <MnemonicInputPopup popupLayer={props.layer} />,
    wifInputPopup: <WifInputPopup popupLayer={props.layer} />,
    confirmMnemonicPopup: <ConfirmMnemonicPopup popupLayer={props.layer} />,
    registrationAndAgreementListPopup: <RegistrationAndAgreementListPopup popupLayer={props.layer} />,
    selectSubAddressPopup: <SelectSubAddressPopup popupLayer={props.layer} />,
    selectAddressFromKeypoolPopup: <SelectAddressFromKeypoolPopup popupLayer={props.layer} />,
    qrCodeScannerPopup: <QrCodeScannerPopup popupLayer={props.layer} />,
    selectSecretPopup: <SelectSecretPopup popupLayer={props.layer} />,
    qrCodeReaderPopup: <QrCodeReaderPopup popupLayer={props.layer} />,
    nativeAppKeyCardReaderPopup: <NativeAppKeyCardReaderPopup popupLayer={props.layer} />,
    addressHistoryPopup: <AddressHistoryPopup popupLayer={props.layer} />,
    termsAndConditionsPopup: <TermsAndConditionsPopup popupLayer={props.layer} />,
  };

  if (state.popup[props.layer].type === null) {
    return (
      <div className='invisible' />
    );
  }
  else if (// state.popup[props.layer].type === 'itemDetail' ||
           // state.popup[props.layer].type === 'itemDetailMore' ||
           // state.popup[props.layer].type === 'exhibitRecordDetailResume' ||
           // state.popup[props.layer].type === 'exhibitRecordDetailChange' ||
           // state.popup[props.layer].type === 'exhibitRecordDetailFinished' ||
           // state.popup[props.layer].type === 'purchaseRecordDetail' ||
           // state.popup[props.layer].type === 'generalList' ||
           // state.popup[props.layer].type === 'sendMonaConfirmation' ||
           state.popup[props.layer].type !== undefined && state.popup[props.layer].type !== null) {
    return (
      <div>
        {/* PC */}
        <div className="visibleMiddleOrMore">
          <div className={'popupBackgroundMultiLayer' + (popup.extendedClassesBackGround !== undefined ? ' ' + popup.extendedClassesBackGround : '')} style={{ '--popupLayer': props.layer }}>
            <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
              onClick={ () => handleClickClosePopup({ dispatch, popup, popupLayer: props.layer }) }
            />
            <div className='popupMultiLayer' style={{ '--popupLayer': props.layer }}>
              <button className='topRightClose focusEffect01' tabindex='0'
                onClick={ () => handleClickClosePopup({ dispatch, popup, popupLayer: props.layer }) } 
              >
                x
              </button>
              {popupComponent[state.popup[props.layer].type]}
            </div>
          </div>
        </div>
        {/* SP */}
        <div className="visibleSmallOrLess">
          <div className='popupBackgroundMultiLayer' style={{ '--popupLayer': props.layer }}>
            <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
              onClick={ () => handleClickClosePopup({ dispatch, popup, popupLayer: props.layer }) }
            />
            <div className='popupMultiLayerSmallScreen ' style={{ '--popupLayer': props.layer }}>
              <button className='topRightClose focusEffect01' tabindex='0'
                onClick={ () => handleClickClosePopup({ dispatch, popup, popupLayer: props.layer }) } 
              >
                x
              </button>
              {popupComponent[state.popup[props.layer].type]}
            </div>
          </div>
        </div>
      </div>
    );
  }
  else {
    return (
      <div className='' >
      </div>
    );
  }
}

// HANDLE CLICK CLOSE POPUP
// × や背景でポップアップを閉じる。結果を待っている処理があれば（body.reject）、閉じたこと（popupClosed）を知らせて、待ちを終わらせる
function handleClickClosePopup({ dispatch, popup, popupLayer }) {
  popup.body?.reject?.(new Error('popupClosed'));
  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
}

// SEND MONA CONFIRMATION
function SendMonaConfirmation(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const sendMonaDetail = state.popup[props.popupLayer].body;
  let transactionFee;
  let transactionFeeUpperBound;
  let transactionFeeSmallScreen;
  let transactionFeeUpperBoundSmallScreen;

  // transactionFee or transactionFeeUpperBound
  if (sendMonaDetail.transactionFee !== undefined) {
    transactionFee =
      <div className='boxMonacotto1 margin0p5 heightMin2'>
        <div className='widthMin15 marginSide1'>
          {words.transactionFee[state.language]}
        </div>
        <div className='widthMin25 marginSide1'>
        </div>
        <div className='widthMin15 marginSide1'>
          {(sendMonaDetail.transactionFee / 100000000) + ' MONA'}
        </div>
      </div>;

    transactionFeeUpperBound = null;

    transactionFeeSmallScreen =
      <div className='boxMonacotto1SmallScreen '>
        <div className=''>
          {words.transactionFee[state.language]}
        </div>
        <div className='breakAll paddingLeft1'>
        </div>
        <div className='paddingLeft1'>
          {(sendMonaDetail.transactionFee / 100000000) + ' MONA'}
        </div>
      </div>;

    transactionFeeUpperBoundSmallScreen = null;
  }
  else {
    transactionFee = null;

    transactionFeeUpperBound =
      <div className='boxMonacotto1 margin0p5 heightMin2'>
        <div className='widthMin15 marginSide1'>
          {words.transactionFeeUpperBound[state.language]}
        </div>
        <div className='widthMin25 marginSide1'>
        </div>
        <div className='widthMin15 marginSide1'>
          {(sendMonaDetail.transactionFeeUpperBound / 100000000) + ' MONA'}
        </div>
      </div>;

    transactionFeeSmallScreen = null;

    transactionFeeUpperBoundSmallScreen =
      <div className='boxMonacotto1SmallScreen '>
        <div className=''>
          {words.transactionFeeUpperBound[state.language]}
        </div>
        <div className='breakAll paddingLeft1'>
        </div>
        <div className='paddingLeft1'>
          {(sendMonaDetail.transactionFeeUpperBound / 100000000) + ' MONA'}
        </div>
      </div>;
  }

  // confirmation section

  let confirmationSection;

  if (sendMonaDetail.callbackOk !== undefined && sendMonaDetail.callbackCancel !== undefined) {
    confirmationSection =
    <div className='flexRow justifyContentCenter margin1 '>
      <button className='button2 margin1 ' onClick={ sendMonaDetail.callbackOk } >
        { sendMonaDetail.buttonFaceOk }
      </button>
      <button className='button2 margin1 ' onClick={ sendMonaDetail.callbackCancel } >
        { sendMonaDetail.buttonFaceCancel }
      </button>
    </div>
  }


  return (
    <div>
      {/* PC */}
      <div className='visibleLargeOrMore flexColumn'>
        <div className='marginTop0p5'>
          {words.confirmTheDetailsOfTheRemittance[state.language]}
        </div>
        <div className='boxMonacotto1 margin0p5 heightMin2'>
          <div className='widthMin15 marginSide1'>
            {words.exhibitorReceipts[state.language]}
          </div>
          <div className='widthMin25 marginSide1'>
            {sendMonaDetail.addressPayProceedsTo}
          </div>
          <div className='widthMin15 marginSide1'>
            {(sendMonaDetail.proceedsNetMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='boxMonacotto1 margin0p5 heightMin2'>
          <div className='widthMin15 marginSide1'>
            {words.royalty[state.language]}
          </div>
          <div className='widthMin25 marginSide1'>
            {sendMonaDetail.addressPayRoyaltyTo}
          </div>
          <div className='widthMin15 marginSide1'>
            {(sendMonaDetail.royaltyMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='boxMonacotto1 margin0p5 heightMin2'>
          <div className='widthMin15 marginSide1'>
            {words.serviceFee[state.language]}
          </div>
          <div className='widthMin25 marginSide1'>
            {sendMonaDetail.monacottoAddressMona}
          </div>
          <div className='widthMin15 marginSide1'>
            {(sendMonaDetail.feeMona / 100000000) + ' MONA'}
          </div>
        </div>
        { transactionFee }
        { transactionFeeUpperBound }
        { confirmationSection }
      </div>
      {/* SP */}
      <div className='visibleMiddleOrLess flexColumn'>
        <div className='marginTop0p5'>
          {words.confirmTheDetailsOfTheRemittance[state.language]}
        </div>
        <div className='boxMonacotto1SmallScreen '>
          <div className=''>
            {words.exhibitorReceipts[state.language]}
          </div>
          <div className='breakAll paddingLeft1'>
            {sendMonaDetail.addressPayProceedsTo}
          </div>
          <div className='paddingLeft1'>
            {(sendMonaDetail.proceedsNetMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='boxMonacotto1SmallScreen '>
          <div className=''>
            {words.royalty[state.language]}
          </div>
          <div className='breakAll paddingLeft1'>
            {sendMonaDetail.addressPayRoyaltyTo}
          </div>
          <div className='paddingLeft1'>
            {(sendMonaDetail.royaltyMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='boxMonacotto1SmallScreen '>
          <div className=''>
            {words.serviceFee[state.language]}
          </div>
          <div className='breakAll paddingLeft1'>
            {sendMonaDetail.monacottoAddressMona}
          </div>
          <div className='paddingLeft1'>
            {(sendMonaDetail.feeMona / 100000000) + ' MONA'}
          </div>
        </div>
        { transactionFeeSmallScreen }
        { transactionFeeUpperBoundSmallScreen }
        { confirmationSection }
      </div>
    </div>
  );
}

// GENERAL LIST
function GeneralList(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const body = state.popup[props.popupLayer].body;

  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { body.title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { body.options }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { body.title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { body.options }
        </div>
      </div>
    </div>
  );
}

// GENERAL ITEMS
function GeneralItems(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const body = state.popup[props.popupLayer].body;

  return (
    <div className='flexColumn alignItemsCenter'>
      { body }
    </div>
  );
}

// SESSION TITLE
function SessionTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div className='widthMax'>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { words.loggedInAddress[state.language] }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
        <div className='textCenter' >
          { words.loggedInAddress[state.language] }
        </div>
      </div>
    </div>
  );
}

// SESSION RECORD
function SessionRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = props.record;

  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { record.address }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
        <div className='textCenter' >
          { record.address }
        </div>
      </div>
    </div>
  );
}

// HOW TO USE
function HowToUse() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );

  if (state.language === 'japanese') {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore' >
          <Header screen='howToUse' />
          <div className='flexColumn alignItemsCenter '>
            <div className='width95vw marginTopBottom1 '>
              <div>
                1つのアドレスだけを使う<span className='margin0p5 font2'>もなこっとの一番簡単な使い方</span><br/>
              </div>
              {/*
                <div className='marginTop1'>
                  ※もなこっとは現在PCでの利用を推奨しています。スマホでは表示が乱れたり、一部機能が使えない箇所があります。
                </div>
              */}
            </div>
            <div className='flexColumn borderMonacotto width98vw marginTopBottom1 padding1'>
              <div className='font2'>
                モナカードを買う
              </div>
              <div className='flexRow justifyContentSpaceAround margin1'>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    1. Mpurseをインストールする
                  </div>
                  <div className='flexRow justifyContentCenter widthMax margin1' >
                    <img className='width14' src={imageManualMpurse10} />
                  </div>
                  <div>
                    もなこっとでは、モナコインのウォレットとしてMpurseを使います。Mpurseはブラウザ拡張型のアプリケーションで、Chrome, Firefoxに対応しています。
                    Mpurseのインストールについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      こちら
                    </button>
                    をご参照ください。<br/>
                    <br/>
                    ここでは、1つのアドレスを使った購入方法を説明しますので、Mpurseのアカウント(アドレス)の切替は行わないでください。
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    2. モナコインを準備する
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualMonachen} />
                  </div>
                  <div className='margin1'>
                    Mpurseのアドレスにモナコインを送金してください。暗号資産取引所でモナコインを入手することもできますが、もなちぇんを使えば、暗号資産取引所を使わずにモナコインを入手することができます。
                    もなちぇんについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}`);
                      } }>
                      こちら
                    </button>
                    をご参照ください。
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    3. ユーザー登録をする
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualPurchase03} />
                  </div>
                  <div>
                    設定画面で、「メインアドレス」の横のMpurseボタンをクリックしてアドレスを入力してください。「ユーザー名」を入力してください。利用規約、プライバシーポリシーを読んで、同意するボタンを押してください。「メインアドレスで署名して登録」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    4. モナカードを買う
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualPurchase04} />
                  </div>
                  <div>
                    「出かける」ボタンか、もなこっとロゴをクリックすると、マイホーム一覧が表示されます。マイホーム・メインイメージをクリックすると、マイホーム内に入り、出品商品が一覧表示されます。<br/>
                    買いたい商品をクリックし、「メインアドレス」「代金送金元アドレス」「カード受取アドレス」の横のMpurseボタンをクリックし、全部同じアドレスを入力してください。購入したい枚数を入力してください。「メインアドレスで署名する」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。署名に成功すると、「MONA送信」ボタンが表示されますので、クリックし、送金内容を確認のうえ、Mpurseの「送信」ボタンをクリックしてください。数分待つと、モナカードがMpurseのモナコインアドレスに送信されます。<span className='backgroundColorRed'>2時間以内にモナコインの送金を行わないと期限切れとなり、購入はキャンセルとなります。</span>
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    5. 買ったモナカードを確認する
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualPurchase05} />
                  </div>
                  <div>
                    送信されたモナカードを確認するにはMpurseエクステが便利です。
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://mpurse-extension.komikikaku.com/');
                      } }>
                      ここ
                    </button>
                    にアクセスし、Mpurseを接続すると、保有しているモナカードが表示されます。<img className='size1p7x1p7' src={imageManualPurchaseImageButton} />ボタンを押すと画像が表示されます。
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn borderMonacotto width98vw marginTopBottom1 padding1'>
              <div className='font2'>
                モナカードを売る
              </div>
              <div className='flexRow justifyContentSpaceAround margin1'>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    1. Mpurseをインストールする
                  </div>
                  <div className='flexRow justifyContentCenter widthMax margin1' >
                    <img className='width14' src={imageManualMpurse10} />
                  </div>
                  <div>
                    もなこっとでは、モナコインのウォレットとしてMpurseを使います。Mpurseはブラウザ拡張型のアプリケーションで、Chrome, Firefoxに対応しています。
                    Mpurseのインストールについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      こちら
                    </button>
                    をご参照ください。<br/>
                    <br/>
                    ここでは、1つのアドレスを使った販売方法を説明しますので、Mpurseのアカウント(アドレス)の切替は行わないでください。
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    2. モナコインを準備する
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualMonachen} />
                  </div>
                  <div className='margin1'>
                    モナカードを出品するのに、ごく少額のモナコインが必要になります。<br/>
                    <br/>
                    Mpurseのアドレスにモナコインを送金してください。暗号資産取引所でモナコインを入手することもできますが、もなちぇんを使えば、暗号資産取引所を使わずにモナコインを入手することができます。
                    もなちぇんについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}`);
                      } }>
                      こちら
                    </button>
                    をご参照ください。
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    3. モナカードを準備する
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit03} />
                  </div>
                  <div>
                    Mpurseのアドレスに出品するモナカードを送信してください。<br/>
                    <br/>
                    自身でモナカードを発行する場合は、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://mpurse-extension.komikikaku.com/');
                      } }>
                      Mpurseエクステ
                    </button>
                    が便利です。Mpurseエクステは、超高機能総合エンタテイメントウォレット「モナパレット」の機能を、Mpurseで使えるようにしたものです。使い方は、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://opaque-toast-7ea.notion.site/fe5a2c309f3a495fa7a3399549cfe50c');
                      } }>
                      こちら
                    </button>
                    のドキュメントなどを参考にしてください。(ネットで「モナパレット」「モナカード」などのキーワードで検索すると他にも参考になる記事が出てくると思います。)
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    4. ユーザー登録をする
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit04} />
                  </div>
                  <div>
                    設定画面で、「メインアドレス」の横のMpurseボタンをクリックしてアドレスを入力してください。「ユーザー名」を入力してください。「マイホームあり」を選択してください。(マイホームはモナカードを出品するスペースのことです。)メインイメージ(マイホームの画像)をドラッグ＆ドロップしてください。プロフィールテキストを入力してください。利用規約、プライバシーポリシーを読んで、それぞれ同意するボタンを押してください。「メインアドレスで署名して登録」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    5. モナカードを出品する
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit05} />
                  </div>
                  <div>
                    出品画面で、「メインアドレス」「カード送信元アドレス」「売上受取アドレス」の横のMpurseボタンをクリックし、全部同じアドレスを入力してください。出品したいモナカードのトークン名、枚数、単価を入力してください。「メインアドレスで署名する」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。署名に成功すると、「カード送信」ボタンが表示されますので、クリックし、送信内容を確認のうえ、Mpurseの「送信」ボタンをクリックしてください。数分待つと、マイホーム画面に出品したモナカードが表示されます。<span className='backgroundColorRed'>2時間以内にモナカードの送金を行わないと期限切れとなり、出品はキャンセルとなります。</span>
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    6. 売上を確認する
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit06} />
                  </div>
                  <div>
                    出品したモナカードが売れると、マイホーム上のモナカードの在庫が減ります。しばらくすると、Mpurseのアドレスに売上が送られます。Mpurseのアドレスの残高を確認してみてください。
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn borderMonacotto margin1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
                } }>
                ガイドラインもご一読ください。
              </button>
            </div>
            <div className='flexColumn borderMonacotto margin1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouseadvanced' : '/howtouseadvanced'); 
                } }>
                もっと使いこなしてみたい人はこちら！（FAQ）
              </button>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess flexColumn alignItemsCenter ' >
          <Header screen='howToUse' />
          <div className='flexColumn alignItemsCenter '>
            <div className='width93vw marginTopBottom1 '>
              <div>
                1つのアドレスだけを使う<br/>
                <span className='font2'>もなこっとの一番簡単な使い方</span><br/>
              </div>
              <div className='marginTop1'>
                {/*
                  ※もなこっとは現在PCでの利用を推奨しています。スマホでは表示が乱れたり、一部機能が使えない箇所があります。<br/>
                */}
                ※スクリーンショットは、一部PCのものを使用しています。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter borderMonacotto width96vw marginTopBottom1 '>
              <div className='font2 width93vw'>
                モナカードを買う
              </div>
              <div className='flexColumn alignItemsCenter widthMax '>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1 '>
                  <div className='widthMax'>
                    1. Mpurseをインストールする
                  </div>
                  <div className='marginTopBottom1' >
                    <img className='width60vw' src={imageManualMpurseSp05} />
                  </div>
                  <div className='widthMax breakAll'>
                    もなこっとでは、モナコインのウォレットとしてMpurseを使います。スマホではMpurseアプリを利用するのが一般的ですが、Firefoxに対応したブラウザ拡張型のアプリケーションもあります。
                    Mpurseのインストールについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      こちら
                    </button>
                    をご参照ください。<br/>
                    <br/>
                    ここでは、1つのアドレスを使った購入方法を説明しますので、Mpurseのアカウント(アドレス)の切替は行わないでください。
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    2. モナコインを準備する
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualMonachen} />
                  </div>
                  <div className='widthMax breakAll'>
                    Mpurseのアドレスにモナコインを送金してください。暗号資産取引所でモナコインを入手することもできますが、もなちぇんを使えば、暗号資産取引所を使わずにモナコインを入手することができます。
                    もなちぇんについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}`);
                      } }>
                      こちら
                    </button>
                    をご参照ください。
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    3. ユーザー登録をする
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualPurchase03} />
                  </div>
                  <div className='widthMax breakAll'>
                    設定画面で、「メインアドレス」の下のMpurseボタンをクリックしてアドレスを入力してください。「ユーザー名」を入力してください。利用規約、プライバシーポリシーを読んで、同意するボタンを押してください。「メインアドレスで署名して登録」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    4. モナカードを買う
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualPurchase04} />
                  </div>
                  <div className='widthMax breakAll'>
                    「出かける」ボタンか、もなこっとロゴをクリックすると、マイホーム一覧が表示されます。マイホーム・メインイメージをクリックすると、マイホーム内に入り、出品商品が一覧表示されます。<br/>
                    買いたい商品をクリックし、「メインアドレス」「代金送金元アドレス」「カード受取アドレス」の下のMpurseボタンをクリックし、全部同じアドレスを入力してください。購入したい枚数を入力してください。「メインアドレスで署名する」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。署名に成功すると、「MONA送信内容確認」ボタンと「MONA送信」ボタンが表示されますので、クリックし、送金内容を確認のうえ、Mpurseの「送信」ボタンをクリックしてください。数分待つと、モナカードがMpurseのモナコインアドレスに送信されます。<span className='backgroundColorRed'>2時間以内にモナコインの送金を行わないと期限切れとなり、購入はキャンセルとなります。</span>
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    5. 買ったモナカードを確認する
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp01} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp02} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp03} />
                  </div>
                  {/*
                    <div className='marginTopBottom1'>
                      <img className='width90vw' src={imageManualPurchase05} />
                    </div>
                  */}
                  <div className='widthMax breakAll'>
                    送信されたモナカードを確認するにはMpurseエクステが便利です。
                    Mpurseアプリのメニューからブラウザを選び、Mpurseエクステをクリックすると、保有しているモナカードが表示されます。<img className='size1p7x1p7' src={imageManualPurchaseImageButton} />ボタンを押すと画像が表示されます。
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn alignItemsCenter borderMonacotto width96vw marginTopBottom1 '>
              <div className='font2 width93vw'>
                モナカードを売る
              </div>
              <div className='flexColumn alignItemsCenter widthMax'>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    1. Mpurseをインストールする
                  </div>
                  <div className='marginTopBottom1' >
                    <img className='width60vw' src={imageManualMpurseSp05} />
                  </div>
                  <div className='widthMax breakAll ' >
                    もなこっとでは、モナコインのウォレットとしてMpurseを使います。スマホではMpurseアプリを利用するのが一般的ですが、Firefoxに対応したブラウザ拡張型のアプリケーションもあります。
                    Mpurseのインストールについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      こちら
                    </button>
                    をご参照ください。<br/>
                    <br/>
                    ここでは、1つのアドレスを使った販売方法を説明しますので、Mpurseのアカウント(アドレス)の切替は行わないでください。
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    2. モナコインを準備する
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualMonachen} />
                  </div>
                  <div className='widthMax breakAll'>
                    モナカードを出品するのに、ごく少額のモナコインが必要になります。<br/>
                    <br/>
                    Mpurseのアドレスにモナコインを送金してください。暗号資産取引所でモナコインを入手することもできますが、もなちぇんを使えば、暗号資産取引所を使わずにモナコインを入手することができます。
                    もなちぇんについては、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}`);
                      } }>
                      こちら
                    </button>
                    をご参照ください。
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    3. モナカードを準備する
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp01} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp02} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualExhibitSP01} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualExhibitSP02} />
                  </div>
                  <div className='widthMax breakAll' >
                    Mpurseのアドレスに出品するモナカードを送信してください。<br/>
                    <br/>
                    自身でモナカードを発行する場合は、Mpurseエクステが便利です。Mpurseアプリのメニューからブラウザを選び、Mpurseエクステをクリックしてください。
                    Mpurseエクステは、超高機能総合エンタテイメントウォレット「モナパレット」の機能を、Mpurseで使えるようにしたものです。詳しい使い方は、
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://opaque-toast-7ea.notion.site/fe5a2c309f3a495fa7a3399549cfe50c');
                      } }>
                      こちら
                    </button>
                    のドキュメントなどを参考にしてください。(ネットで「モナパレット」「モナカード」などのキーワードで検索すると他にも参考になる記事が出てくると思います。)
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    4. ユーザー登録をする
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualExhibit04} />
                  </div>
                  <div className='widthMax breakAll' >
                    設定画面で、「メインアドレス」の下のMpurseボタンをクリックしてアドレスを入力してください。「ユーザー名」を入力してください。「マイホームあり」を選択してください。(マイホームはモナカードを出品するスペースのことです。)メインイメージ(マイホームの画像)をドラッグ＆ドロップしてください。プロフィールテキストを入力してください。利用規約、プライバシーポリシーを読んで、同意するボタンを押してください。「メインアドレスで署名して登録」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    5. モナカードを出品する
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualExhibit05} />
                  </div>
                  <div className='widthMax breakAll' >
                    出品画面で、「メインアドレス」「カード送信元アドレス」「売上受取アドレス」の下のMpurseボタンをクリックし、全部同じアドレスを入力してください。出品したいモナカードのトークン名、枚数、単価を入力してください。「メインアドレスで署名する」ボタンをクリックするとMpurseがポップアップしますので、署名ボタンをクリックしてください。署名に成功すると、「カード送信」ボタンが表示されますので、クリックし、送信内容を確認のうえ、Mpurseの「送信」ボタンをクリックしてください。数分待つと、マイホーム画面に出品したモナカードが表示されます。<span className='backgroundColorRed'>2時間以内にモナカードの送金を行わないと期限切れとなり、出品はキャンセルとなります。</span>
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    6. 売上を確認する
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualExhibitSP03} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualExhibit06} />
                  </div>
                  <div className='widthMax breakAll' >
                    出品したモナカードが売れると、マイホーム上のモナカードの在庫が減ります。しばらくすると、Mpurseのアドレスに売上が送られます。Mpurseアプリのメニューからウォレットを選び、Mpurseのアドレスの残高を確認してみてください。
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn borderMonacotto width90vw marginTopBottom1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
                } }>
                ガイドラインもご一読ください。
              </button>
            </div>
            <div className='flexColumn borderMonacotto width90vw marginTopBottom1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouseadvanced' : '/howtouseadvanced'); 
                } }>
                もっと使いこなしてみたい人はこちら！（FAQ）
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  else // english
  {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore' >
          <Header screen='howToUse' />
          <div className='flexColumn alignItemsCenter'>
            <div className='width95vw marginTopBottom1 marginSide2'>
              <div>
                <span className='margin0p5 font2'>The easiest way to use monacotto</span>using only one address<br/>
              </div>
              <div className='marginTop1'>
                *We currently recommend using monacotto on a PC. Some parts of the site may not display properly or some functions may not work on smartphones.
              </div>
            </div>
            <div className='flexColumn borderMonacotto width98vw marginTopBottom1 padding1'>
              <div className='font2'>
                Buy Monacards
              </div>
              <div className='flexRow justifyContentSpaceAround margin1'>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    1. Install Mpurse
                  </div>
                  <div className='flexRow justifyContentCenter widthMax margin1' >
                    <img className='width14' src={imageManualMpurse10} />
                  </div>
                  <div>
                    Monacotto uses Mpurse as a wallet for Monacoin. Mpurse is a browser extension application and supports Chrome and Firefox. For information on installing Mpurse, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      here
                    </button>
                    .<br/>
                    <br/>
                    Please do not switch Mpurse accounts (addresses), as this section explains how to make purchases using a single address.
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    2. Prepare Monacoin
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualMonachen} />
                  </div>
                  <div className='margin1'>
                    Send Monacoin to your Mpurse address. You can also obtain Monacoin on crypto asset exchanges, but with monachen, you can obtain Monacoin without using a crypto asset exchange.
                    For more information about monachen, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}?language=${state.language}`);
                      } }>
                      here
                    </button>
                    .
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    3. Register as a user
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualPurchase03} />
                  </div>
                  <div>
                    On the setup screen, click the Mpurse button next to "main address" to enter the address. Enter your "user name". Read the terms of conditions and Privacy Policy and click the Accept button for each. Click the "sign by main address to register" button and Mpurse will pop up, then click the Sign button.
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    4. Buy Monacards
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualPurchase04} />
                  </div>
                  <div>
                    Click the "go out" button or the monacotto logo to display the My Home list. Click on a My Home main image to enter a My Home and view a list of items for sale.<br/>
                    Click on the item you want to buy, click on the Mpurse button next to "main address," "address you pay from" and "address you receive cards in" to enter the same address for all of them. Enter the number of cards you want to buy. Click the "{words.signByMainAddress[state.language]}" button and Mpurse will pop up, then click the Sign button. If the signature is successful, you will see the "{words.sendMona[state.language]}" button, click it, confirm the remittance details, and then click "Send" button on Mpurse. Wait a few minutes and the Monacards will be sent to your Monacoin address in Mpurse.<span className='backgroundColorRed'>Failure to remit Monacoin within 2 hours will result in the expiration time and the purchase will be canceled.</span>
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    5. View the Monacards you bought
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualPurchase05} />
                  </div>
                  <div>
                    Mpurse extension is useful to check the monacards sent. Once you access 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://mpurse-extension.komikikaku.com/');
                      } }>
                      here 
                    </button>
                    and connect your Mpurse, you will see the monacards you are holding. Press the <img className='size1p7x1p7' src={imageManualPurchaseImageButton} /> button to view the images.
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn borderMonacotto width98vw marginTopBottom1 padding1'>
              <div className='font2'>
                Sell Monacards
              </div>
              <div className='flexRow justifyContentSpaceAround margin1'>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    1. Install Mpurse
                  </div>
                  <div className='flexRow justifyContentCenter widthMax margin1' >
                    <img className='width14' src={imageManualMpurse10} />
                  </div>
                  <div>
                    Monacotto uses Mpurse as a wallet for Monacoin. Mpurse is a browser extension application and supports Chrome and Firefox. For information on installing Mpurse, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      here
                    </button>
                    .<br/>
                    <br/>
                    Please do not switch Mpurse accounts (addresses), as this section explains how to sell Monacards using a single address.
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    2. Prepare Monacoin
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualMonachen} />
                  </div>
                  <div className='margin1'>
                    A very small amount of Monacoin is required to exhibit a Monacard.<br/>
                    <br/>
                    Send Monacoin to your Mpurse address. You can also obtain Monacoin on crypto asset exchanges, but with monachen, you can obtain Monacoin without using a crypto asset exchange.
                    For more information about monachen, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}?language=${state.language}`);
                      } }>
                      here
                    </button>
                    .
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    3. Prepare Monacards
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit03} />
                  </div>
                  <div>
                    Send the monacard you want to exhibit to your Mpurse address.<br/>
                    <br/>
                    If you want to issue your own Monacards, 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://mpurse-extension.komikikaku.com/');
                      } }>
                      Mpurse extension
                    </button>
                    is useful. With Mpurse extension, you can use features of monapalette, an ultra-functional general entertainment wallet. Please refer to 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://opaque-toast-7ea.notion.site/fe5a2c309f3a495fa7a3399549cfe50c');
                      } }>
                      this
                    </button>
                     document(Japanese) and others for how to use it. (You may find other helpful articles by searching the Internet for keywords such as "monapalette" and "Monacard.")
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    4. Register as a user
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit04} />
                  </div>
                  <div>
                    On the setup screen, click the Mpurse button next to "main address" to enter the address. Enter your "{words.userName[state.language]}." Select "{words.haveMyHome[state.language]}." (My Home is the space where you will display your Monacards.) Drag and drop the main image (My Home image). Enter your profile text. Read the terms of conditions and Privacy Policy and click the Accept button for each. Click the "sign by main address to register" button and Mpurse will pop up, then click the Sign button.
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    5. Exhibit Monacards
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit05} />
                  </div>
                  <div>
                    On the exhibit screen, click the Mpurse button next to "{words.addressMain[state.language]}," "{words.addressCardFrom[state.language]}" and "{words.addressPayProceedsTo[state.language]}" to enter the same address for all of them. Enter the token name, the number of cards, and the unit price of the Monacards you want to sell. Click the "{words.signByMainAddress[state.language]}" button and Mpurse will pop up, then click the Sign button. If the signature is successful, the "{words.sendCards[state.language]}" button will appear. Click it, confirm the details of the sending, and then click "Send" button on Mpurse. After waiting a few minutes, the exhibited Monacards will appear on your My Home screen. 2 hours are required to remit the mona card or it will expire and the transaction will be canceled. <span className='backgroundColorRed'>Failure to send Monacards within 2 hours will result in the expiration time and the exhibit will be canceled.</span>
                  </div>
                </div>
                <div className='flexColumn width35 margin1'>
                  <div className=''>
                    6. Check proceeds
                  </div>
                  <div className='margin1'>
                    <img className='width35' src={imageManualExhibit06} />
                  </div>
                  <div>
                    When the Monacards you have exhibited are sold, the stock of the Monacards will be reduced in your My Home. After a while, the proceeds will be sent to your Mpurse address; check the balance in your Mpurse address.
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn borderMonacotto margin1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
                } }>
                Please also read the guidelines. (Japanese)
              </button>
            </div>
            <div className='flexColumn borderMonacotto margin1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouseadvanced' : '/howtouseadvanced'); 
                } }>
                If you want to get more use out of it, click here!(FAQ)
              </button>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess flexColumn alignItemsCenter' >
          <Header screen='howToUse' />
          <div className='flexColumn alignItemsCenter'>
            <div className='width93vw marginTopBottom1 '>
              <div>
                <span className='font2'>The easiest way to use monacotto</span> using only one address<br/>
              </div>
              <div className='marginTop1'>
                *We currently recommend using monacotto on a PC. Some parts of the site may not display properly or some functions may not work on smartphones.<br/>
                *Some of the screenshots are from a PC.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter borderMonacotto width96vw marginTopBottom1 '>
              <div className='font2 width93vw'>
                Buy Monacards
              </div>
              <div className='flexColumn alignItemsCenter widthMax'>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    1. Install Mpurse
                  </div>
                  <div className='marginTopBottom1' >
                    <img className='width60vw' src={imageManualMpurseSp05} />
                  </div>
                  <div className='widthMax breakAll' >
                    Monacotto uses Mpurse as a wallet for Monacoin. For smartphones, the native application of Mpurse is the most common, but there is also a browser extension application for Firefox. For information on installing Mpurse, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      here
                    </button>
                    .<br/>
                    <br/>
                    Please do not switch Mpurse accounts (addresses), as this section explains how to make purchases using a single address.
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    2. Prepare Monacoin
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualMonachen} />
                  </div>
                  <div className='widthMax breakAll'>
                    Send Monacoin to your Mpurse address. You can also obtain Monacoin on crypto asset exchanges, but with monachen, you can obtain Monacoin without using a crypto asset exchange.
                    For more information about monachen, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}?language=${state.language}`);
                      } }>
                      here
                    </button>
                    .
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    3. Register as a user
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualPurchase03} />
                  </div>
                  <div className='widthMax breakAll'>
                    On the setup screen, click the Mpurse button below "main address" to enter the address. Enter your "user name". Read the terms of conditions and Privacy Policy and click the Accept button. Click the "sign by main address to register" button and Mpurse will pop up, then click the Sign button.
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    4. Buy Monacards
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualPurchase04} />
                  </div>
                  <div className='widthMax breakAll'>
                    Click the "go out" button or the monacotto logo to display the My Home list. Click on a My Home main image to enter a My Home and view a list of items for sale.<br/>
                    Click on the item you want to buy, click on the Mpurse buttons below "main address," "address you pay from" and "address you receive cards in" to enter the same address for all of them. Enter the number of cards you want to buy. Click the "{words.signByMainAddress[state.language]}" button and Mpurse will pop up, then click the Sign button. If the signature is successful, you will see the "{words.confirmTheDetailsOfSendingMona[state.language]}" button and "{words.sendMona[state.language]}" button, click them, confirm the remittance details, and then click "Send" button on Mpurse. Wait a few minutes and the Monacards will be sent to your Monacoin address in Mpurse.<span className='backgroundColorRed'>Failure to remit Monacoin within 2 hours will result in the expiration time and the purchase will be canceled.</span>
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    5. View the Monacards you bought
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp01} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp02} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp03} />
                  </div>
                  <div className='widthMax breakAll'>
                    Mpurse extension is useful to check the monacards sent. Select "Browser" from the Mpurse application menu and click on "Mpurse Extension", then you will see the Monacards you are holding.
                    Press the <img className='size1p7x1p7' src={imageManualPurchaseImageButton} /> button to view the images.
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn alignItemsCenter borderMonacotto width96vw marginTopBottom1 '>
              <div className='font2 width93vw'>
                Sell Monacards
              </div>
              <div className='flexColumn alignItemsCenter widthMax'>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    1. Install Mpurse
                  </div>
                  <div className='marginTopBottom1' >
                    <img className='width60vw' src={imageManualMpurseSp05} />
                  </div>
                  <div className='widthMax breakAll'>
                    Monacotto uses Mpurse as a wallet for Monacoin. For smartphones, the native application of Mpurse is the most common, but there is also a browser extension application for Firefox. For information on installing Mpurse, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtousempurse' : '/howtousempurse'); 
                      } }>
                      here
                    </button>
                    .<br/>
                    <br/>
                    Please do not switch Mpurse accounts (addresses), as this section explains how to sell Monacards using a single address.
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    2. Prepare Monacoin
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualMonachen} />
                  </div>
                  <div className='widthMax breakAll'>
                    A very small amount of Monacoin is required to exhibit a Monacard.<br/>
                    <br/>
                    Send Monacoin to your Mpurse address. You can also obtain Monacoin on crypto asset exchanges, but with monachen, you can obtain Monacoin without using a crypto asset exchange.
                    For more information about monachen, please click 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}?language=${state.language}`);
                      } }>
                      here
                    </button>
                    .
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    3. Prepare Monacards
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp01} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualPurchaseSp02} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualExhibitSP01} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualExhibitSP02} />
                  </div>
                  <div className='widthMax breakAll'>
                    Send the monacard you want to exhibit to your Mpurse address.<br/>
                    <br/>
                    If you want to issue your own Monacards, Mpurse extension is useful. Select "Browser" from the Mpurse application menu and click on "Mpurse Extension".
                    With Mpurse extension, you can use features of monapalette, an ultra-functional general entertainment wallet. Please refer to 
                    <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                      onClick={ () => {
                        window.open('https://opaque-toast-7ea.notion.site/fe5a2c309f3a495fa7a3399549cfe50c');
                      } }>
                      this
                    </button>
                     document(Japanese) and others for how to use it. (You may find other helpful articles by searching the Internet for keywords such as "monapalette" and "Monacard.")
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    4. Register as a user
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualExhibit04} />
                  </div>
                  <div className='widthMax breakAll'>
                    On the setup screen, click the Mpurse button below "main address" to enter the address. Enter your "{words.userName[state.language]}." Select "{words.haveMyHome[state.language]}." (My Home is the space where you will display your Monacards.) Drag and drop the main image (My Home image). Enter your profile text. Read the terms of conditions and Privacy Policy and click the Accept button. Click the "sign by main address to register" button and Mpurse will pop up, then click the Sign button.
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    5. Exhibit Monacards
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualExhibit05} />
                  </div>
                  <div className='widthMax breakAll'>
                    On the exhibit screen, click the Mpurse buttons below "{words.addressMain[state.language]}," "{words.addressCardFrom[state.language]}" and "{words.addressPayProceedsTo[state.language]}" to enter the same address for all of them. Enter the token name, the number of cards, and the unit price of the Monacards you want to sell. Click the "{words.signByMainAddress[state.language]}" button and Mpurse will pop up, then click the Sign button. If the signature is successful, the "{words.sendCards[state.language]}" button will appear. Click it, confirm the details of the sending, and then click "Send" button on Mpurse. After waiting a few minutes, the exhibited Monacards will appear on your My Home screen. 2 hours are required to remit the mona card or it will expire and the transaction will be canceled. <span className='backgroundColorRed'>Failure to send Monacards within 2 hours will result in the expiration time and the exhibit will be canceled.</span>
                  </div>
                </div>
                <div className='flexColumn alignItemsCenter width93vw marginTopBottom1'>
                  <div className='widthMax'>
                    6. Check proceeds
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width60vw' src={imageManualExhibitSP03} />
                  </div>
                  <div className='marginTopBottom1'>
                    <img className='width90vw' src={imageManualExhibit06} />
                  </div>
                  <div className='widthMax breakAll'>
                    When the Monacards you have exhibited are sold, the stock of the Monacards will be reduced in your My Home. After a while, the proceeds will be sent to your Mpurse address; select "Wallet" from the Mpurse application menu and check the balance in your Mpurse address.
                  </div>
                </div>
              </div>
            </div>
            <div className='flexColumn borderMonacotto mwidth90vw arginTopBottom1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
                } }>
                Please also read the guidelines. (Japanese)
              </button>
            </div>
            <div className='flexColumn borderMonacotto width90vw marginTopBottom1 padding1'>
              <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                onClick={ () => {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouseadvanced' : '/howtouseadvanced'); 
                } }>
                If you want to get more use out of it, click here!(FAQ)
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// HOW TO USE ADVANCED  
function HowToUseAdvanced() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );

  useEffect( () => {
    window.scrollTo(0, 0);
  }, []);

  if (state.language === 'japanese') {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore' >
          <Header screen='howToUseAdvanced' />
          <div className='flexColumn alignItemsCenter'>
            <div className='widthMax marginTopBottom1 marginSide2'>
              <div className='font2'>
                もなこっとの一歩進んだ使い方
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                購入時に、メインアドレスとは異なるアドレスからモナコインを送る
              </div>
              <div className='margin1'>
                「代金送金元アドレス」にモナコインの送り元アドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は、
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・「メインアドレスで署名」ボタンをクリック(Mpurseのアドレスは、メインアドレスに設定してください。) → Mpurseで署名
                   </div>
                   <div>
                     ・「代金送金元アドレスで署名」ボタンをクリック(Mpurseのアドレスは、代金送金元アドレスに設定してください。) → Mpurseで署名<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>メインアドレスで署名してから30分以内に行わないと期限切れとなり、購入はキャンセルとなります。</span>
                     </div>
                   </div>
                   <div>
                     ・「MONA送信」ボタンをクリック(Mpurseのアドレスは、代金送金元アドレスに設定してください。)
                   </div>
                   <div>
                     ・送金内容を確認のうえ、Mpurseの「送信」ボタンをクリック<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>代金送金元アドレスで署名してから2時間以内に行わないと期限切れとなり、購入はキャンセルとなります。</span>
                     </div>
                   </div>
                 </div>
                 という流れになります。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                購入時に、メインアドレスとは異なるアドレスでモナカードを受け取る
              </div>
              <div className='margin1'>
                「カード受取アドレス」にモナカードを受け取りたいアドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は変わりません。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品時に、メインアドレスとは異なるアドレスからモナカードを送る
              </div>
              <div className='margin1'>
                「カード送信元アドレス」にモナカードの送り元アドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は、
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・「メインアドレスで署名」ボタンをクリック(Mpurseのアドレスは、メインアドレスに設定してください。) → Mpurseで署名
                   </div>
                   <div>
                     ・「カード送信元アドレスで署名」ボタンをクリック(Mpurseのアドレスは、カード送信元アドレスに設定してください。) → Mpurseで署名<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed marginLeft1'>メインアドレスで署名してから30分以内に行わないと期限切れとなり、出品はキャンセルとなります。</span>
                     </div>
                   </div>
                   <div>
                     ・「カード送信」ボタンをクリック(Mpurseのアドレスは、カード送信元アドレスに設定してください。)
                   </div>
                   <div>
                     ・送信内容を確認のうえ、Mpurseの「送信」ボタンをクリック<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed marginLeft1'>カード送信元アドレスで署名してから2時間以内に行わないと期限切れとなり、出品はキャンセルとなります。</span>
                     </div>
                   </div>
                 </div>
                 という流れになります。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品時に、メインアドレスとは異なるアドレスで売上を受け取る設定をする
              </div>
              <div className='margin1'>
                「売上受取アドレス」に売上を受け取りたいアドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は変わりません。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                メインアドレスとは異なる自分のアドレスで発行したモナカードを出品する
              </div>
              <div className='margin1'>
                もなこっとでは、初期状態では、メインアドレスで発行したモナカードしか出品することができません。他のアドレスで発行したモナカードを出品するためには、発行アドレス(オーナーアドレス)からメインアドレスに対して、出品許可を与える必要があります。<br/>
                <br/>
                <span className='backgroundColorRed '>出品許可を与えるためには、発行アドレスでのユーザー登録が必要になりますので、設定画面で登録してください。</span><br/>
                次に、出品許可画面の「出品許可を与える」の各項目を以下のとおり入力してください。
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・オーナーアドレス： モナカードを発行したアドレス
                   </div>
                   <div>
                     ・出品許可先アドレス： モナカードを出品したいメインアドレス
                   </div>
                   <div>
                     ・ロイヤリティ受取アドレス： 空欄のまま
                   </div>
                   <div>
                     ・ロイヤリティ・パーセンテージ： 0のまま
                   </div>
                 </div>
                 入力後、Mpurseのアドレスをオーナーアドレスに設定して署名してください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                他者のアドレスで発行したモナカードを出品する
              </div>
              <div className='margin1'>
                他者の発行アドレスから、自分のメインアドレスに対して出品許可を与えてもらう必要があります。そのために、他者に対して出品許可リクエストを行います。<br/>
                他者があなたに出品許可する際に、ロイヤリティ・パーセンテージを設定することができます。この場合、モナカードが売れた際に、表示価格 × ロイヤリティ・パーセンテージ × 0.01 のロイヤリティがモナカード発行者に支払われます。<br/>
                <br/>
                出品許可画面の「出品許可をリクエストする」の各項目を以下のとおり入力してください。
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・メインアドレス： モナカードを出品したいメインアドレス
                   </div>
                   <div>
                     ・オーナーアドレス： モナカードを発行したアドレス(リクエストの宛先)
                   </div>
                   <div>
                     ・ロイヤリティ・パーセンテージ： 提案するロイヤリティ・パーセンテージ(相手は提案％を変更して許可する事が可能。)
                   </div>
                 </div>
                 入力後、Mpurseのアドレスをメインアドレスに設定して署名してください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                自分が発行したモナカードを他人が出品することを許可する
              </div>
              <div className='margin1'>
                他者から自分のアドレス宛に、出品許可リクエストが来ることがあります。<br/>
                <span className='backgroundColorRed '>出品許可リクエストを検索したり出品許可を与えるためには、対象となるアドレスでのユーザー登録が必要になりますので、設定画面で登録してください。</span><br/>
                <br/>
                出品許可画面の検索機能で、「許可リクエストされた」を選択し、メインアドレスにリクエストが来ているか調べたいアドレスを入力し、検索ボタンをクリックします。<br/>
                リクエストが来ている場合、その内容が表示されます。右端のハンドシェイクボタンをクリックすると、「出品許可を与える」の各項目にリクエスト内容がコピーされます。<br/>
                出品を許可する場合は、「ロイヤリティ受取アドレス」にロイヤリティを受け取りたいアドレスを入力し、必要に応じてロイヤリティ・パーセンテージを変更し、Mpurseのアドレスをオーナーアドレスに設定して署名・登録してください。<br/>
                <br/>
                出品許可リクエストが来ていなくても、他者に出品許可を与えることができます。<br/>
                この場合、各項目は、以下の文に当てはめて考えてください。<br/>
                <br/>
               「オーナーアドレス」で発行したモナカードを「出品許可先アドレス」が出品することを許可する。モナカードが売れたらロイヤリティ・パーセンテージ分のロイヤリティを「ロイヤリティ受取アドレス」で受け取る。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                自分のアドレスの署名を、他の自分のアドレスに委任する。
              </div>
              <div className='margin1'>
                もなこっとを複数アドレスで利用する場合、署名するアドレスを変更するために、Mpurseのアドレスの切り替えが必要になる場面があります。<br/>
                2つの異なるアドレスで署名を行う場合、片方の署名をもう一方に委任することで、後者の署名だけで済ませることができます。<br/>
                <span className='backgroundColorRed '>モナコインの送信とモナカードの送信は他のアドレスに委任できない</span>ので、代金送金元アドレス、カード送信元アドレスを委任先アドレスにするのが基本的な使い方になります。<br/>
                <span className='backgroundColorRed '>署名委任を行うには、委任元アドレス、委任先アドレスでのユーザー登録が必要になりますので、設定画面で登録してください。</span><br/>
                出品許可・署名委任画面の「署名委任」で、「委任する」を選択し、各項目を以下のとおり入力してください。
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・委任元アドレス： 署名を任せる元のアドレス
                   </div>
                   <div>
                     ・委任先アドレス： 署名を任せる先のアドレス(他のアドレスの署名を引き受けて、実際に署名行為をする側。)
                   </div>
                 </div>
                 入力後、Mpurseのアドレスを委任元アドレスに設定して署名してください。次に、「受任する」を選択し、Mpurseのアドレスを委任先アドレスに設定して署名してください。<br/>
                 委任および受任が完了すると、署名委任は有効となります。<br/>
                 なお、委任および受任の途中であっても、「委任した」「委任された」の検索が可能です。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                モナパレットのアドレスを使う
              </div>
              <div className='margin1'>
                モナパレットのアドレス(秘密鍵)をMpurseにインポートすると、モナパレットのアドレスをもなこっとで利用できるようになります。<br/>
                詳細は、
                <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                  onClick={ () => {
                    window.open('https://spotlight.soy/detail?article_id=avg2yiq6d');
                  } }>
                  こちら
                </button>
                をご参照ください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品したモナカードの並べ替えをする
              </div>
              <div className='margin1'>
                メインアドレスでログインしている状態でマイホームに入ると、出品中のモナカードの上に左右の矢印が表示され、これをクリックすることでモナカードの並べ替えができます。<br/>
                並べ替えた配置を確定するには、「並べ替えを確定する」ボタンをクリックしてください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                ユーザー情報を変更する
              </div>
              <div className='margin1'>
                設定画面で登録したユーザー情報を変更する場合、一度ログインボタンをクリックして現在の登録内容を読み込んでください。<br/>
                その後、内容を変更し、Mpurseのアドレスをメインアドレスに設定して署名・登録してください。<br/>
                <br/>
                画像の更新の反映には多少時間がかかります。また、ブラウザのキャッシュクリアもお試し下さい。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                デフォルトアドレスの設定をする
              </div>
              <div className='margin1'>
                設定画面で、「カード送信アドレス」「売上受取アドレス」「代金送金アドレス」「カード受取アドレス」のデフォルト設定ができます。<br/>
                デフォルトアドレスの設定をすると、購入時、出品時にデフォルトボタンをクリックすることで、各アドレスを簡単に入力することができます。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品履歴を確認する
              </div>
              <div className='margin1'>
                履歴画面で「出品履歴」を選択し、メインアドレスを入力し、検索ボタンをクリックすることで、いままで出品した履歴が表示されます。右端の「・・・」ボタンをクリックすると詳細が表示されます。<br/>
                <br/>
                近いうちに、出品に紐づく購入の明細を表示する機能を追加する予定です。(購入者のユーザー名、メインアドレス、送金TXID等も表示します。)
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                購入履歴を確認する
              </div>
              <div className='margin1'>
                履歴画面で「購入履歴」を選択し、メインアドレスを入力し、検索ボタンをクリックすることで、いままで購入した履歴が表示されます。右端の「・・・」ボタンをクリックすると詳細が表示されます。<br/>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品が途中なので、再開したい
              </div>
              <div className='margin1'>
                出品履歴を検索してください。<br/>
                <br/>
                出品履歴でステータスが「署名待ち」のものは、「カード送信元アドレス」による署名を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスをカード送信元アドレスに設定して、「カード送信元アドレスで署名する」ボタンをクリックしてください。その後、「カード送信」ボタンをクリックし、送信内容を確認のうえ、モナカードを送信してください。
                <br/>
                出品履歴でステータスが「カード送付待ち」のものは、モナカードの送信を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスをカード送信元アドレスに設定して、「カード送信」ボタンをクリックし、送信内容を確認のうえ、モナカードを送信してください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                購入が途中なので、再開したい
              </div>
              <div className='margin1'>
                購入履歴を検索してください。<br/>
                <br/>
                購入履歴でステータスが「署名待ち」のものは、「代金送金元アドレス」による署名を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスを代金送金元アドレスに設定して、「代金送金元アドレスで署名する」ボタンをクリックしてください。その後、「MONA送信」ボタンをクリックし、送金内容を確認のうえ、モナコインを送信してください。<br/>
                <br/>
                購入履歴でステータスが「MONA待ち」のものは、モナコインの送金を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスを代金送金元アドレスに設定して、「MONA送信」ボタンをクリックし、送金内容を確認のうえ、モナコインを送信してください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品をキャンセルしたい
              </div>
              <div className='margin1'>
                出品履歴を検索してください。<br/>
                <br/>
                出品履歴でステータスが「販売中」のものは、キャンセルが可能です。「・・・」ボタンをクリックし、「キャンセル」を選択し、Mpurseのアドレスをメインアドレスに設定して、「メインアドレスで署名する」ボタンをクリックしてください。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                出品しているモナカードの価格、売上受取アドレスを変更したい
              </div>
              <div className='margin1'>
                もなこっとでは、出品内容の変更はできず、代わりにキャンセル＆再出品という手続きを行います。<br/>
                <br/>
                出品履歴を検索してください。<br/>
                <br/>
                出品履歴でステータスが「販売中」のものは、キャンセル＆再出品が可能です。「・・・」ボタンをクリックし、「キャンセル＆再出品」を選択してください。売上受取アドレスと価格(単価)を変更し、Mpurseのアドレスをメインアドレスに設定して、「メインアドレスで署名する」ボタンをクリックしてください。<br/>
                当出品はキャンセルされ、新しい出品に引き継がれます。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                完売したモナカードはいつマイホームから消えるのか？
              </div>
              <div className='margin1'>
                完売から約3日後に非表示となります。
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                メッセージを見逃したのでもう一度表示させてほしい。
              </div>
              <div className='margin1'>
                もなこっとロゴの隣の青いヒヨコ「こっとちゃん」をクリックしてください。直前のメッセージが表示されます。<br/>
                また、メッセージの上の矢印をクリックすることで、過去のメッセージも表示できます。
              </div>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess' >
          <Header screen='howToUseAdvanced' />
          <div className='flexColumn alignItemsCenter'>
            <div className='flexColumn alignItemsCenter width93vw marginTopBottom1 '>
              <div className='font2 '>
                もなこっとの一歩進んだ使い方
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                購入時に、メインアドレスとは異なるアドレスからモナコインを送る
              </div>
              <div className='width93vw'>
                「代金送金元アドレス」にモナコインの送り元アドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は、
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・「メインアドレスで署名」ボタンをクリック(Mpurseのアドレスは、メインアドレスに設定してください。) → Mpurseで署名
                   </div>
                   <div>
                     ・「代金送金元アドレスで署名」ボタンをクリック(Mpurseのアドレスは、代金送金元アドレスに設定してください。) → Mpurseで署名<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>メインアドレスで署名してから30分以内に行わないと期限切れとなり、購入はキャンセルとなります。</span>
                     </div>
                   </div>
                   <div>
                     ・「MONA送信」ボタンをクリック(Mpurseのアドレスは、代金送金元アドレスに設定してください。)
                   </div>
                   <div>
                     ・送金内容を確認のうえ、Mpurseの「送信」ボタンをクリック<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>代金送金元アドレスで署名してから2時間以内に行わないと期限切れとなり、購入はキャンセルとなります。</span>
                     </div>
                   </div>
                 </div>
                 という流れになります。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                購入時に、メインアドレスとは異なるアドレスでモナカードを受け取る
              </div>
              <div className='width93vw'>
                「カード受取アドレス」にモナカードを受け取りたいアドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は変わりません。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品時に、メインアドレスとは異なるアドレスからモナカードを送る
              </div>
              <div className='width93vw'>
                「カード送信元アドレス」にモナカードの送り元アドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は、
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・「メインアドレスで署名」ボタンをクリック(Mpurseのアドレスは、メインアドレスに設定してください。) → Mpurseで署名
                   </div>
                   <div>
                     ・「カード送信元アドレスで署名」ボタンをクリック(Mpurseのアドレスは、カード送信元アドレスに設定してください。) → Mpurseで署名<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed marginLeft1'>メインアドレスで署名してから30分以内に行わないと期限切れとなり、出品はキャンセルとなります。</span>
                     </div>
                   </div>
                   <div>
                     ・「カード送信」ボタンをクリック(Mpurseのアドレスは、カード送信元アドレスに設定してください。)
                   </div>
                   <div>
                     ・送信内容を確認のうえ、Mpurseの「送信」ボタンをクリック<br/>
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed marginLeft1'>カード送信元アドレスで署名してから2時間以内に行わないと期限切れとなり、出品はキャンセルとなります。</span>
                     </div>
                   </div>
                 </div>
                 という流れになります。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品時に、メインアドレスとは異なるアドレスで売上を受け取る設定をする
              </div>
              <div className='width93vw'>
                「売上受取アドレス」に売上を受け取りたいアドレスを入力してください。Mpurseのアドレスを切り替えて、Mpurseボタンをクリックすると入力されます。<br/>
                 全項目入力後の操作は変わりません。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                メインアドレスとは異なる自分のアドレスで発行したモナカードを出品する
              </div>
              <div className='width93vw'>
                もなこっとでは、初期状態では、メインアドレスで発行したモナカードしか出品することができません。他のアドレスで発行したモナカードを出品するためには、発行アドレス(オーナーアドレス)からメインアドレスに対して、出品許可を与える必要があります。<br/>
                <br/>
                <span className='backgroundColorRed '>出品許可を与えるためには、発行アドレスでのユーザー登録が必要になりますので、設定画面で登録してください。</span><br/>
                次に、出品許可画面の「出品許可を与える」の各項目を以下のとおり入力してください。
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・オーナーアドレス： モナカードを発行したアドレス
                   </div>
                   <div>
                     ・出品許可先アドレス： モナカードを出品したいメインアドレス
                   </div>
                   <div>
                     ・ロイヤリティ受取アドレス： 空欄のまま
                   </div>
                   <div>
                     ・ロイヤリティ・パーセンテージ： 0のまま
                   </div>
                 </div>
                 入力後、Mpurseのアドレスをオーナーアドレスに設定して署名してください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                他者のアドレスで発行したモナカードを出品する
              </div>
              <div className='width93vw'>
                他者の発行アドレスから、自分のメインアドレスに対して出品許可を与えてもらう必要があります。そのために、他者に対して出品許可リクエストを行います。<br/>
                他者があなたに出品許可する際に、ロイヤリティ・パーセンテージを設定することができます。この場合、モナカードが売れた際に、表示価格 × ロイヤリティ・パーセンテージ × 0.01 のロイヤリティがモナカード発行者に支払われます。<br/>
                <br/>
                出品許可画面の「出品許可をリクエストする」の各項目を以下のとおり入力してください。
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・メインアドレス： モナカードを出品したいメインアドレス
                   </div>
                   <div>
                     ・オーナーアドレス： モナカードを発行したアドレス(リクエストの宛先)
                   </div>
                   <div>
                     ・ロイヤリティ・パーセンテージ： 提案するロイヤリティ・パーセンテージ(相手は提案％を変更して許可する事が可能。)
                   </div>
                 </div>
                 入力後、Mpurseのアドレスをメインアドレスに設定して署名してください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                自分が発行したモナカードを他人が出品することを許可する
              </div>
              <div className='width93vw'>
                他者から自分のアドレス宛に、出品許可リクエストが来ることがあります。<br/>
                <span className='backgroundColorRed '>出品許可リクエストを検索したり出品許可を与えるためには、対象となるアドレスでのユーザー登録が必要になりますので、設定画面で登録してください。</span><br/>
                <br/>
                出品許可画面の検索機能で、「許可リクエストされた」を選択し、メインアドレスにリクエストが来ているか調べたいアドレスを入力し、検索ボタンをクリックします。<br/>
                リクエストが来ている場合、その内容が表示されます。右端のハンドシェイクボタンをクリックすると、「出品許可を与える」の各項目にリクエスト内容がコピーされます。<br/>
                出品を許可する場合は、「ロイヤリティ受取アドレス」にロイヤリティを受け取りたいアドレスを入力し、必要に応じてロイヤリティ・パーセンテージを変更し、Mpurseのアドレスをオーナーアドレスに設定して署名・登録してください。<br/>
                <br/>
                出品許可リクエストが来ていなくても、他者に出品許可を与えることができます。<br/>
                この場合、各項目は、以下の文に当てはめて考えてください。<br/>
                <br/>
               「オーナーアドレス」で発行したモナカードを「出品許可先アドレス」が出品することを許可する。モナカードが売れたらロイヤリティ・パーセンテージ分のロイヤリティを「ロイヤリティ受取アドレス」で受け取る。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                自分のアドレスの署名を、他の自分のアドレスに委任する。
              </div>
              <div className='width93vw'>
                もなこっとを複数アドレスで利用する場合、署名するアドレスを変更するために、Mpurseのアドレスの切り替えが必要になる場面があります。<br/>
                2つの異なるアドレスで署名を行う場合、片方の署名をもう一方に委任することで、後者の署名だけで済ませることができます。<br/>
                <span className='backgroundColorRed '>モナコインの送信とモナカードの送信は他のアドレスに委任できない</span>ので、代金送金元アドレス、カード送信元アドレスを委任先アドレスにするのが基本的な使い方になります。<br/>
                <span className='backgroundColorRed '>署名委任を行うには、委任元アドレス、委任先アドレスでのユーザー登録が必要になりますので、設定画面で登録してください。</span><br/>
                出品許可・署名委任画面の「署名委任」で、「委任する」を選択し、各項目を以下のとおり入力してください。
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     ・委任元アドレス： 署名を任せる元のアドレス
                   </div>
                   <div>
                     ・委任先アドレス： 署名を任せる先のアドレス(他のアドレスの署名を引き受けて、実際に署名行為をする側。)
                   </div>
                 </div>
                 入力後、Mpurseのアドレスを委任元アドレスに設定して署名してください。次に、「受任する」を選択し、Mpurseのアドレスを委任先アドレスに設定して署名してください。<br/>
                 委任および受任が完了すると、署名委任は有効となります。<br/>
                 なお、委任および受任の途中であっても、「委任した」「委任された」の検索が可能です。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                モナパレットのアドレスを使う
              </div>
              <div className='width93vw'>
                モナパレットのアドレス(秘密鍵)をMpurseにインポートすると、モナパレットのアドレスをもなこっとで利用できるようになります。<br/>
                詳細は、
                <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                  onClick={ () => {
                    window.open('https://spotlight.soy/detail?article_id=avg2yiq6d');
                  } }>
                  こちら
                </button>
                をご参照ください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品したモナカードの並べ替えをする
              </div>
              <div className='width93vw'>
                メインアドレスでログインしている状態でマイホームに入ると、出品中のモナカードの上に左右の矢印が表示され、これをクリックすることでモナカードの並べ替えができます。<br/>
                並べ替えた配置を確定するには、「並べ替えを確定する」ボタンをクリックしてください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                ユーザー情報を変更する
              </div>
              <div className='width93vw'>
                設定画面で登録したユーザー情報を変更する場合、一度ログインボタンをクリックして現在の登録内容を読み込んでください。<br/>
                その後、内容を変更し、Mpurseのアドレスをメインアドレスに設定して署名・登録してください。<br/>
                <br/>
                画像の更新の反映には多少時間がかかります。また、ブラウザのキャッシュクリアもお試し下さい。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                デフォルトアドレスの設定をする
              </div>
              <div className='width93vw'>
                設定画面で、「カード送信アドレス」「売上受取アドレス」「代金送金アドレス」「カード受取アドレス」のデフォルト設定ができます。<br/>
                デフォルトアドレスの設定をすると、購入時、出品時にデフォルトボタンをクリックすることで、各アドレスを簡単に入力することができます。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品履歴を確認する
              </div>
              <div className='width93vw'>
                履歴画面で「出品履歴」を選択し、メインアドレスを入力し、検索ボタンをクリックすることで、いままで出品した履歴が表示されます。右端の「・・・」ボタンをクリックすると詳細が表示されます。<br/>
                <br/>
                近いうちに、出品に紐づく購入の明細を表示する機能を追加する予定です。(購入者のユーザー名、メインアドレス、送金TXID等も表示します。)
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                購入履歴を確認する
              </div>
              <div className='width93vw'>
                履歴画面で「購入履歴」を選択し、メインアドレスを入力し、検索ボタンをクリックすることで、いままで購入した履歴が表示されます。右端の「・・・」ボタンをクリックすると詳細が表示されます。<br/>
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品が途中なので、再開したい
              </div>
              <div className='width93vw'>
                出品履歴を検索してください。<br/>
                <br/>
                出品履歴でステータスが「署名待ち」のものは、「カード送信元アドレス」による署名を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスをカード送信元アドレスに設定して、「カード送信元アドレスで署名する」ボタンをクリックしてください。その後、「カード送信」ボタンをクリックし、送信内容を確認のうえ、モナカードを送信してください。
                <br/>
                出品履歴でステータスが「カード送付待ち」のものは、モナカードの送信を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスをカード送信元アドレスに設定して、「カード送信」ボタンをクリックし、送信内容を確認のうえ、モナカードを送信してください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                購入が途中なので、再開したい
              </div>
              <div className='width93vw'>
                購入履歴を検索してください。<br/>
                <br/>
                購入履歴でステータスが「署名待ち」のものは、「代金送金元アドレス」による署名を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスを代金送金元アドレスに設定して、「代金送金元アドレスで署名する」ボタンをクリックしてください。その後、「MONA送信」ボタンをクリックし、送金内容を確認のうえ、モナコインを送信してください。<br/>
                <br/>
                購入履歴でステータスが「MONA待ち」のものは、モナコインの送金を待っている状態です。「・・・」ボタンをクリックし、Mpurseのアドレスを代金送金元アドレスに設定して、「MONA送信」ボタンをクリックし、送金内容を確認のうえ、モナコインを送信してください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品をキャンセルしたい
              </div>
              <div className='width93vw'>
                出品履歴を検索してください。<br/>
                <br/>
                出品履歴でステータスが「販売中」のものは、キャンセルが可能です。「・・・」ボタンをクリックし、「キャンセル」を選択し、Mpurseのアドレスをメインアドレスに設定して、「メインアドレスで署名する」ボタンをクリックしてください。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                出品しているモナカードの価格、売上受取アドレスを変更したい
              </div>
              <div className='width93vw'>
                もなこっとでは、出品内容の変更はできず、代わりにキャンセル＆再出品という手続きを行います。<br/>
                <br/>
                出品履歴を検索してください。<br/>
                <br/>
                出品履歴でステータスが「販売中」のものは、キャンセル＆再出品が可能です。「・・・」ボタンをクリックし、「キャンセル＆再出品」を選択してください。売上受取アドレスと価格(単価)を変更し、Mpurseのアドレスをメインアドレスに設定して、「メインアドレスで署名する」ボタンをクリックしてください。<br/>
                当出品はキャンセルされ、新しい出品に引き継がれます。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                完売したモナカードはいつマイホームから消えるのか？
              </div>
              <div className='width93vw'>
                完売から約3日後に非表示となります。
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                メッセージを見逃したのでもう一度表示させてほしい。
              </div>
              <div className='width93vw'>
                もなこっとロゴの隣の青いヒヨコ「こっとちゃん」をクリックしてください。直前のメッセージが表示されます。<br/>
                また、メッセージの上の矢印をクリックすることで、過去のメッセージも表示できます。
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  else // english
  {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore' >
          <Header screen='howToUseAdvanced' />
          <div className='flexColumn alignItemsCenter'>
            <div className='widthMax marginTopBottom1 marginSide2'>
              <div className='font2'>
                How to use Monacotto one step further
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Send Monacoin from a different address than your main address when you purchase.
              </div>
              <div className='margin1'>
                 Enter the address from which Monacoin is sent in "{words.addressPayFrom[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the following.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - Click "{words.signByMainAddress[state.language]}" button and sign with Mpurse. (Mpurse address must be set as your main address.) 
                   </div>
                   <div>
                     - Click "{words.signByAddressYouPayFrom[state.language]}" button and sign with Mpurse. (Mpurse address must be set as "{words.addressPayFrom[state.language]}".) 
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 30 minutes of signing by the main address will result in expiration and the purchase will be canceled.</span>
                     </div>
                   </div>
                   <div>
                     - Click "{words.sendMona[state.language]}" button. (Mpurse address must be set as "{words.addressPayFrom[state.language]}".) 
                   </div>
                   <div>
                     - Confirm the remittance details, and click "Send" button on Mpurse.
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 2 hours of signing by "{words.addressPayFrom[state.language]}" will result in expiration and the purchase will be canceled.</span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Receive Monacards in a different address than your main address when you purchase.
              </div>
              <div className='margin1'>
                 Enter the address where you want to receive the Monacards in the "{words.addressSendCardTo[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the same.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Send the monacards from a different address than your main address when you exhibit.
              </div>
              <div className='margin1'>
                 Enter the address from which the Monacards is sent in "{words.addressCardFrom[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the following.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - Click "{words.signByMainAddress[state.language]}" button and sign with Mpurse. (Mpurse address must be set as your main address.) 
                   </div>
                   <div>
                     - Click "{words.signByAddressYouSendCardsFrom[state.language]}" button and sign with Mpurse. (Mpurse address must be set as "{words.addressCardFrom[state.language]}".) 
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 30 minutes of signing by the main address will result in expiration and the exhibit will be canceled.</span>
                     </div>
                   </div>
                   <div>
                     - Click "{words.sendCards[state.language]}" button. (Mpurse address must be set as "{words.addressCardFrom[state.language]}".) 
                   </div>
                   <div>
                     - Confirm the sending details, and click "Send" button on Mpurse.
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 2 hours of signing by "{words.addressCardFrom[state.language]}" will result in expiration and the exhibit will be canceled.</span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Set up to receive proceeds in a different address than your main address when you exhibit.
              </div>
              <div className='margin1'>
                 Enter the address where you want to receive proceeds in the "{words.addressPayProceedsTo[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the same.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Exhibit Monacards issued by your own address that is different from your main address.
              </div>
              <div className='margin1'>
                By default, you can exhibit Monacards only issued by your main address in monacotto. In order to exhibit Monacards issued by another address, the issuing address(owner address) must give permission to the main address to exhibit the cards.<br/>
                <br/>
                <span className='backgroundColorRed '>In order to grant permission to exhibit, you will need to be registered as a user with the issuing address, so please register on the setup page.</span><br/>
                Next, fill in each field of "{words.grantPermissionOfExhibit[state.language]}" section on the permission screen as follows.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - {words.addressOwner[state.language]}: The address where the Monacards were issued.
                   </div>
                   <div>
                     - {words.addressPermitTo[state.language]}: The main address where you want to exhibit the Monacards.
                   </div>
                   <div>
                     - {words.addressPayRoyaltyTo[state.language]}: Leave blank.
                   </div>
                   <div>
                     - {words.royaltyPercentage[state.language]}: Leave 0.
                   </div>
                 </div>
                 After all fields have been filled in, set the Mpurse address as {words.addressOwner[state.language]} and sign it.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Exhibit Monacards issued by someone else's address.
              </div>
              <div className='margin1'>
                You need to ask others to grant you permission to exhibit from their issuing address to your main address. To do so, make a exhibit permission request to the other.<br/>
                They can set a royalty percentage when they allow you to exhibit their Monacards on your My Home. In this case, the Monacard issuer(owner) will receive a royalty of the displayed price x royalty percentage x 0.01 when the Monacard is sold.<br/>
                <br/>
                Fill in each field of "{words.requestPermissionOfExhibit[state.language]}" section on the permission screen as follows.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - {words.addressMain[state.language]}: The main address where you want to exhibit the Monacards.
                   </div>
                   <div>
                     - {words.addressOwner[state.language]}: The address where the Monacards were issued.(Destination of the request)
                   </div>
                   <div>
                     - {words.royaltyPercentage[state.language]}: the royalty percentage you propose. (the other can change the proposed % when he/she grant you permission.)
                   </div>
                 </div>
                 After all fields have been filled in, set the Mpurse address as {words.addressMain[state.language]} and sign it.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Allow others to exhibit Monacards issued by you.
              </div>
              <div className='margin1'>
                You may receive a request for permission to exhibit your Monacards from someone else to your address.<br/>
                <span className='backgroundColorRed '>In order to search for requests and grant permission to exhibit, you will need to be registered as a user with the target address, so please register on the setup screen.</span><br/>
                <br/>
                In the search function on the permission screen, select "{words.requestedPermission[state.language]}, " enter the address you want to check to see if a request has been received in "{words.addressMain[state.language]}", and click the Search button.<br/>
                If a request has been received, its details will be displayed. Click the handshake button on the far right to copy the details of the request to each field in the "{words.grantPermissionOfExhibit[state.language]}" section.<br/>
                To allow to exhibit, enter the address where you want to receive royalties in "{words.addressPayRoyaltyTo[state.language]}" field, change the royalty percentage if necessary, set the Mpurse address as "{words.addressOwner[state.language]}," sign it and register.<br/>
                <br/>
                You can grant permission to exhibit to others even if you have not received a request.<br/>
                In this case, each field should be considered in terms of the following statement.<br/>
                <br/>
                I permits "{words.addressPermitTo[state.language]}" to exhibit the Monacards issued by "{words.addressOwner[state.language]}". I will receive royalties for "{words.royaltyPercentage[state.language]}" in "{words.addressPayRoyaltyTo[state.language]}" when the Monacards are sold.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Delegate the signature of your address to another of your addresses.
              </div>
              <div className='margin1'>
                When using monacotto with multiple addresses, there are situations where you will need to switch the Mpurse address in order to change the address to sign with.<br/>
                When signing with two different addresses, one signature can be delegated to the other so that only the latter signature is required.<br/>
                <span className='backgroundColorRed '>Since sending Monacoins and sending Monacards cannot be delegated to other addresses,</span> the basic usage is to use the payment source address and card sending source address as {words.addressDelegateTo[state.language]}.<br/>
                <span className='backgroundColorRed '>In order to perform signature delegation, you will need to be registered as a user with the delegation source address and the delegated address, so please register on the setup screen.</span><br/>
                In the "{words.signatureDelegation[state.language]}" section of the "{words.permissionAndDelegation[state.language]}" screen, select "{words.delegate[state.language]}" and enter each item as shown below.<br/>
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - {words.addressDelegateFrom[state.language]}: The address you delegate signature from.
                   </div>
                   <div>
                     - {words.addressDelegateTo[state.language]}: The address you delegate signature to.(The party that accepts the signatures of the other address and actually performs the act of signing.)
                   </div>
                 </div>
                 After all fields have been filled in, set the Mpurse address as {words.addressDelegateFrom[state.language]} and sign it. Next, select "{words.acceptDelegation[state.language]}" and sign it with Mpurse address set as {words.addressDelegateTo[state.language]}.<br/>
                 On completion of delegation and acceptance, signature delegation becomes effective.<br/>
                 Note that "{words.delegate2[state.language]}" and "{words.delegated[state.language]}" searches are possible even in the middle of delegation and acceptance.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Use your monapalette address.
              </div>
              <div className='margin1'>
                Importing monapalette addresses (private keys) into Mpurse will make them available in monacotto.<br/>
                For more information, please refer to 
                <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                  onClick={ () => {
                    window.open('https://spotlight.soy/detail?article_id=avg2yiq6d');
                  } }>
                  here
                </button>
                . (Japanese)
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
               Rearrange the exhibited Monacards.
              </div>
              <div className='margin1'>
                When you enter your own My Home while logged in at your main address, you will see left and right arrows on the Monacards on exhibit, which you can click to rearrange the Monacards.<br/>
                To determine the sorted arrangement, click "{words.commitReplacement[state.language]}" button.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Change user information.
              </div>
              <div className='margin1'>
                To change the user information registered on the settings screen, click the login button once to load the current registration information.<br/>
                Then, change the information, set the Mpurse address as the main address, and sign and register.<br/>
                <br/>
                It may take some time for image updates to be reflected. Also, please try clearing your browser's cache.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Set the default addresses
              </div>
              <div className='margin1'>
                Default settings for "{words.addressCardFrom[state.language]}," "{words.addressPayProceedsTo[state.language]}," "{words.addressPayFrom[state.language]}" and "{words.addressSendCardTo[state.language]}" can be set on the setup screen.<br/>
                Once the default addresses are set, each address can be easily entered by clicking the default button when making a purchase or an exhibit of Monacards.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Check exhibit history.
              </div>
              <div className='margin1'>
                Select "exhibit history" on the history screen, enter the main address, and click Search button to display the history of your previous exhibits. Click the "..." button on the far right to view details.<br/>
                <br/>
                In the near future, we plan to add the ability to display the details of purchases tied to an exhibit. (The buyer's user name, main address, remittance TXID, etc. are also displayed.)
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                Check purchase history.
              </div>
              <div className='margin1'>
                Select "purchase history" on the history screen, enter the main address, and click Search button to display the history of your previous purchases. Click the "..." button on the far right to view details.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                The exhibit is on its way and I want to resume it.
              </div>
              <div className='margin1'>
                Please search your exhibit history.<br/>
                <br/>
                If the status of the exhibit is "{words.waitingForSignature[state.language]}", it means that we are waiting for signature by "{words.addressCardFrom[state.language]}". Click the "..." button, set the Mpurse address as "{words.addressCardFrom[state.language]}", and click "{words.signByAddressYouSendCardsFrom[state.language]}" button. After that, click "{words.sendCards[state.language]}" button, confirm the sending details, and send the Monacards.<br/>
                <br/>
                If the status of the exhibit is "{words.waitingForToken[state.language]}", it means that we are waiting for you to send the Monacards. Click the "..." button, set the Mpurse address as "{words.addressCardFrom[state.language]}", click "{words.sendCards[state.language]}" button, confirm the sending details, and send the Monacards.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                The purchase is on its way and I want to resume it.
              </div>
              <div className='margin1'>
                Please search your purchase history.<br/>
                <br/>
                If the status of the purchase is "{words.waitingForSignature[state.language]}", it means that we are waiting for signature by "{words.addressPayFrom[state.language]}". Click the "..." button, set the Mpurse address as "{words.addressPayFrom[state.language]}", and click "{words.signByAddressYouPayFrom[state.language]}" button. After that, click "{words.sendMona[state.language]}" button, confirm the remittance details, and send Monacoin.<br/>
                <br/>
                If the status of the purchase is "{words.waitingForMona[state.language]}", it means that we are waiting for you to send Monacoin. Click the "..." button, set the Mpurse address as "{words.addressPayFrom[state.language]}", click "{words.sendMona[state.language]}" button, confirm the remittance details, and send Monacoin.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                I want to cancel my exhibit.
              </div>
              <div className='margin1'>
                Please search your exhibit history.<br/>
                <br/>
                If the status of the exhibit is "{words.onSale[state.language]}", you can cancel it. Click the "..." button, select "{words.cancel[state.language]}," set the Mpurse address as your main address, and click "{words.signByMainAddress[state.language]}" button.<br/>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                I want to change the price of the Monacards I have exhibited or the address I receive proceeds in.
              </div>
              <div className='margin1'>
                Monacotto does not allow you to change exhibit details, but instead you can Cancel & Re-exhibit.<br/>
                <br/>
                Please search your exhibit history.<br/>
                <br/>
                If the status of the item is "{words.onSale[state.language]}", you can Cancel & Re-exhibit it. Click the "..." button and select "{words.cancelAndReexhibit[state.language]}." Change "{words.addressPayProceedsTo[state.language]}" and the price (unit price), set the Mpurse address as your main address, and click "{words.signByMainAddress[state.language]}" button.<br/>
                The exhibit will be canceled and taken over to the new exhibit.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                When will sold-out Monacards disappear from My Home?
              </div>
              <div className='margin1'>
                They will disappear about 3 days after they are sold out.
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width90P borderMonacotto margin1 padding1'>
              <div className='font2'>
                I missed the message and want it to appear again.
              </div>
              <div className='margin1'>
                Click on the blue chick "Cotto-chan" next to the monacotto logo. The previous message will be displayed.<br/>
                You can also view past messages by clicking the arrow above the message.
              </div>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess' >
          <Header screen='howToUseAdvanced' />
          <div className='flexColumn alignItemsCenter'>
            <div className='flexColumn alignItemsCenter width93vw marginTopBottom1 '>
              <div className='font2 '>
                How to use Monacotto one step further
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Send Monacoin from a different address than your main address when you purchase.
              </div>
              <div className='width93vw'>
                 Enter the address from which Monacoin is sent in "{words.addressPayFrom[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the following.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - Click "{words.signByMainAddress[state.language]}" button and sign with Mpurse. (Mpurse address must be set as your main address.) 
                   </div>
                   <div>
                     - Click "{words.signByAddressYouPayFrom[state.language]}" button and sign with Mpurse. (Mpurse address must be set as "{words.addressPayFrom[state.language]}".) 
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 30 minutes of signing by the main address will result in expiration and the purchase will be canceled.</span>
                     </div>
                   </div>
                   <div>
                     - Click "{words.sendMona[state.language]}" button. (Mpurse address must be set as "{words.addressPayFrom[state.language]}".) 
                   </div>
                   <div>
                     - Confirm the remittance details, and click "Send" button on Mpurse.
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 2 hours of signing by "{words.addressPayFrom[state.language]}" will result in expiration and the purchase will be canceled.</span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Receive Monacards in a different address than your main address when you purchase.
              </div>
              <div className='width93vw'>
                 Enter the address where you want to receive the Monacards in the "{words.addressSendCardTo[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the same.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Send the monacards from a different address than your main address when you exhibit.
              </div>
              <div className='width93vw'>
                 Enter the address from which the Monacards is sent in "{words.addressCardFrom[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the following.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - Click "{words.signByMainAddress[state.language]}" button and sign with Mpurse. (Mpurse address must be set as your main address.) 
                   </div>
                   <div>
                     - Click "{words.signByAddressYouSendCardsFrom[state.language]}" button and sign with Mpurse. (Mpurse address must be set as "{words.addressCardFrom[state.language]}".) 
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 30 minutes of signing by the main address will result in expiration and the exhibit will be canceled.</span>
                     </div>
                   </div>
                   <div>
                     - Click "{words.sendCards[state.language]}" button. (Mpurse address must be set as "{words.addressCardFrom[state.language]}".) 
                   </div>
                   <div>
                     - Confirm the sending details, and click "Send" button on Mpurse.
                     <div className='marginLeft1'>
                       <span className='backgroundColorRed '>Failure to do so within 2 hours of signing by "{words.addressCardFrom[state.language]}" will result in expiration and the exhibit will be canceled.</span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Set up to receive proceeds in a different address than your main address when you exhibit.
              </div>
              <div className='width93vw'>
                 Enter the address where you want to receive proceeds in the "{words.addressPayProceedsTo[state.language]}" field. Switch the Mpurse address and click Mpurse button to enter it.<br/>
                 After all fields have been filled in, do the same.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Exhibit Monacards issued by your own address that is different from your main address.
              </div>
              <div className='width93vw'>
                By default, you can exhibit Monacards only issued by your main address in monacotto. In order to exhibit Monacards issued by another address, the issuing address(owner address) must give permission to the main address to exhibit the cards.<br/>
                <br/>
                <span className='backgroundColorRed '>In order to grant permission to exhibit, you will need to be registered as a user with the issuing address, so please register on the setup page.</span><br/>
                Next, fill in each field of "{words.grantPermissionOfExhibit[state.language]}" section on the permission screen as follows.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - {words.addressOwner[state.language]}: The address where the Monacards were issued.
                   </div>
                   <div>
                     - {words.addressPermitTo[state.language]}: The main address where you want to exhibit the Monacards.
                   </div>
                   <div>
                     - {words.addressPayRoyaltyTo[state.language]}: Leave blank.
                   </div>
                   <div>
                     - {words.royaltyPercentage[state.language]}: Leave 0.
                   </div>
                 </div>
                 After all fields have been filled in, set the Mpurse address as {words.addressOwner[state.language]} and sign it.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Exhibit Monacards issued by someone else's address.
              </div>
              <div className='width93vw'>
                You need to ask others to grant you permission to exhibit from their issuing address to your main address. To do so, make a exhibit permission request to the other.<br/>
                They can set a royalty percentage when they allow you to exhibit their Monacards on your My Home. In this case, the Monacard issuer(owner) will receive a royalty of the displayed price x royalty percentage x 0.01 when the Monacard is sold.<br/>
                <br/>
                Fill in each field of "{words.requestPermissionOfExhibit[state.language]}" section on the permission screen as follows.
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - {words.addressMain[state.language]}: The main address where you want to exhibit the Monacards.
                   </div>
                   <div>
                     - {words.addressOwner[state.language]}: The address where the Monacards were issued.(Destination of the request)
                   </div>
                   <div>
                     - {words.royaltyPercentage[state.language]}: the royalty percentage you propose. (the other can change the proposed % when he/she grant you permission.)
                   </div>
                 </div>
                 After all fields have been filled in, set the Mpurse address as {words.addressMain[state.language]} and sign it.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Allow others to exhibit Monacards issued by you.
              </div>
              <div className='width93vw'>
                You may receive a request for permission to exhibit your Monacards from someone else to your address.<br/>
                <span className='backgroundColorRed '>In order to search for requests and grant permission to exhibit, you will need to be registered as a user with the target address, so please register on the setup screen.</span><br/>
                <br/>
                In the search function on the permission screen, select "{words.requestedPermission[state.language]}, " enter the address you want to check to see if a request has been received in "{words.addressMain[state.language]}", and click the Search button.<br/>
                If a request has been received, its details will be displayed. Click the handshake button on the far right to copy the details of the request to each field in the "{words.grantPermissionOfExhibit[state.language]}" section.<br/>
                To allow to exhibit, enter the address where you want to receive royalties in "{words.addressPayRoyaltyTo[state.language]}" field, change the royalty percentage if necessary, set the Mpurse address as "{words.addressOwner[state.language]}," sign it and register.<br/>
                <br/>
                You can grant permission to exhibit to others even if you have not received a request.<br/>
                In this case, each field should be considered in terms of the following statement.<br/>
                <br/>
                I permits "{words.addressPermitTo[state.language]}" to exhibit the Monacards issued by "{words.addressOwner[state.language]}". I will receive royalties for "{words.royaltyPercentage[state.language]}" in "{words.addressPayRoyaltyTo[state.language]}" when the Monacards are sold.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Delegate the signature of your address to another of your addresses.
              </div>
              <div className='width93vw'>
                When using monacotto with multiple addresses, there are situations where you will need to switch the Mpurse address in order to change the address to sign with.<br/>
                When signing with two different addresses, one signature can be delegated to the other so that only the latter signature is required.<br/>
                <span className='backgroundColorRed '>Since sending Monacoins and sending Monacards cannot be delegated to other addresses,</span> the basic usage is to use the payment source address and card sending source address as {words.addressDelegateTo[state.language]}.<br/>
                <span className='backgroundColorRed '>In order to perform signature delegation, you will need to be registered as a user with the delegation source address and the delegated address, so please register on the setup screen.</span><br/>
                In the "{words.signatureDelegation[state.language]}" section of the "{words.permissionAndDelegation[state.language]}" screen, select "{words.delegate[state.language]}" and enter each item as shown below.<br/>
                 <div className='flexColumn alignItemsFlexStart marginLeft1 marginTopBottom1'>
                   <div>
                     - {words.addressDelegateFrom[state.language]}: The address you delegate signature from.
                   </div>
                   <div>
                     - {words.addressDelegateTo[state.language]}: The address you delegate signature to.(The party that accepts the signatures of the other address and actually performs the act of signing.)
                   </div>
                 </div>
                 After all fields have been filled in, set the Mpurse address as {words.addressDelegateFrom[state.language]} and sign it. Next, select "{words.acceptDelegation[state.language]}" and sign it with Mpurse address set as {words.addressDelegateTo[state.language]}.<br/>
                 On completion of delegation and acceptance, signature delegation becomes effective.<br/>
                 Note that "{words.delegate2[state.language]}" and "{words.delegated[state.language]}" searches are possible even in the middle of delegation and acceptance.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Use your monapalette address.
              </div>
              <div className='width93vw'>
                Importing monapalette addresses (private keys) into Mpurse will make them available in monacotto.<br/>
                For more information, please refer to 
                <button className={'borderNone backgroundColorTransparent fontHyperLink focusEffect01 cursor'} tabindex='0'
                  onClick={ () => {
                    window.open('https://spotlight.soy/detail?article_id=avg2yiq6d');
                  } }>
                  here
                </button>
                . (Japanese)
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
               Rearrange the exhibited Monacards.
              </div>
              <div className='width93vw'>
                When you enter your own My Home while logged in at your main address, you will see left and right arrows on the Monacards on exhibit, which you can click to rearrange the Monacards.<br/>
                To determine the sorted arrangement, click "{words.commitReplacement[state.language]}" button.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Change user information.
              </div>
              <div className='width93vw'>
                To change the user information registered on the settings screen, click the login button once to load the current registration information.<br/>
                Then, change the information, set the Mpurse address as the main address, and sign and register.<br/>
                <br/>
                It may take some time for image updates to be reflected. Also, please try clearing your browser's cache.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Set the default addresses
              </div>
              <div className='width93vw'>
                Default settings for "{words.addressCardFrom[state.language]}," "{words.addressPayProceedsTo[state.language]}," "{words.addressPayFrom[state.language]}" and "{words.addressSendCardTo[state.language]}" can be set on the setup screen.<br/>
                Once the default addresses are set, each address can be easily entered by clicking the default button when making a purchase or an exhibit of Monacards.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Check exhibit history.
              </div>
              <div className='width93vw'>
                Select "exhibit history" on the history screen, enter the main address, and click Search button to display the history of your previous exhibits. Click the "..." button on the far right to view details.<br/>
                <br/>
                In the near future, we plan to add the ability to display the details of purchases tied to an exhibit. (The buyer's user name, main address, remittance TXID, etc. are also displayed.)
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                Check purchase history.
              </div>
              <div className='width93vw'>
                Select "purchase history" on the history screen, enter the main address, and click Search button to display the history of your previous purchases. Click the "..." button on the far right to view details.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                The exhibit is on its way and I want to resume it.
              </div>
              <div className='width93vw'>
                Please search your exhibit history.<br/>
                <br/>
                If the status of the exhibit is "{words.waitingForSignature[state.language]}", it means that we are waiting for signature by "{words.addressCardFrom[state.language]}". Click the "..." button, set the Mpurse address as "{words.addressCardFrom[state.language]}", and click "{words.signByAddressYouSendCardsFrom[state.language]}" button. After that, click "{words.sendCards[state.language]}" button, confirm the sending details, and send the Monacards.<br/>
                <br/>
                If the status of the exhibit is "{words.waitingForToken[state.language]}", it means that we are waiting for you to send the Monacards. Click the "..." button, set the Mpurse address as "{words.addressCardFrom[state.language]}", click "{words.sendCards[state.language]}" button, confirm the sending details, and send the Monacards.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                The purchase is on its way and I want to resume it.
              </div>
              <div className='width93vw'>
                Please search your purchase history.<br/>
                <br/>
                If the status of the purchase is "{words.waitingForSignature[state.language]}", it means that we are waiting for signature by "{words.addressPayFrom[state.language]}". Click the "..." button, set the Mpurse address as "{words.addressPayFrom[state.language]}", and click "{words.signByAddressYouPayFrom[state.language]}" button. After that, click "{words.sendMona[state.language]}" button, confirm the remittance details, and send Monacoin.<br/>
                <br/>
                If the status of the purchase is "{words.waitingForMona[state.language]}", it means that we are waiting for you to send Monacoin. Click the "..." button, set the Mpurse address as "{words.addressPayFrom[state.language]}", click "{words.sendMona[state.language]}" button, confirm the remittance details, and send Monacoin.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                I want to cancel my exhibit.
              </div>
              <div className='width93vw'>
                Please search your exhibit history.<br/>
                <br/>
                If the status of the exhibit is "{words.onSale[state.language]}", you can cancel it. Click the "..." button, select "{words.cancel[state.language]}," set the Mpurse address as your main address, and click "{words.signByMainAddress[state.language]}" button.<br/>
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                I want to change the price of the Monacards I have exhibited or the address I receive proceeds in.
              </div>
              <div className='width93vw'>
                Monacotto does not allow you to change exhibit details, but instead you can Cancel & Re-exhibit.<br/>
                <br/>
                Please search your exhibit history.<br/>
                <br/>
                If the status of the item is "{words.onSale[state.language]}", you can Cancel & Re-exhibit it. Click the "..." button and select "{words.cancelAndReexhibit[state.language]}." Change "{words.addressPayProceedsTo[state.language]}" and the price (unit price), set the Mpurse address as your main address, and click "{words.signByMainAddress[state.language]}" button.<br/>
                The exhibit will be canceled and taken over to the new exhibit.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                When will sold-out Monacards disappear from My Home?
              </div>
              <div className='width93vw'>
                They will disappear about 3 days after they are sold out.
              </div>
            </div>
            <div className='flexColumn alignItemsCenter width96vw borderMonacotto marginTopBottom1 '>
              <div className='font2 width90vw marginTopBottom1'>
                I missed the message and want it to appear again.
              </div>
              <div className='width93vw'>
                Click on the blue chick "Cotto-chan" next to the monacotto logo. The previous message will be displayed.<br/>
                You can also view past messages by clicking the arrow above the message.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// HOW TO USE MPURSE
function HowToUseMpurse() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );

  useEffect( () => {
    window.scrollTo(0, 0);
  }, []);


  if (state.language === 'japanese') {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore' >
          <Header screen='howToUseMpurse' />
          <div className='flexColumn alignItemsCenter'>
            <div className='widthMax marginTopBottom1 marginSide2'>
              <div className='font2'>
                Mpurseのインストール
              </div>
              <div className='marginTop1'>
                もなこっとでは、モナコイン、モナカードをMpurseというウォレットで扱います。<br/>
                Mpurseはモナコイン版MetaMaskのようなもので、MetaMaskに慣れているひとであれば使い方はそれほど難しくないでしょう。
              </div>
            </div>
            <div className='marginTopBottom1'>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='width50' src={imageManualMpurse01} />
                </div>
                <div className='width50  '>
                  Mpurseのダウンロードサイトにアクセスします。<br/>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://chrome.google.com/webstore/detail/mpurse/ljkohnccmlcpleonoiabgfggnhpkihaa'); } }
                    >
                      Mpurse - Google Chrome版
                    </button>
                  </div>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://addons.mozilla.org/ja/firefox/addon/mpchain_mpurse/'); } }
                    >
                      Mpurse - Firefox版
                    </button>
                  </div>
                  <br/>
                  <br/>
                  ここでは、Chrome版のインストールを説明します。<br/>
                  「Chromeに追加」をクリックします。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse02} />
                </div>
                <div className='width50 marginSide1 '>
                  「拡張機能を追加」をクリックします。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse03} />
                </div>
                <div className='width50 marginSide1 '>
                  MpurseがChromeに追加されました。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse04} />
                </div>
                <div className='width50 marginSide1 '>
                  ブラウザ右上の、パズルのピースのようなアイコンをクリックします。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse05} />
                </div>
                <div className='width50 marginSide1 '>
                  Mpurseの右にあるピンのアイコンをクリックします。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse06} />
                </div>
                <div className='width50 marginSide1 '>
                  ブラウザ右上に、Mpurseのアイコンが追加されました。<br/>
                  このアイコンをクリックします。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse07} />
                </div>
                <div className='width50 marginSide1 '>
                  「同意」をクリックします。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse08} />
                </div>
                <div className='width50 marginSide1 '>
                  Mpurseを開くときのパスワードを設定します。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse09} />
                </div>
                <div className='width50 marginSide1 '>
                  パスフレーズ(ニーモニック)が表示されます。<br/>
                  このパスフレーズを順序通りに紙にメモしてください。<br/>
                  <span className='backgroundColorRed'>このパスフレーズを失くしてしまうと、ウォレットを復元することができません。<br/>
                  このパスフレーズを他人に知られてしまうと、ウォレットの中身を奪われてしまいます。<br/></span>
                  パスフレーズは他人に見られないよう、大切に保管してください。<br/>
                  <br/>
                  しっかりメモし、間違いないか確認したら、チェックボックスにチェックを入れて「保存」をクリックしてください。
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse10} />
                </div>
                <div className='width50 marginSide1 '>
                  初期設定が完了しました。<br/>
                  アカウント名(「アカウント1」)の下に表示されている文字列がこのアカウントのアドレスになります。(クリックするとコピーできます。)<br/>
                  <br/>
                  また、右上のアイコンからアカウントの追加をすることもできます。
                </div>
              </div>
            </div>
            <div className='widthMax marginTopBottom1 marginSide2'>
              ■参考記事
              <div>
                <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                  onClick={ () => { window.open('https://tadajam.hateblo.jp/entry/2019/05/26/160533'); } }
                >
                  開発者(tadajamさん)のMpurseについての記事
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess' >
          <Header screen='howToUseMpurse' />
          <div className='flexColumn alignItemsCenter'>
            <div className='width93vw marginTopBottom1 '>
              <div className='font2'>
                Mpurseのインストール(スマホ版)
              </div>
              <div className='marginTop1'>
                もなこっとでは、モナコイン、モナカードをMpurseというウォレットで扱います。<br/>
                Mpurseはモナコイン版MetaMaskのようなもので、MetaMaskに慣れているひとであれば使い方はそれほど難しくないでしょう。
              </div>
            </div>
            <div className=''>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp01} />
                </div>
                <div className='width93vw  '>
                  Mpurseのダウンロードサイトにアクセスします。<br/>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://play.google.com/store/apps/details?id=info.mpchain.mpurse&pli=1'); } }
                    >
                      Mpurse - Andoroidアプリ版
                    </button>
                  </div>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://apps.apple.com/us/app/mpurse/id1494156643'); } }
                    >
                      Mpurse - iOSアプリ版
                    </button>
                  </div>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://addons.mozilla.org/ja/firefox/addon/mpchain_mpurse/'); } }
                    >
                      Mpurse - Firefox版
                    </button>
                  </div>
                  <br/>
                  <br/>
                  ここでは、iOSアプリ版のインストールを説明します。<br/>
                  アプリをインストールし、起動します。
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp02} />
                </div>
                <div className='width93vw'>
                  「カスタムシード」をクリックします。
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp03} />
                </div>
                <div className='width93vw'>
                  Mpurseを開くときのパスワードを設定します。
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp04} />
                </div>
                <div className='width93vw'>
                  シードフレーズ(ニーモニック)が表示されます。<br/>
                  このシードフレーズを順序通りに紙にメモしてください。<br/>
                  <span className='backgroundColorRed'>このパスフレーズを失くしてしまうと、ウォレットを復元することができません。<br/>
                  このシードフレーズを他人に知られてしまうと、ウォレットの中身を奪われてしまいます。<br/></span>
                  シードフレーズは他人に見られないよう、大切に保管してください。<br/>
                  <br/>
                  しっかりメモし、間違いないか確認したら、チェックボックスにチェックを入れて「OK」をクリックしてください。
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp05} />
                </div>
                <div className='width93vw'>
                  初期設定が完了しました。<br/>
                  アカウント名(「アカウント1」)の下に表示されている文字列がこのアカウントのアドレスになります。(クリックするとコピーできます。)<br/>
                  <br/>
                  また、中央上部のアイコンからアカウントの追加をすることもできます。
                </div>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width96vw marginTopBottom1 '>
              <div>
                ■参考記事
                <div>
                  <button className='fontHyperLink borderNone backgroundColorTransparent cursor textLeft '
                    onClick={ () => { window.open('https://tadajam.hateblo.jp/entry/2019/05/26/160533'); } }
                  >
                    開発者(tadajamさん)のMpurseについての記事
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  else // english
  {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore' >
          <Header screen='howToUseMpurse' />
          <div className='flexColumn alignItemsCenter'>
            <div className='widthMax marginTopBottom1 marginSide2'>
              <div className='font2'>
                Installing Mpurse
              </div>
              <div className='marginTop1'>
                In monacotto, Monacoin and Monacards are handled in a wallet "Mpurse."<br/>
                Mpurse is like a Monacoin version of MetaMask, and if you are familiar with MetaMask, it is not too difficult to use.
              </div>
            </div>
            <div className='marginTopBottom1'>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='width50' src={imageManualMpurse01} />
                </div>
                <div className='width50  '>
                  Go to the Mpurse download site.<br/>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://chrome.google.com/webstore/detail/mpurse/ljkohnccmlcpleonoiabgfggnhpkihaa'); } }
                    >
                      Mpurse - Google Chrome version
                    </button>
                  </div>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://addons.mozilla.org/ja/firefox/addon/mpchain_mpurse/'); } }
                    >
                      Mpurse - Firefox version
                    </button>
                  </div>
                  <br/>
                  <br/>
                  This section describes the installation of the Chrome version.<br/>
                  Click "Add to Chrome."
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse02} />
                </div>
                <div className='width50 marginSide1 '>
                  Click "Add Extension."
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse03} />
                </div>
                <div className='width50 marginSide1 '>
                  Mpurse has been added to Chrome.
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse04} />
                </div>
                <div className='width50 marginSide1 '>
                  Click the icon in the upper right corner of the browser that looks like a puzzle piece.
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse05} />
                </div>
                <div className='width50 marginSide1 '>
                  Click the pin icon to the right of Mpurse.
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse06} />
                </div>
                <div className='width50 marginSide1 '>
                  An Mpurse icon has been added to the upper right corner of your browser.<br/>
                  Click this icon.
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse07} />
                </div>
                <div className='width50 marginSide1 '>
                  Click "Agree."
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse08} />
                </div>
                <div className='width50 marginSide1 '>
                  Set the password for opening Mpurse.
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse09} />
                </div>
                <div className='width50 marginSide1 '>
                  A passphrase(mnemonic) will appear.<br/>
                  Write this passphrase down on a piece of paper in the correct order.<br/>
                  <span className='backgroundColorRed'>If you lose this passphrase, you will not be able to recover your wallet.<br/>
                  If someone else learns this passphrase, the asset in your wallet will be taken away from you.<br/></span>
                  Please keep your passphrase in a safe place so that others cannot see it.<br/>
                  <br/>
                  After writing it down carefully and making sure it is correct, check the box and click "Save."
                </div>
              </div>
              <div className='flexRow justifyContentCenter marginTopBottom1 borderMonacotto padding1 ' >
                <div className='flexRow justifyContentCenter width50 marginSide1'>
                  <img className='' src={imageManualMpurse10} />
                </div>
                <div className='width50 marginSide1 '>
                  The initial setup is complete.<br/>
                  The string displayed under the account name("Account 1") is the address for this account. (You can copy it by clicking it.)<br/>
                  <br/>
                  You can also add an account from the icon in the upper right corner.
                </div>
              </div>
            </div>
            <div className='widthMax marginTopBottom1 marginSide2'>
              - reference article
              <div>
                <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                  onClick={ () => { window.open('https://tadajam.hateblo.jp/entry/2019/05/26/160533'); } }
                >
                  Developer's(tadajam's) article about Mpurse (Japanese)
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess' >
          <Header screen='howToUseMpurse' />
          <div className='flexColumn alignItemsCenter'>
            <div className='width93vw marginTopBottom1 '>
              <div className='font2'>
                Installing Mpurse<br/>
                (Smartphone version)
              </div>
              <div className='marginTop1'>
                In monacotto, Monacoin and Monacards are handled in a wallet "Mpurse."<br/>
                Mpurse is like a Monacoin version of MetaMask, and if you are familiar with MetaMask, it is not too difficult to use.
              </div>
            </div>
            <div className=''>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp01} />
                </div>
                <div className='width93vw  '>
                  Go to the Mpurse download site.<br/>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://play.google.com/store/apps/details?id=info.mpchain.mpurse&pli=1'); } }
                    >
                      Mpurse - Andoroid application version
                    </button>
                  </div>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://apps.apple.com/us/app/mpurse/id1494156643'); } }
                    >
                      Mpurse - iOS application version
                    </button>
                  </div>
                  <div>
                    <button className='fontHyperLink borderNone backgroundColorTransparent cursor '
                      onClick={ () => { window.open('https://addons.mozilla.org/ja/firefox/addon/mpchain_mpurse/'); } }
                    >
                      Mpurse - Firefox version
                    </button>
                  </div>
                  <br/>
                  <br/>
                  This section describes the installation of the iOS application version.<br/>
                  Install and launch the application.
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp02} />
                </div>
                <div className='width93vw'>
                  Click on "Custom Seed."
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp03} />
                </div>
                <div className='width93vw'>
                  Set the password for opening Mpurse.
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp04} />
                </div>
                <div className='width93vw'>
                  A seedphrase(mnemonic) will appear.<br/>
                  Write this seedphrase down on a piece of paper in the correct order.<br/>
                  <span className='backgroundColorRed'>If you lose this seedphrase, you will not be able to recover your wallet.<br/>
                  If someone else learns this seedphrase, the asset in your wallet will be taken away from you.<br/></span>
                  Please keep your seedphrase in a safe place so that others cannot see it.<br/>
                  <br/>
                  After writing it down carefully and making sure it is correct, check the box and click "OK."
                </div>
              </div>
              <div className='flexColumn alignItemsCenter width96vw marginTopBottom1 borderMonacotto ' >
                <div className='marginTopBottom1'>
                  <img className='width60vw' src={imageManualMpurseSp05} />
                </div>
                <div className='width93vw'>
                  The initial setup is complete.<br/>
                  The string displayed under the account name("Account 1") is the address for this account. (You can copy it by clicking it.)<br/>
                  <br/>
                  You can also add an account from the icon in the top center.
                </div>
              </div>
            </div>
            <div className='flexColumn alignItemsFlexStart width96vw marginTopBottom1 '>
              - reference article
              <div>
                <button className='fontHyperLink borderNone backgroundColorTransparent cursor textLeft'
                  onClick={ () => { window.open('https://tadajam.hateblo.jp/entry/2019/05/26/160533'); } }
                >
                  Developer's(tadajam's) article about Mpurse (Japanese)
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// TEXT LINE MULTI LAYERS STATE ON PRESS KEY
function TextLine3(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const type = props.type !== undefined ? props.type : 'setStateMultiLayers';

  let value = props.keys.reduce( (acc, cur) => { return acc[cur]; }, state );
  if (type === 'setStateMultiLayersFloat') {
    value = value.face;
  }

  let tooltipClass;

  if (props.tooltip === 'left') {
    tooltipClass = 'tooltipLeft breakAll'
  }
  else if (props.tooltip === 'leftLong') {
    tooltipClass = 'tooltipLeft'
  }
  else if (props.tooltip === 'right') {
    tooltipClass = 'tooltipRight breakAll'
  }
  else if (props.tooltip === 'rightLong') {
    tooltipClass = 'tooltipRight'
  }
  else if (props.tooltip === false) {
    tooltipClass = 'invisible'
  }
  else if (props.tooltip !== undefined) {
    tooltipClass = 'tooltipRight'
  }
  else {
    tooltipClass = 'invisible'
  }

  let disabled;
  if (props.disabled) {
    disabled = true;
  }
  else {
    disabled = false;
  }

  return (
    <div>
            <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Background'} type='checkbox' />
            <div className='box1 widthWithButton1NarrowSp'
              onMouseEnter={ () => {
                if (props.tooltip !== undefined && props.tooltip !== false && value !== undefined && value !== null && value !== '') {
                  document.getElementById('UVCB_' + props.fieldName + 'Tooltip').checked=true; 
                }
              }}
              onMouseLeave={ () => {
                if (props.tooltip !== undefined && props.tooltip !== false) {
                  document.getElementById('UVCB_' + props.fieldName + 'Tooltip').checked=false; 
                }
              }}
            >
              <input className='textLine1' type="text" value={value} placeholder='' disabled={disabled}
                onFocus={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=true; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=true; 

                  if (props.tooltip !== undefined && props.tooltip !== false) {
                    document.getElementById('UVCB_' + props.fieldName + 'Tooltip').checked=false; 
                  }
                }}
                onBlur={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=false; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=false; 

                  if (type === 'setStateMultiLayersFloat') {
                    dispatch({type: 'adjustFace', keys: props.keys});
                  }
                }}
                onChange={ (e) => {
                  let targetValueAdjusted = e.target.value;

                  if (type === 'setStateMultiLayersFloat') {
                    targetValueAdjusted = adjustFloat(props.adjustType, e.target.value, props.adjustExp);
                  }

                  dispatch({type: type, keys: props.keys, value: e.target.value, adjustType: props.adjustType, adjustExp: props.adjustExp});

                  if (props.extraDispatch !== undefined) {
                    for (const aDispatch of props.extraDispatch) {
                      dispatch({type: aDispatch.type, keys: aDispatch.keys, value: e.target.value});
                    }
                  }

                  if (props.extraFunctionOnChange !== undefined) {
                    for (const aFunction of props.extraFunctionOnChange) {
                      let argumentsRevised = aFunction.arguments;

                      if (aFunction.targetValue !== undefined) {
                        argumentsRevised.splice(aFunction.targetValue === true ? argumentsRevised.length : aFunction.targetValue, 0, targetValueAdjusted);
                      }

                      devLog('argumentsRevised', argumentsRevised);
                      aFunction.function(...argumentsRevised);
                    }
                  }

                  if (props.tooltip !== undefined && props.tooltip !== false) {
                    document.getElementById('UVCB_' + props.fieldName + 'Tooltip').checked=false; 
                  }
                }}
                onKeyPress={ (e) => {
                  if (e.which === props.keyNo) {
                    if (props.onKeyPressFunction !== undefined) {
                      props.onKeyPressFunction();
                    }
                  }
                }}
              />
              <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Label'} type='checkbox' />
              <div className={ value === undefined || value === '' || value === null ? 'label1Unfilled' : 'label1Filled'}>
                {props.face}
              </div>
              <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Tooltip'} type='checkbox' />
              <div className={tooltipClass} >
                {value}
              </div>
            </div>
    </div>
  );
}

// TEXT AREA MULTI LAYERS STATE
function TextArea2(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const value = props.keys.reduce( (acc, cur) => { return acc[cur]; }, state );
  const type = props.type !== undefined ? props.type : 'setStateMultiLayers';

  return (
    <div className={'flexColumn alignItemsCenter ' + props.outerClass}>
            <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Background'} type='checkbox' />
            <div className={props.boxClass} style={props.boxStyle} >
              <textarea className={props.textAreaClass} value={value}
                onFocus={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=true; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=true; 
                }}
                onBlur={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=false; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=false; 
                }}
                onChange={ (e) => {
                  dispatch({type: type, keys: props.keys, value: e.target.value});

                  if (props.extraFunctionsOnChange !== undefined) {
                    for (const extraFunction of props.extraFunctionsOnChange) {
                      let argumentsRevised = extraFunction.arguments;

                      if (extraFunction.targetValue !== undefined) {
                        argumentsRevised.splice(extraFunction.targetValue === true ? argumentsRevised.length : extraFunction.targetValue, 0, e.target.value);
                      }

                      extraFunction.function(...argumentsRevised);
                    }
                  }
                }}
              />
              <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Label'} type='checkbox' />
              <div className={ value === '' ? 'label1Unfilled' : 'label1Filled'}>
                {props.face}
              </div>
            </div>
    </div>
  );
}


function handleClickMpurse(state, dispatch, stateKeys, popupLayer) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;

  const callback = (keyPairs) => {
    const keyPair = keyPairs[0];
    const result = getAddressFromKey(state, dispatch, keyPair);

    if (result.status === 'fulfilled') {
      const address= result.address;
      dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: address });
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    keepKeyPairsInMemory(state, dispatch, keyPairs);
  };

  if (state.walletType === 'mpurse') {
    if (window.mpurse) {
      window.mpurse.getAddress()
      .then( (result) => {
        dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: result });
      })
      .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
      });
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.activateMpurse[state.language] });
    }
  }
  else if (state.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    handleClickNfc(state, dispatch, callback);
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayerNext });
  }
}

// HANDLE CLICK VIEW SESSION
function handleClickViewSession(state, dispatch, popupLayer) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  let sessionAddresses = Object.keys(state.session);

  // if (addressHistory === undefined) {
  //   addressHistory = [];
  // }

  sessionAddresses = sessionAddresses.filter( address => state.session[address].expirationOfSession >= Date.now() )
  const records = sessionAddresses.map( address => <SessionRecord record={ {address} } /> );

  const popup = {
    type: 'generalList',
    body: {
      title: <SessionTitle />,
      options: records,
    },
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

  if (sessionAddresses.length === 0) {
    dispatch({ type: 'setState', key: 'session', value: {} });
  }
}

// 「ログイン」ボタン押下 HANDLE CLICK LOGIN
async function handleClickLogin(state, dispatch, cookies, setCookie, keyPairs, popupLayer, { noteToReload } = {}) {
  let request = {};
  let messages = {};
  let certifications = [];
  const popupLayerNext = (popupLayer !== undefined && popupLayer !== null) ? (popupLayer + 1) : 0;
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.login.addressMain,
    signatureVersion: state.config.clientParameters.signatureVersion.login,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。
  devLog('session', JSON.stringify(state.session));
  devLog('session keys', JSON.stringify(Object.keys(state.session)));

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        // addressCoinType: stateFixed[address].addressCoinType,
        address: address,
        sessionId: stateFixed[address].sessionId,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs(state, dispatch);

  if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' && keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey(state, dispatch, [ keyPairsInPool[stateFixed.addressMain].keyPair ], 'login', stateFixed, certifications, now, null, 'matchedKey');
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    // 鍵ペアが渡され、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。
    certificationWithKey(state, dispatch, keyPairs, 'login', stateFixed, certifications, now, null, 'firstKey');
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain(state, dispatch, stateFixed, certifications, now, null, 'login');
  }

  // 対象がなければ戻る。
  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToLogin[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      "certifications": certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/login_and_reload';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'user', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      let balance;
      let assets;
      let assetInfo;
      let result;

      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }

      if (response.body[address]['certificatedBy'] === 'signature' || response.body[address]['certificatedBy'] === 'sessionId') {
        // privateInformationをセット
        dispatch({ type: 'setStateMultiLayers', keys: ['privateInformation', address], value: response.body[address].basicInformation });

        // 保有アセット取得
        result = await getBalancesKOM(state, dispatch, address)
        .then( async (balance) => {
          const assets = Object.keys(balance);

          // アセット情報取得
          return {
            assets,
            assetInfos: getAssetInfo(state, dispatch, assets),
          };
        })
        .then( async ({ assets, assetInfos }) => {
          // モナカード情報取得
          const assetCommons = assets.map( asset => assetInfos[asset].asset_longname === null ? asset : assetInfos[asset].asset_longname );
          getMonacard(state, dispatch, assetCommons);
        })
        .catch( (error) => {
          // そのまま消滅
        });

        // ノート情報取得

        // -- 認証状態に変化したので、loadedをfalseにする。

        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'popupDisplay', address], value: false });
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', address], value: {} });

        if (noteToReload?.screen === 'note' && address === noteToReload.addressMain) {
          getNote({
            dispatch,
            searchType: 'specificMyOwnNotes',
            addressesMain: [noteToReload.addressMain],
            noteNos: [noteToReload.noteNo],
            session: state.session,
            marginOfSessionTime: state.marginOfSessionTime,
            notes: state.notes,
          })
          .then( result => {
            const notes = result[noteToReload.addressMain].notes;

            const components = notes.map( note => {
              return ['components', 'popupDisplay'].map( componentContainer => {
                return getComponents({
                  note,
                  componentContainer,
                  session: state.session,
                  marginOfSessionTime: state.marginOfSessionTime,
                });
              }).flat();
            }).flat();

            getUserResource({
              dispatch,
              userResources: components,
              session: state.session,
              marginOfSessionTime: state.marginOfSessionTime,
            });
          })
          .then( () => {
            // galleryに戻ったときに、note情報がクリアされてしまうから、特定ノートをlordedにしてはいけない。
            // const loadStatus = { [noteToReload.noteNo]: true };
            // dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', noteToReload.addressMain], value: loadStatus });
          })
          .catch( (error) => {
          })
        }

        if (noteToReload?.screen === 'gallery' && address === noteToReload.addressMain) {
          getNotesAndUserResources({
            dispatch,
            addressMain: noteToReload.addressMain,
            componentContainers: ['popupDisplay'],
            session: state.session,
            marginOfSessionTime: state.marginOfSessionTime,
            notes: state.notes,
          })
          .then( () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', noteToReload.addressMain], value: true });
          })
          .catch( (error) => {
          });
        }
      }
    }
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToLogin[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
    if (response.body[stateFixed.addressMain].certificatedBy === 'sessionId' || response.body[stateFixed.addressMain].certificatedBy === 'signature') {
      // 明示的ログインアドレスでログイン成功

      // 基本情報をconfigureにセット
      dispatch({ type: 'setState', key: 'configure', value: response.body[stateFixed.addressMain].basicInformation });

      // 各種stateにログインアドレスをセット
      if (state.exhibit.addressMain === undefined || state.exhibit.addressMain === null || state.exhibit.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'addressMain'], value: stateFixed.addressMain });
      }

      if (state.purchase.addressMain === undefined || state.purchase.addressMain === null || state.purchase.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['purchase', 'addressMain'], value: stateFixed.addressMain });
      }

      if (state.permit.addressMain === undefined || state.permit.addressMain === null || state.permit.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'addressOwner'], value: stateFixed.addressMain });
      }

      if (state.requestPermission.addressMain === undefined || state.requestPermission.addressMain === null || state.requestPermission.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['requestPermission', 'addressMain'], value: stateFixed.addressMain });
      }

      if (state.getHistory.addressMain === undefined || state.getHistory.addressMain === null || state.getHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.login.addressMain === undefined || state.login.addressMain === null || state.login.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['login', 'addressMain'], value: stateFixed.addressMain });
      }

      if (state.active.addressMain === undefined || state.active.addressMain === null || state.active.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['active', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'login',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }
    else {
      // 明示的ログインアドレスでログイン失敗

      if (response.body[stateFixed.addressMain].applicationMessage === 'not accept TAC yet.') {
        // ユーザー登録を促す。
        dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseRegisterAsAUser[state.language] });

        const popup = { type: 'userRegistrationPopup' };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }
      else if (response.body[stateFixed.addressMain].applicationMessage === 'you must accept the terms and conditions of the current version.') {
        // 基本情報をconfigureにセット（認証は成功しているので、規約同意しやすいように基本情報は埋めてあげる。）
        dispatch({ type: 'setState', key: 'configure', value: response.body[stateFixed.addressMain].basicInformation });

        if (response.body[stateFixed.addressMain].applicationMessageParameter.versionOfTheTermsAndConditions === state.config.clientParameters.versionOfTheTermsAndConditions) {
          // クライアントには最新バージョンがロードされているので、規約同意を促す。
          dispatch({ type: 'setNotification', key: 'notification', value: words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language] });

          const popup = { type: 'userRegistrationPopup' };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }
        else {
          // クライアントに最新バージョンがロードされていないので、ブラウザリロードと規約同意を促す。
          dispatch({ type: 'setNotification', key: 'notification', value: words.youMustReloadYourBrowserAndAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language] });
        }
      }
      else if (response.body[stateFixed.addressMain].applicationMessage === 'you must accept the privacy policy of the current version.') {
        // 基本情報をconfigureにセット（認証は成功しているので、プライバシーポリシーに同意しやすいように基本情報は埋めてあげる。）
        dispatch({ type: 'setState', key: 'configure', value: response.body[stateFixed.addressMain].basicInformation });

        if (response.body[stateFixed.addressMain].applicationMessageParameter.versionOfPrivacyPolicy === state.config.clientParameters.versionOfPrivacyPolicy) {
          // クライアントには最新バージョンがロードされているので、プライバシーポリシーへの同意を促す。
          dispatch({ type: 'setNotification', key: 'notification', value: words.youMustAcceptThePrivacyPolicyOfTheCurrentVersion[state.language] });

          const popup = { type: 'userRegistrationPopup' };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }
        else {
          // クライアントに最新バージョンがロードされていないので、ブラウザリロードとプライバシーポリシーへの同意を促す。
          dispatch({ type: 'setNotification', key: 'notification', value: words.youMustReloadYourBrowserAndAcceptThePrivacyPolicyOfTheCurrentVersion[state.language] });
        }
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.youFailedToLogin[state.language] });
      }
    }
  }
  else {
  }
}

// 「設定」ボタン押下 HANDLE CLICK SETUP
async function handleClickSetup(state, dispatch, cookies, setCookie, keyPairs) {
  let addressMainActual;
  let signature;
  let result;

  // state固定
  const stateFixed = {
    addressMain: state.configure.addressMain,
    addressCardFromDefault: state.configure.addressCardFromDefault,
    addressPayProceedsToDefault: state.configure.addressPayProceedsToDefault,
    addressPayFromDefault: state.configure.addressPayFromDefault,
    addressSendCardToDefault: state.configure.addressSendCardToDefault,
    userName: state.configure.userName,
    homed: state.configure.homed,
    profileText: state.configure.profileText,
    imageMain: state.configure.imagesNew.main,
    acceptedVersionOfTheTermsAndConditions: state.configure.acceptedVersionOfTheTermsAndConditions,
    acceptedVersionOfPrivacyPolicy: state.configure.acceptedVersionOfPrivacyPolicy,
    signatureVersion: state.config.clientParameters.signatureVersion.configure,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // if (keyPairs !== undefined && keyPairs !== null) {
  //   keyPair = keyPairs[0];
  //   const result = getAddressFromKey(state, dispatch, keyPair);

  //   if (result.status === 'fulfilled') {
  //     stateFixed.addressMain = result.address;
  //   }
  //   else {
  //     dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
  //     return 'rejected';
  //   }
  // }

  // 必須項目チェック
  // if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
  //   dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressMustBeFilled[state.language] });
  //   return;
  // }

  if (stateFixed.userName === undefined || stateFixed.userName === null || stateFixed.userName === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.userNameMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.acceptedVersionOfTheTermsAndConditions === undefined ||
      stateFixed.acceptedVersionOfTheTermsAndConditions === null ||
      stateFixed.acceptedVersionOfTheTermsAndConditions === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.acceptTheTermsAndConditions[state.language] });
    return;
  }

  if (stateFixed.acceptedVersionOfPrivacyPolicy === undefined ||
      stateFixed.acceptedVersionOfPrivacyPolicy === null ||
      stateFixed.acceptedVersionOfPrivacyPolicy === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.acceptThePrivacyPolicy[state.language] });
    return;
  }

  const clientTime = Date.now();

  const getMessage = (addressMain) => {
    return `I want to use monacotto. My main address is ${addressMain}. My name is ${stateFixed.userName}. I will send cards from ${stateFixed.addressCardFromDefault} and I want to receive proceeds in ${stateFixed.addressPayProceedsToDefault} as default. I will pay from ${stateFixed.addressPayFromDefault} and I want to receive cards in ${stateFixed.addressSendCardToDefault} as default. I accept the terms and conditions version ${stateFixed.acceptedVersionOfTheTermsAndConditions} and privacy policy version ${stateFixed.acceptedVersionOfPrivacyPolicy}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
  }

  const keyPairsInPool = getValidKeyPairs(state, dispatch);

  if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' && keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    const keyPair = keyPairsInPool[stateFixed.addressMain].keyPair;
    addressMainActual = stateFixed.addressMain;

    const result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressMain));

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair);

    if (result.status === 'fulfilled') {
      addressMainActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    // addressMainが指定されていれば、アドレスチェックを行う。
    // 指定されていなければ、addressMainActualをaddressMainとして扱う。
    if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
      if (!checkIfAddressIsMatchedWithAnAddress(state, dispatch, addressMainActual, stateFixed.addressMain, stateFixed.addressCheck)) {
        return { status: 'rejected' };
      }
    }
    else {
      stateFixed.addressMain = addressMainActual;
    }

    result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressMain));

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressMainActual = result;

      // addressMainが指定されていれば、アドレスチェックを行う。
      // 指定されていなければ、addressMainActualをaddressMainとして扱う。
      if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
        if (!checkIfAddressIsMatchedWithAnAddress(state, dispatch, addressMainActual, stateFixed.addressMain, stateFixed.addressCheck)) {
          return 'rejected';
        }
      }
      else {
        stateFixed.addressMain = addressMainActual;
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(getMessage(stateFixed.addressMain)).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return;
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！
  const resultConfigure = await configure(state, stateFixed, dispatch, cookies, setCookie, 'upsert', clientTime, signature, addressMainActual);
}

async function configure(state, stateFixed, dispatch, cookies, setCookie, method, clientTime, signature, addressMainActual) {
  let request = {};
  let messages = {};

  const formData = new FormData();

  const requestJson = JSON.stringify({
    "body": {
      "method": method,
      "addressMain": stateFixed.addressMain,
      "addressMainActual": addressMainActual,
      "addressCardFromDefault": stateFixed.addressCardFromDefault,
      "addressPayProceedsToDefault": stateFixed.addressPayProceedsToDefault,
      "addressPayFromDefault": stateFixed.addressPayFromDefault,
      "addressSendCardToDefault": stateFixed.addressSendCardToDefault,
      "userName": stateFixed.userName,
      "homed": stateFixed.homed,
      "profileText": stateFixed.profileText,
      "acceptedVersionOfTheTermsAndConditions": stateFixed.acceptedVersionOfTheTermsAndConditions,
      "acceptedVersionOfPrivacyPolicy": stateFixed.acceptedVersionOfPrivacyPolicy,
      "clientTime" : clientTime,
      "signature" : signature,
      "signatureVersion" : stateFixed.signatureVersion,
    }
  });

  formData.append('json', requestJson);

  if (stateFixed.imageMain !== undefined && stateFixed.imageMain !== null) {
    formData.append('imageMain', stateFixed.imageMain, stateFixed.imageMain.name);
  }

  request.body = formData;
  request.headers = {};
  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/configure';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "you are not delegated.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    "addressMainActual must be filled.": words.clearYourBrowserOrAppCache[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': response.body.sessionId.addressMain, 'expirationOfSession': response.body.expirationOfSession.addressMain} });

    if (addressMainActual !== stateFixed.addressMain) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual], value: {'sessionId': response.body.sessionId.addressMainActual, 'expirationOfSession': response.body.expirationOfSession.addressMainActual} });
    }

    // addressMainが指定されていなかった場合は、dispatchする。
    if (state.configure.addressMain === undefined || state.configure.addressMain === null || state.configure.addressMain === '') {
      dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'addressMain'], value: stateFixed.addressMain });
    }

    if (state.active.addressMain === undefined || state.active.addressMain === null || state.active.addressMain === '') {
      dispatch({ type: 'setStateMultiLayers', keys: ['active', 'addressMain'], value: stateFixed.addressMain });
    }

    // オーダーNo.通知欄表示
    // dispatch({ type: 'setNotification', key: 'notification', value: words.orderAcceptedOrderNo[state.language] + response.body.orderNo + words.orderAcceptedOrderNo2[state.language] });

    // -- ユーザ情報取得
    const usersGeneral = await getUser({ dispatch, getType: 'all' });
    devLog('usersGeneral', JSON.stringify(usersGeneral));

    let usersGeneralIndex = {};

    for (const user of usersGeneral.body) {
      usersGeneralIndex[user.addressMain] = user;
    }

    dispatch({ type: 'setState', key: 'usersGeneralIndex', value: usersGeneralIndex });

    // cookie情報更新(アドレス情報)
    const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    const cookiesNew = [
          {
            action: 'setUp',
            addressType: 'addressMain',
            description: `${userName}`,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}


// CHECK MPURSE ADDRESS
async function checkMpurseAddress(state, dispatch, stateFixed, addressFirst) {
  // Mpurseのアドレスが合ってるかチェック
  const result = await window.mpurse.getAddress()
  .then( (result) => {
    const addressActual = result;

    if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
      if (addressActual !== stateFixed[addressFirst]) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return { status: 'rejected' };
      }
      else {
        return { status: 'fulfilled', addressActual: addressActual };
      }
    }
    else { // off
      return { status: 'fulfilled', addressActual: addressActual };
    }
  })
  .catch( (error) => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
      return { status: 'rejected' };
  });

  return result;
}


// SET SIGNATURE BY MAIN ADDRESS
async function setSignatureByAddressMain(state, dispatch, stateFixed, certifications, clientTime, extendedCertificationProperties, messageType) {
  // アクティブなMONAアドレスが有り、そのアドレスがcertificationsに含まれていなければ、署名する。
  // if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== '' && !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)) {
    // -- Mpurseのアドレス取得
    const result = await window.mpurse.getAddress()
    .then( async (result) => {
      const addressActual = result;
      let address;

      // lastEvaluatedSortKey等があるということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
        if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
          if (addressActual !== stateFixed.addressMain) {
            dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressAndTheAddressInWalletAreDifferent[state.language] });
            return 'rejected';
          }
          else {
            // 続行
          }
        }
        else { // off
          // 続行
        }

        address = stateFixed.addressMain;
      }
      else {
        address = addressActual;
        stateFixed.addressMain = addressActual;
      }

      devLog('address', address);
      devLog('certifications', JSON.stringify(certifications));

      if (!certifications.map( certification => certification.address ).includes(address)) {
      devLog('sign');
        let message;

        if (messageType === 'login') {
          message = `I want to log in to monacotto as ${address}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
        }
        else if (messageType === 'information') {
          message = `I want to get the information of ${address}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
        }

        devLog('message', message);

        let signatureMona;

        try {
          signatureMona = await window.mpurse.signMessage(message).then( result => result );

          const certification = {
            // addressCoinType: 'mona',
            address: address,
            addressActual: addressActual,
            clientTime: clientTime,
            signatureVersion: stateFixed.signatureVersion,
            signature: signatureMona,
            lastEvaluatedSortKey: stateFixed.lastEvaluatedSortKey,
          };

          // 拡張プロパティ
          if (extendedCertificationProperties !== undefined && extendedCertificationProperties !== null) {
            for (const property of extendedCertificationProperties) {
              certification[property.key] = property.value;
            }
          }

          devLog('certification addressMain', JSON.stringify(certification));

          certifications.push(certification);
        }
        catch (err) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
        }
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
    });
  // }
}


// 「出品キャンセル:クリア」ボタン押下
async function handleClickClearCancelExhibit(state, dispatch) {
  dispatch({ type: 'setState', key: 'cancelExhibit',
    value: {
      exhibitNo: '',
      addressMain: '',
      amountFree: null,
      signatureByAddressMainCancel: null,
      status: 'waitingForSignature',
    }
  });

  return;
}

// 「出品変更:クリア」ボタン押下
async function handleClickClearChangeExhibit(state, dispatch) {
  dispatch({ type: 'setState', key: 'changeExhibit',
    value: {
      exhibitNo: null,
      addressMain: '',
      addressPayProceedsTo: '',
      amountToSell: null,
      priceMona: { face: '', value: '' },
      priceMonaWatanabe: '',
      signatureByAddressMainChange: null,
      status: 'waitingForSignature',
    }
  });

  return;
}

// HANDLE CLICK REPLACE ITEM
async function handleClickReplaceItem(state, dispatch) {
  let request = {};
  let messages = {};
  let certification = {};
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.gallery.addressMain,
    roomNo: 1,
    items: state.items[state.gallery.addressMain].itemPlacement[0].items,
    updateTime: state.items[state.gallery.addressMain].itemPlacement[0].updateTime,
    [state.gallery.addressMain]: {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[state.gallery.addressMain].sessionId, // ボタン押せたってことは定義されてるってことなんだけど。
      expirationOfSession: state.session[state.gallery.addressMain].expirationOfSession,
    },
    signatureVersion: state.config.clientParameters.signatureVersion.replaceItem,
    addressCheck: state.addressCheck,
  };

  // メインアドレスのセッションが存在しない、または、期限が切れていれば、署名する。

  if ( stateFixed[stateFixed.addressMain] === undefined || stateFixed[stateFixed.addressMain].expirationOfSession < now + marginOfSessionTime ) {

    // -- Mpurseのアドレス取得
    const result = await window.mpurse.getAddress()
    .then( async (result) => {
      const addressActual = result;
      const clientTimeMona = now;

      if (stateFixed.addressCheck === 'strict' || stateFixed.addressCheck === 'addressSecond') {
        if (addressActual !== stateFixed.addressMain) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          // 続行
        }
      }
      else { // off
        // 続行
      }

      const message = `I want to get the information of ${stateFixed.addressMain}. (epoch time: ${clientTimeMona}, signature version: ${stateFixed.signatureVersion})`;
      devLog('message', message);

      let signatureMona;

      try {
        signatureMona = await window.mpurse.signMessage(message).then( result => result );

        certification = {
          // addressCoinType: 'mona',
          address: stateFixed.addressMain,
          addressActual: addressActual,
          clientTime: clientTimeMona,
          signatureVersion: stateFixed.signatureVersion,
          signature: signatureMona,
        };
      }
      catch (err) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
        return 'rejected';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      throw new Error('failed to get address from mpurse.');
    }
  }
  else if ( stateFixed[stateFixed.addressMain] === undefined || stateFixed[stateFixed.addressMain].expirationOfSession >= now + marginOfSessionTime ) { // セッションが有効
    certification = {
      // addressCoinType: stateFixed[address].addressCoinType,
      address: stateFixed.addressMain,
      sessionId: stateFixed[stateFixed.addressMain].sessionId,
    };
  }

  // GO！

  request.body = JSON.stringify({
    body: {
      certification: certification,
      roomNo: stateFixed.roomNo,
      items: stateFixed.items,
      updateTime: stateFixed.updateTime,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/replace_item';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "success": words.success[state.language],
  };

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  for (const address of Object.keys(response.body)) {
    // 署名した場合もろもろ更新
    if (response.body[address]['certificatedBy'] === 'signature') {

      // session更新
      dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
        value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
    }
    else if (response.body[address]['certificatedBy'] === 'none') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
    }
  }

  if ( response.status === 'fulfilled' ) {
    // itemPlacement情報更新
    dispatch({ type: 'setStateMultiLayersNum', keys: ['items', stateFixed.addressMain, 'itemPlacement', 0, 'updateTime'],
               value: response.body[stateFixed.addressMain].itemPlacement.updateTime });

    // オーダーNo.通知欄表示
    // dispatch({ type: 'setNotification', key: 'notification', value: words.orderAcceptedOrderNo[state.language] + response.body.orderNo + words.orderAcceptedOrderNo2[state.language] });
  }
  else {
    devLog('error', JSON.stringify(response));
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToUpdate[state.language] });
    throw new Error('failed to update item placement.');
  }

  /*
  // session情報更新
  if (response.body !== undefined) {
    if (response.body[stateFixed.addressMain]['certificatedBy'] === 'signature') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {
        'sessionId': response.body[stateFixed.addressMain].sessionId,
        'expirationOfSession': response.body[stateFixed.addressMain].expirationOfSession,
      } });
    }
    else if (response.body[stateFixed.addressMain]['certificatedBy'] === 'none') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: { expirationOfSession: 0 } });
    }
  }
  */

  return response.body;
}

// DEPRECATED
// eslint-disable-next-line no-unused-vars
async function _getConfig(dispatch, keys) {
  let request = {};
  let messages = {};

  request.body = JSON.stringify({
    "body": {
      "keys": keys,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_client_parameter';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, 'config', undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return response;
  }
  else {
  }
}

async function getConfig(dispatch, project, keys, stateKey) {
  let request = {};
  let messages = {};

  request.body = JSON.stringify({
    body: {
      project: project,
      keys: keys,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_client_parameter';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, stateKey, undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return {
      status: 'fulfilled',
      body: response,
    };
  }
  else {
    return {
      status: 'rejected',
    };
  }
}

// GET ASSET INFO
async function getAssetInfo(state, dispatch, assets, indexAsset_longname) {
  let assetInfosArray;
  const assetInfos = state.assetInfo;
  const request = {};
  const bodyObj = {
    jsonrpc: "2.0",
    id: 0,
    method: "get_assets_info",
    params: {
      assetsList: assets,
    }
  };

  request.url = 'https://monapa.electrum-mona.org/_api';
  // request.url = 'https://wallet.monaparty.me/_api';
  // request.url = 'https://counterblock.api.monaparty.me/';
  request.method = 'POST';
  // request.body = `{"jsonrpc":"2.0","id":0,"method":"get_assets_info","params":{"assetsList":["${tokenName}"]}}`;
  request.body = JSON.stringify(bodyObj);

  devLog('get asset info; request', JSON.stringify(request));

  const response = await syncHttpRequest(request);
  devLog('get asset info; response', JSON.stringify(response));

  if (response.status === 'rejected') {
    // return { status: 'rejected' };
    throw new Error('rejected to get asset info');
  }
  else if (response.body.error !== undefined) {
    // -- 失敗　エラー返却
    // return { status: 'rejected', error: response.body.error };
    throw new Error('rejected to get asset info; ' + response.body.error);
  }
  else if (response.body.result.length === 0) {
    // -- そんなトークンは存在しない
    assetInfosArray = response.body.result;
  }
  else {
    // -- 成功
    assetInfosArray = response.body.result;
  }

  // state格納
  for (const assetInfo of assetInfosArray) {
    assetInfos[assetInfo.asset] = assetInfo;

    if (indexAsset_longname) {
      assetInfos[assetInfo.asset_longname] = assetInfo;
    }
  }

  dispatch({ type: 'setState', key: 'assetInfo', value: assetInfos });

  if (assetInfosArray.length === 0) {
    // return { status: 'notFound', body: {} };
    return {};
  }
  else {
    // return { status: 'fulfilled', body: assetInfos };
    return assetInfos;
  }
}

// GET MONACARD
async function getMonacard(state, dispatch, assets) {
//  const tokenNamesCSV = tokenNames.reduce( (acc, cur) => `${acc},${cur}`, '' );

  const assetCsvsDivided = [];
  let csv = '';

  for (const asset of assets) {
    if ( (new Blob([csv])).size > 1700 ) {
      assetCsvsDivided.push(csv);
      csv = '';
    }

    csv += ',' + asset;
  }

  assetCsvsDivided.push(csv);

  let request = {};
  let response;
  let monacardsArray = [];
  let monacards = state.monacard;

  request.method = 'GET';
  request.body = undefined;

  for (const assetCSV of assetCsvsDivided) {
    request.url = `https://card.mona.jp/api/card_detail?assets=${assetCSV}`
    devLog('get monacard; request', JSON.stringify(request));

    response = await syncHttpRequest(request);
    devLog('get monacard; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      return { status: 'rejected' };
    }
    else if (response.body.error !== undefined) {
      if (response.body.error.message === 'No matched assets.') {
//        return { status: 'notFound', body: [] };
      }
      else {
        return { status: 'rejected', error: response.body.error.message };
      }
    }
    else if (response.body.details === undefined) {
      return { status: 'rejected', error: 'details undefined' };
    }
    else {
      // -- get成功！
//      return { status: 'fulfilled', body: response.body.details };
      monacardsArray = monacardsArray.concat(response.body.details);
    }
  }

  // state格納
  for (const monacard of monacardsArray) {
    monacards[monacard.asset] = monacard;
  }

  dispatch({ type: 'setState', key: 'monacard', value: monacards });

  if (monacardsArray.length === 0) {
    return { status: 'notFound', body: [] };
  }
  else {
    return { status: 'fulfilled', body: monacards };
  }
}

// GET BALANCES
async function getBalances(state, dispatch, address) {
  let balancesArray =[];
  const balances = {};
  const request = {};
  const defaultLimit = state.config.clientParameters.counterparty.getTableDefaultLimit;
  let offset = 0;

  while (true) {
    let balancesArrayPartial;
    const bodyObj = {
      jsonrpc: "2.0",
      id: 0,
      method: "proxy_to_counterpartyd",
      params: {
        method: "get_balances",
        params: {
          filters: [
            {field: "address", op: "==", value: address}
          ],
          offset: offset,
          limit: defaultLimit,
        },
      }
    };

    request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';
    request.method = 'POST';
    request.body = JSON.stringify(bodyObj);

    devLog('get balances; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get balances; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      return { status: 'rejected' };
    }
    else if (response.body.error !== undefined) {
      // -- 失敗　エラー返却
      return { status: 'rejected', error: response.body.error };
    }
    else if (response.body.result.length === 0) {
      // -- そんなトークンは存在しない
      balancesArrayPartial = response.body.result;
    }
    else {
      // -- 成功
      balancesArrayPartial = response.body.result;
    }

    balancesArray = balancesArray.concat(balancesArrayPartial);

    if (balancesArrayPartial.length < defaultLimit) {
      break;
    }
    else {
      offset += defaultLimit;
    }
  }

  // state格納
  for (const balance of balancesArray) {
    balances[balance.asset] = balance;
  }

  dispatch({ type: 'setState', key: 'balance', value: balances });

  if (balancesArray.length === 0) {
    return { status: 'notFound', body: {} };
  }
  else {
    return { status: 'fulfilled', body: balances };
  }
}

// GET BALANCES KOM
async function getBalancesKOM(state, dispatch, address) {
  let balancesArray =[];
  const balances = {};
  const request = {};
  // const defaultLimit = state.config.clientParameters.counterparty.getTableDefaultLimit;
  const defaultLimit = 500;
  let offset = 0;

  while (true) {
    let balancesArrayPartial;
    const bodyObj = {
      jsonrpc: "2.0",
      id: 0,
      method: "proxy_to_counterpartyd",
      params: {
        method: "get_balances",
        params: {
          filters: [
            {field: "address", op: "==", value: address}
          ],
          offset: offset,
          limit: defaultLimit,
        },
      }
    };

    request.url = 'https://monapa.electrum-mona.org/_api';
    // request.url = 'https://wallet.monaparty.me/_api';
    // request.url = 'https://counterblock.api.monaparty.me/';
    request.method = 'POST';
    request.body = JSON.stringify(bodyObj);

    devLog('get balances; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get balances; response', JSON.stringify(response));

    if (response.status === 'rejected') {
      // return { status: 'rejected' };
      throw new Error('rejected to get balances');
    }
    else if (response.body.error !== undefined) {
      // -- 失敗　エラー返却
      // return { status: 'rejected', error: response.body.error };
      throw new Error('rejected to get balances; ' + response.body.error);
    }
    else if (response.body.result.length === 0) {
      // -- そんなトークンは存在しない
      balancesArrayPartial = response.body.result;
    }
    else {
      // -- 成功
      balancesArrayPartial = response.body.result;
    }

    balancesArray = balancesArray.concat(balancesArrayPartial);

    if (balancesArrayPartial.length < defaultLimit) {
      break;
    }
    else {
      offset += defaultLimit;
    }
  }

  // state格納
  for (const balance of balancesArray) {
    balances[balance.asset] = balance;
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['balanceKOM', address], value: balances });

  if (balancesArray.length === 0) {
    // return { status: 'notFound', body: {} };
    return {};
  }
  else {
    // return { status: 'fulfilled', body: balances };
    return balances;
  }
}

// GET REGISTERED CARD
async function getRegisteredCard(state, dispatch) {
  let request = {};
  let messages = {};
  const registeredCardsIndex = {};

  // state固定
  const stateFixed = {
  };

  request.body = JSON.stringify({
    "body": {
    }
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_registered_card';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);

  if ( response.status === 'rejected' ) {
    return {
      status: 'rejected',
    };
  }

  for (const registeredCard of response.body) {
    registeredCardsIndex[registeredCard.asset] = registeredCard;
  }

  dispatch({ type: 'setState', key: 'registeredCard', value: registeredCardsIndex });
  devLog('registeredCard', JSON.stringify(registeredCardsIndex));

  return {
    status: 'fulfilled',
    body: registeredCardsIndex,
  };
}

// モナカード情報結局
// GET MONACARD INFO AFTER ALL
function getMonacardInfoAfterAll(state, item, size) {
  let cardName;
  let cardOwnerName;
  let cardDescription;
  let cid;
  let cardImageUrl;
  let cardImageUrlSP;
  let isAMonacard;

  if (Object.keys(state.assetInfo).length >= 1) { // 分割取得した場合、完全には働かない。
    if (state.assetInfo[item.asset]?.description !== undefined && state.assetInfo[item.asset]?.description !== null && state.assetInfo[item.asset]?.description !== '') {
      try {
        const description = JSON.parse(state.assetInfo[item.asset].description);
        cardName = description.monacard.name;
        cardOwnerName = description.monacard.owner;
        cardDescription = description.monacard.desc;
        cid = description.monacard.cid;

        if (size === 'large') {
          cardImageUrl = `${state.config.clientParameters.monacardUrl}${cid}`;
          cardImageUrlSP = `${state.config.clientParameters.monacardUrl}${cid}`;
        }
        else { // small
          cardImageUrl = `${state.config.clientParameters.monacardUrl}${cid}m`;
          cardImageUrlSP = `${state.config.clientParameters.monacardUrl}${cid}t`;
        }

        isAMonacard = true;
      }
      catch (err) {
        if (state.monacard[item.asset] !== undefined) {
          cardName = state.monacard[item.asset].card_name;
          cardOwnerName = state.monacard[item.asset].owner_name;
          cardDescription = state.monacard[item.asset].add_description;
          cardImageUrl = state.monacard[item.asset].imgur_url;
          cardImageUrlSP = state.monacard[item.asset].imgur_url;
          isAMonacard = true;
        }
        else {
          cardName = state.assetInfo[item.asset].asset_longname || item.asset;
          cardOwnerName = null;
          cardDescription = state.assetInfo[item.asset].description;
          cardImageUrl = null;
          cardImageUrlSP = null;

          if (Object.keys(state.monacard).length >= 1) { // 分割取得した場合、完全には働かない。
            isAMonacard = false;
          }
        }
      }
    }
    else if (state.assetInfo[item.asset] !== undefined) {
      if (state.monacard[item.asset] !== undefined) {
        cardName = state.monacard[item.asset].card_name;
        cardOwnerName = state.monacard[item.asset].owner_name;
        cardDescription = state.monacard[item.asset].add_description;
        cardImageUrl = state.monacard[item.asset].imgur_url;
        cardImageUrlSP = state.monacard[item.asset].imgur_url;
        isAMonacard = true;
      }
      else {
        cardName = state.assetInfo[item.asset].asset_longname || item.asset;
        cardOwnerName = null;
        cardDescription = state.assetInfo[item.asset].description;
        cardImageUrl = null;
        cardImageUrlSP = null;

        if (Object.keys(state.monacard).length >= 1) { // 分割取得した場合、完全には働かない。
          isAMonacard = false;
        }
      }
    }
    else { // このケースはありえない想定。
      cardName = null;
      cardOwnerName = null;
      cardDescription = null;
      cardImageUrl = null;
      cardImageUrlSP = null;
      isAMonacard = false;
    }
  }
  else { // アセット情報取得途中
    cardName = null;
    cardOwnerName = null;
    cardDescription = null;
    cardImageUrl = null;
    cardImageUrlSP = null;
  }

  return {
    cardName,
    cardOwnerName,
    cardDescription,
    cid,
    cardImageUrl,
    cardImageUrlSP,
    isAMonacard,
  };
}

function checkIfAddressIsMatchedWithAnAddress(state, dispatch, addressActual, address, addressCheck) {
  if (addressCheck === 'strict' || addressCheck === 'addressSecond') {
    if (addressActual !== address) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
      return false;
    }
    else {
      return true;
    }
  }
  else { // off
    return true;
  }
}

// BROADCAST MONA TRANSACTIONS
async function broadcastMonaTransactions(state, dispatch, actionItemsMultiSources) {

  // ブロードキャスト

  for (const addressFrom of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
      if (actionItem.statusDetail === 'signed') {
        const result = await broadcastTransaction({ clientParameters: state.config.clientParameters, signedTxHex: actionItem.transactionSigned });

        if (result.status === 'fulfilled') {
          actionItem.txid = result.body;
          actionItem.status = 'succeeded';
          actionItem.statusDetail = 'broadcasted';

          // notification
          dispatch({ type: 'setNotification', key: 'notification', value: words.sentSuccessfully[state.language] + ' ' + actionItem.txid });
        }
        else {
          devLog('failed to broadcast transaction.');
          dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] });

          actionItem.status = 'failed';
          actionItem.statusDetail = 'failedToBroadcastTransaction';
          continue ACTION_ITEM;
        }
      }
    }
  }

  return actionItemsMultiSources;
}

// GET UTXO
// eslint-disable-next-line no-unused-vars
async function _getUtxo(state, address) {
  let serverIndex = 0;

  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.utxoPath}${address}`;
    devLog('get UTXO; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get UTXO; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      const utxos = response.body;
      devLog('utxos', JSON.stringify(utxos));
      return {
        status: 'fulfilled',
        body: utxos,
      };
    }
    else {
      devLog('get UTXO; rejected');

      if (serverIndex >= state.config.clientParameters.blockbook.domain.length - 1) {
        return {
          status: 'rejected',
          error: response.body + request.url,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// モナコインUTXO選定
// -- utxosは昇順ソート
function selectUtxoMona(utxos, amount) {
  devLog('selectUtxoMona', JSON.stringify(utxos), amount);
  const minimumGrater= minimumGraterUtxo(utxos, amount);
  devLog('minimumGrater', JSON.stringify(minimumGrater));

  if (minimumGrater !== null) {
    return [minimumGrater];
  }
  else {
    if (utxos.length <= 1) {
      return null;
    }

    const maximum = utxos.pop();
    devLog('maximum', JSON.stringify(maximum));
    const supplement = selectUtxoMona(utxos, amount - maximum.amount);

    if (supplement !== null) {
      supplement.unshift(maximum);
      return supplement;
    }
    else {
      return null;
    }
  }
}

function minimumGraterUtxo(utxos, bound) {
  devLog('minimumGraterUtxo', JSON.stringify(utxos), bound);
  let result = null;

  for(const utxo of utxos) {
   if (utxo.amount >= bound) {
     result = utxo;
     break;
   } 
  }

  return result;
}

// SELECT UTXO WATANABE
// モナコインUTXO選定
// -- utxosは昇順ソート
function selectUtxoWatanabe(utxos, amount) {
  devLog('selectUtxoWatanabe', JSON.stringify(utxos), amount);
  const minimumGrater= minimumGraterUtxoWatanabe(utxos, amount);
  devLog('minimumGrater', JSON.stringify(minimumGrater));

  if (minimumGrater !== null) {
    return [minimumGrater];
  }
  else {
    if (utxos.length <= 1) {
      return null;
    }

    const maximum = utxos.pop();
    devLog('maximum', JSON.stringify(maximum));
    const supplement = selectUtxoWatanabe(utxos, amount - maximum.satoshis);

    if (supplement !== null) {
      supplement.unshift(maximum);
      return supplement;
    }
    else {
      return null;
    }
  }
}

function minimumGraterUtxoWatanabe(utxos, bound) {
  devLog('minimumGraterUtxo', JSON.stringify(utxos), bound);
  let result = null;

  for(const utxo of utxos) {
   if (utxo.satoshis >= bound) {
     result = utxo;
     break;
   } 
  }

  return result;
}

// GET TRANSACTION
async function getTransaction(state, txid) {
  let transaction;
  let serverIndex = 0;

  // transaction取得
  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.transactionDetailPath}${txid}`;
    devLog('get transaction; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get transaction; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      transaction = response.body;
      devLog('transaction', JSON.stringify(transaction));

      return {
        status: 'fulfilled',
        body: transaction,
      };
    }
    else {
      devLog('get transaction; rejected');

      if (serverIndex >= state.config.clientParameters.blockbook.domain.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// GET RAW TRANSACTION
async function getRawTransaction(state, utxosSelected) {
  let serverIndex = 0;

  let request = {};
  request.method = 'POST';

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.monapaServer.domainAndPath[serverIndex]}`;

    for (const utxo of utxosSelected) {
      request.body = `{"jsonrpc":"2.0","id":0,"method":"proxy_to_counterpartyd","params":{"method":"getrawtransaction","params":{"tx_hash":"${utxo.txid}"}}}`;
      devLog('get UTX raw transaction; request', JSON.stringify(request));

      const response = await syncHttpRequest(request);
      devLog('get UTX raw transaction; response', JSON.stringify(response));

      if ( response.status === 'rejected' || response.body.error !== undefined ) {
        devLog('get UTXO; rejected');
        const error = response.status === 'rejected' ? response.error : response.body.error;

        if (serverIndex >= state.config.clientParameters.monapaServer.domainAndPath.length - 1) {
          // -- 失敗 エラー返却
          return {
            status: 'rejected',
            error: error
          };
        }
        else {
          serverIndex++;
          continue SERVER;
        }
      }

      utxo.rawTransaction = response.body.result;
    }

    break SERVER;
  }

  return {
    status: 'fulfilled',
    body: utxosSelected,
  };
}

// GET ADDRESS INFO
async function getAddressInfo(state, address) {
  let addressInfo;
  let serverIndex = 0;

  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.addressPath}${address}?details=basic`;
    devLog('get address info; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get address info; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      addressInfo = response.body;
      devLog('address info', JSON.stringify(addressInfo));

      return {
        status: 'fulfilled',
        body: addressInfo,
      };
    }
    else {
      devLog('get address info; rejected', response.error);

      if (serverIndex >= state.config.clientParameters.blockbook.domain.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// GET FEE RATE
// eslint-disable-next-line no-unused-vars
async function _getFeeRate(state) {
  let feeRate;
  let serverIndex = 0;

  // fee rate取得
  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };
  // delete request.body;

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.feePath}${state.config.clientParameters.blockbook.feeBlocks}`;
    devLog('get fee rate; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('get fee rate; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      if (response.body.result === '0') {
        feeRate = 0.002;
      }
      else {
        feeRate = toFloat(response.body.result);
      }

      devLog('feeRate', feeRate);

      return {
        status: 'fulfilled',
        body: feeRate,
      };
    }
    else {
      devLog('get fee rate; rejected');

      if (serverIndex >= state.config.clientParameters.blockbook.domain.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// CALCULATE CHANGE WATANABE
function calculateChangeWatanabe(utxosSelected, baseAmountWatanabe, feeRate, virtualSize, transactionFeeUpperBound) {
  // 概算バイト数計算

  const feeRateDecimal = new decimal(feeRate); // MONA/KB = 10^8watanabe/10^3byte = 10^5watanabe/byte
  const transactionFee = decimalAdjust( 'floor',  feeRateDecimal.times(100000).times(virtualSize).toNumber(), 0 ); 
  const amountToPay = baseAmountWatanabe + transactionFee;
  const change = utxosSelected.reduce( (acc, cur) => acc + cur.satoshis, 0 ) - amountToPay;
  devLog(`transactionFee ${transactionFee}, amountToPay ${amountToPay}, change ${change}`);

  // transactionFee歯止め

  if (transactionFee > transactionFeeUpperBound) {
    devLog('transactionFee is too high.');
    return {
      status: 'rejected',
      error: 'transactionFeeIsTooHigh',
    };
  }

  return {
    status: 'fulfilled',
    body: {
      change,
      transactionFee,
    },
  };
}

// BUILD UNSIGNED TRANSACTION SEND MONA
function buildUnsignedTransactionSendMona(inputs, outputs) {
  try {
    console.log('A');

    const txb = new bitcoin.TransactionBuilder(networkMona);

    console.log('B');

    for (const input of inputs) {
      const inputTransaction = bitcoin.Transaction.fromHex(input.rawTransaction);
      console.log(JSON.stringify(inputTransaction.outs[input.vout].script));
      input.scriptPubkey = inputTransaction.outs[input.vout].script;
      console.log(input.scriptPubkey);
      txb.addInput(input.txid, input.vout, null, input.scriptPubkey);
    }

    console.log('C');

    for (const output of outputs) {
      txb.addOutput(output.address, output.amount);
    }

    console.log('D');

    const unsignedTx = txb.buildIncomplete();

    console.log('E');
    console.log(inputs[0].scriptPubkey);

    for (let i = 0; i <= unsignedTx.ins.length - 1; i++) {
      console.log(i);
      unsignedTx.ins[i].script = inputs[i].scriptPubkey;
    }

    console.log('F');

    const unsignedTxHex = unsignedTx.toHex();

    return {
      status: 'fulfilled',
      body: unsignedTxHex,
    };
  }
  catch (error) {
    return {
      status: 'rejected',
      body: error,
    };
  }
}

// SIGN TRANSACTION
function signTransaction(txHex, keyPair, wif) {
  try {
    if (keyPair === undefined || keyPair === null) {
      keyPair = bitcoin.ECPair.fromWIF(wif, networkMona);
    }

    const tx = bitcoin.Transaction.fromHex(txHex);   // The unsigned second part of the 2 part P2SH transactions
    const txb = bitcoin.TransactionBuilder.fromTransaction(tx, networkMona);

    for (let i = 0; i < tx.ins.length; i++) {
      txb.sign(i, keyPair);
    }

    const signedTxHex = txb.build().toHex();

    devLog('inner result', signedTxHex);

    return {
      status: 'fulfilled',
      body: signedTxHex, // The resulting signed transaction in raw hex, ready to be broadcasted
    };
  }
  catch (error) {
    return {
      status: 'rejected',
      body: error,
    };
  }
}

// GET OUTPUT VALUE TOTAL
function getOutputValueTotal(txHex) {
  try {
    const tx = bitcoin.Transaction.fromHex(txHex);
    const outputValueTotal = tx.outs.reduce( (acc, cur) => acc + cur.value, 0 );

    return {
      status: 'fulfilled',
      body: outputValueTotal,
    };
  }
  catch (error) {
    return {
      status: 'rejected',
      body: error,
    };
  }
}

// BROADCAST TRANSACTION
// eslint-disable-next-line no-unused-vars
async function _broadcastTransaction(state, signedTxHex) {
  let serverIndex = 0;

  let request = {};
  request.method = 'POST';
  request.headers = {
    'Accept': 'application/json',
  };
  request.body = signedTxHex;

  SERVER: while (true) {
    request.url = `https://${state.config.clientParameters.blockbook.domain[serverIndex]}${state.config.clientParameters.blockbook.sendTransactionPath}`;
    devLog('broadcast transaction; request', JSON.stringify(request));

    const response = await syncHttpRequest(request);
    devLog('broadcast transaction; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      const txid = response.body.result;
      devLog('txid', txid);

      return {
        status: 'fulfilled',
        body: txid,
      };
    }
    else {
      devLog('broadcast transaction; rejected');

      if (serverIndex >= state.config.clientParameters.blockbook.domain.length - 1) {
        return {
          status: 'rejected',
          error: response.error,
        };
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}


// NFCボタン押下 HANDLE CLICK NFC
async function handleClickNfc(state, dispatch, callback, { args = ['keyPairs'], recordNos = [1] } = {}) {
  if ('NDEFReader' in window) {
    const ndef = new window.NDEFReader();
    await ndef.scan();

    ndef.onreading = async event => {
      console.log("NDEF tag detected");

      const keyPairs = [];
      const mnemonics = [];

      const argumentsAll = { keyPairs, mnemonics };
      const argumentsToPass = args.map( arg => argumentsAll[arg] );

      for (const [index, record] of event.message.records.entries()) {
        if (!recordNos.includes(index)) {
          continue;
        }

        try {
          const textDecoder = new TextDecoder(record.encoding);
          const mnemonicEncrypted = textDecoder.decode(record.data);
          const pass = state.config.clientParameters.specialMessage;
          // const pass = undefined;
          const salt = ['00', '00', '00', '00', '00', '00', '00', '72'];
          const iv = ['00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '01', 'bf', '52'];
          const mnemonic = await decrypt(state, dispatch, mnemonicEncrypted, pass, salt, iv);
          // const mnemonic = textDecoder.decode(record.data);
          // const mnemonic = undefined;
          mnemonics.push(mnemonic);
          const keyPair = getKeyPairsFromMnemonic(mnemonic)[0];
          // const seed = bip39.mnemonicToSeedSync(mnemonic);
          // const root = bip32.fromSeed(seed)
          // const path = "m/44'/22'/0'/0/0";
          // const leaf = root.derivePath(path);
          // const keyPair = ECPair.fromPrivateKey(leaf.privateKey, { network: networkMona });
          keyPairs.push(keyPair);
          // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'address'], value: getAddressFromKey(state, dispatch, keyPair).address }); // 暫定
          // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wif'], value: JSON.stringify(keyPair) }); // 暫定
          // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: typeof mnemonic }); // 暫定
          // const payment = bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey, network: networkMona });
          // const message = 'hoge';
          // let randomBytes = new Uint8Array(32);
          // window.crypto.getRandomValues(randomBytes);
          // const signature = bitcoinMessage.sign(message, keyPair.privateKey, keyPair.compressed, networkMona.messagePrefix, { extraEntropy: Buffer.from(randomBytes) });
          // console.log(`Record type: ${record.recordType}`);
          // console.log(`MIME type: ${record.mediaType}`);
          // console.log(`Data: ${textDecoder.decode(record.data)}`);
          // dispatch({ type: 'setStateMultiLayers', keys: ['login', 'addressMain'], value: signature.toString('base64')}); 
          // dispatch({ type: 'setStateMultiLayers', keys: ['login', 'addressMain'], value: payment.address}); 
          // dispatch({ type: 'setStateMultiLayers', keys: ['cardRegistration', 'feature'], value: keyPair.toWIF()}); 

          // const encryptedMessage = 'kR10Y9tegf2qDkjOFAxK7/YuXX4J4vgHiI3uxaQJQPDVnfc0pR+j2XrK3cn8cJRMwEl9B6DT2ZDcKr2SUxehhe6OcAO57nYLLSOZe+JVP0p4uoMUctfZeoU40Bo2lVjZHnhKd9+zEeDGuqbMXz6ToccqQAa2426B44W5RGRa+9we/Zts5adaalZZu1vnpdn74w3UjBy+ggEwsuu03mjQqLjl1mBB97PaOOdG+XBiczc=';
          // dispatch({ type: 'setStateMultiLayers', keys: ['cardRegistration', 'feature'], value: mnemonic.toString() }); 
          // const encryptedU8A = Uint8Array.from(window.atob(mnemonicEncrypted), byte => byte.charCodeAt(0));
          // dispatch({ type: 'setStateMultiLayers', keys: ['cardRegistration', 'name'], value: mnemonicEncrypted }); 
        }
        catch (error) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromTheKeyCard[state.language] });
        }
      }

      // 先に後処理やっちゃう。
      ndef.onreading = null;
      ndef.onreadingerror = null;

      if (argumentsToPass.some( arg => arg.length === 0 )) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromTheKeyCard[state.language] });
        throw new Error('noArgumentToPass');
      }

      callback(...argumentsToPass);
    };

    ndef.onreadingerror = () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromTheKeyCard[state.language] });

      ndef.onreading = null;
      ndef.onreadingerror = null;
    };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportKeyCards[state.language] });
  }
}

// NFC読み込み READ NFC
async function readNfc(state, dispatch, encryptedMnemonic) {
  if (!('NDEFReader' in window)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportKeyCards[state.language] });
    return;
  }

  const ndef = new window.NDEFReader();

  const result = await ndef.write({
    records: [
      {
        recordType: "url",
        data: "https://knightsofmonadom.monatoka.com/?wallettype=nfc"
      },
      {
        recordType: "text",
        lang: "en",
        encoding: "utf-8",
        data: encryptedMnemonic,
        // data: state.displaySecret.mnemonicToWif,
      },
    ]
  })
  .then( (result) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'NDEF messages written!' });
    return;
  })
  .catch( (error) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'Failed to write NDEF messages.' });
    throw new Error(error);
  });

  return result;
}

// NFC書き込み WRITE MNEMONIC ON NFC
async function writeMnemonicOnNfc(state, dispatch, encryptedMnemonic) {
  if (!('NDEFReader' in window)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportKeyCards[state.language] });
    return;
  }

  const ndef = new window.NDEFReader();

  const result = await ndef.write({
    records: [
      {
        recordType: "url",
        data: "https://knightsofmonadom.monatoka.com/?wallettype=nfc"
      },
      {
        recordType: "text",
        lang: "en",
        encoding: "utf-8",
        data: encryptedMnemonic,
        // data: state.displaySecret.mnemonicToWif,
      },
    ]
  })
  .then( (result) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'NDEF messages written!' });
    return;
  })
  .catch( (error) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'Failed to write NDEF messages.' });
    throw new Error(error + encryptedMnemonic);
  });

  return result;
}

// NFC書き込んだニーモニックチェック CHECK MNEMONIC ON NFC
function checkMnemonicOnNfc(state, dispatch, mnemonicToBeWritten, mnemonicsWritten) {
  if (mnemonicToBeWritten === mnemonicsWritten[0]) {
    localStorage.setItem('swapStatus', 'checkedMnemonic');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'check mnemonic OK.' }); // 暫定
  }
  else {
    localStorage.setItem('swapStatus', 'sweptMona');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'check mnemonic NG.' }); // 暫定
  }
}

// mnemonicから秘密鍵取得 GET KEYPAIRS FROM MNEMONIC
function getKeyPairsFromMnemonic(mnemonic) {
  let keyPairs = [];

  try {
    const seed = bip39.mnemonicToSeedSync(mnemonic);
    const root = bip32.fromSeed(seed)
    const path = "m/44'/22'/0'/0/0";
    const leaf = root.derivePath(path);
    const keyPair = ECPair.fromPrivateKey(leaf.privateKey, { network: networkMona });
    keyPairs.push(keyPair);
  }
  catch (error) {
    devLog('getKeyPairsFromMnemonic ; error', error);
    throw new Error('cannotGetKeyPairsFromMnemonic');
  }

  return keyPairs;
}

// 鍵渡してcertificationつくる CERTIFICATION WITH KEY
function certificationWithKey(state, dispatch, keyPairs, messageType, stateFixed, certifications, clientTime, extendedCertificationProperties, signingMode) {
  let addressIsSpecified;

  // lastEvaluatedSortKey等があるということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
  // addressMainが指定されていないということは、後ページ検索ではない。
  // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。
    
  if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
    addressIsSpecified = true;
  }
  else {
    addressIsSpecified = false;
  }

  if (signingMode === 'firstKey') {
    keyPairs = [ keyPairs[0] ];
  }
  else { // matchedKey
  }

  for (const [index, keyPair] of keyPairs.entries()) {
    // アドレス導出
    let payment;
    let address;
    let addressActual;

    try {
      payment = bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey, network: networkMona });
      addressActual = payment.address;
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      continue;
    }

    if (signingMode === 'matchedKey') {
      if (addressActual !== stateFixed.addressMain) {
        continue;
      }
      else {
        address = stateFixed.addressMain;
      }
    }
    else { // firstKey
      if (addressIsSpecified) {
        if (checkIfAddressIsMatchedWithAnAddress(state, dispatch, addressActual, stateFixed.addressMain, stateFixed.addressCheck)) {
          address = stateFixed.addressMain;
        }
        else {
          continue;
        }
      }
      else {
        address = addressActual;
        stateFixed.addressMain = addressActual;
      }
    }

    // 渡された鍵ペアに対応するアドレスがcertificationsに含まれていなければ、署名する。
    if (address !== undefined && address !== null && address !== '' && !certifications.map( certification => certification.address ).includes(address)) {
      let message;

      if (messageType === 'login') {
      //   if (stateFixed.addressMain !== undefined || stateFixed.addressMain !== null || stateFixed.addressMain !== '') {
      //     message = `I want to log in to monacotto as ${stateFixed.addressMain}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
      //   }
      //   else {
        message = `I want to log in to monacotto as ${address}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
      //   }
      }
      else if (messageType === 'information') {
        message = `I want to get the information of ${address}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
      }

      devLog('message', message);

      let signatureMona;

      const result = signWithKey(state, dispatch, keyPair, message);

      if (result.status === 'fulfilled') {
        signatureMona = result.signature;
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
        continue;
      }

      const certification = {
        // addressCoinType: 'mona',
        address: address,
        addressActual: addressActual,
        clientTime: clientTime,
        signatureVersion: stateFixed.signatureVersion,
        signature: signatureMona,
        lastEvaluatedSortKey: stateFixed.lastEvaluatedSortKey,
      };

      // 拡張プロパティ
      if (extendedCertificationProperties !== undefined && extendedCertificationProperties !== null) {
        for (const property of extendedCertificationProperties) {
          certification[property.key] = property.value;
        }
      }

      devLog('certification given key', JSON.stringify(certification));

      certifications.push(certification);
    }
  }
}

// アドレス抽出 GET ADDRESS FROM KEY
function getAddressFromKey (state, dispatch, keyPair) {
  // アドレス導出
  let payment;
  let address;

  try {
    payment = bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey, network: networkMona });
    address = payment.address;

    return {
      status: 'fulfilled',
      address: address,
    };
  }
  catch (err) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });

    return {
      status: 'rejected',
    };
  }
}

// 鍵渡して署名 SIGN WITH KEY
function signWithKey(state, dispatch, keyPair, message) {
  let signatureMona;

  try {
    let randomBytes = new Uint8Array(32);
    window.crypto.getRandomValues(randomBytes);
    signatureMona = bitcoinMessage.sign(message, keyPair.privateKey, keyPair.compressed, networkMona.messagePrefix, { extraEntropy: Buffer.from(randomBytes) }).toString('base64');

    return {
      status: 'fulfilled',
      signature: signatureMona,
    };
  }
  catch (err) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] + 'SWK' });

    return {
      status: 'rejected'
    };
  }

}

// DECRYPT
async function decrypt(state, dispatch, encryptedData, password, salt, iv) {
  try {
    // 暗号化データをUint8Arrayに変換
    const encryptedU8A = Uint8Array.from(window.atob(encryptedData), byte => byte.charCodeAt(0));

    // パスワードをUint8Arrayに変換
    const passwordU8A = new TextEncoder().encode(password);

    // ソルトをUint8Arrayに変換
    const saltHexArray = salt;
    const saltNumberArray = saltHexArray.map( hex => Number('0x' + hex) );
    const saltU8A = Uint8Array.from(saltNumberArray);

    // if (salt !== undefined && salt !== null) {
    //   const saltBstr = window.atob(salt); // ソルトをBASE64からバイナリバイト列へデコード
    //   const saltU8A = Uint8Array.from(saltBstr, byte => byte.charCodeAt(0));
    //   deriveKeyAlgorithm.salt = saltU8A;
    // }

    // IVをUint8Arrayに変換
    const ivHexArray = iv;
    const ivNumberArray = ivHexArray.map( hex => Number('0x' + hex) );
    const ivU8A = Uint8Array.from(ivNumberArray);

    // if (iv !== undefined && iv !== null) {
    //   ivU8A = Uint8Array.from(window.atob(iv), byte => byte.charCodeAt(0));
    // }

    // PBKDF2を使用して鍵を導出
    const keyMaterial = await window.crypto.subtle.importKey(
        "raw",
        passwordU8A,
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
    );

    const deriveKeyAlgorithm = {
        name: "PBKDF2",
        salt: saltU8A,
        iterations: 514,
        hash: "SHA-256"
    };

    const key = await window.crypto.subtle.deriveKey(
        deriveKeyAlgorithm,
        keyMaterial,
        { name: "AES-CBC", length: 256 },
        false,
        ["decrypt"]
    );

    // データを復号
    const decryptedABuff = await window.crypto.subtle.decrypt(
        { name: "AES-CBC", iv: ivU8A },
        key,
        encryptedU8A
    );

    // 復号されたデータを文字列に変換
    const decrypted = new TextDecoder().decode(decryptedABuff);

    // トリム
    const decryptedTrimmed = decrypted.trim();

    return decryptedTrimmed;
    // return new Uint8Array(decryptedABuff);
  } catch (e) {
    console.error("Decryption failed", e);
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToDecrypt[state.language] });
    throw e;
  }
}

// ENCRYPT
async function encrypt(state, dispatch, plaintext, password, salt, iv) {
  try {
    // 平文データをUint8Arrayに変換
    // const plaintextU8A = Uint8Array.from(window.atob(plaintext), byte => byte.charCodeAt(0));
    const plaintextU8A = new TextEncoder().encode(plaintext);

    // パスワードをUint8Arrayに変換
    const passwordU8A = new TextEncoder().encode(password);

    // ソルトをUint8Arrayに変換
    const saltHexArray = salt;
    const saltNumberArray = saltHexArray.map( hex => Number('0x' + hex) );
    const saltU8A = Uint8Array.from(saltNumberArray);

    // if (salt !== undefined && salt !== null) {
    //   const saltBstr = window.atob(salt); // ソルトをBASE64からバイナリバイト列へデコード
    //   const saltU8A = Uint8Array.from(saltBstr, byte => byte.charCodeAt(0));
    //   deriveKeyAlgorithm.salt = saltU8A;
    // }

    // IVをUint8Arrayに変換
    const ivHexArray = iv;
    const ivNumberArray = ivHexArray.map( hex => Number('0x' + hex) );
    const ivU8A = Uint8Array.from(ivNumberArray);

    // if (iv !== undefined && iv !== null) {
    //   ivU8A = Uint8Array.from(window.atob(iv), byte => byte.charCodeAt(0));
    // }

    // PBKDF2を使用して鍵を導出
    const keyMaterial = await window.crypto.subtle.importKey(
        "raw",
        passwordU8A,
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
    );

    const deriveKeyAlgorithm = {
        name: "PBKDF2",
        salt: saltU8A,
        iterations: 514,
        hash: "SHA-256"
    };

    const key = await window.crypto.subtle.deriveKey(
        deriveKeyAlgorithm,
        keyMaterial,
        { name: "AES-CBC", length: 256 },
        false,
        ["encrypt"]
    );

    // データを暗号化
    const encryptedABuff = await window.crypto.subtle.encrypt(
        { name: "AES-CBC", iv: ivU8A },
        key,
        plaintextU8A
    );

    // 暗号化されたデータを文字列に変換
    // const encrypted = new TextDecoder().decode(encryptedABuff);
    const encrypted = arrayBufferToBase64(encryptedABuff);

    // トリム
    const encryptedTrimmed = encrypted.trim();

    dispatch({ type: 'setNotification', key: 'notification', value: 'encryptedTrimmed ' + encryptedTrimmed });
    return encryptedTrimmed;
    // return new Uint8Array(decryptedABuff);
  } catch (e) {
    console.error("Encryption failed", e);
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToEncrypt[state.language] });
    // throw e;
  }
}

// QRボタン押下 HANDLE CLICK SCAN QR
function handleClickScanQr(state, dispatch, callback, { args = ['keyPairs'], recordNos = [0], callbackType = 'decryptMnemonic', popupLayer = 0 } = {}) {
  devLog('handleClickScanQr');
  const popup = {
    type: 'generalItems',
    body: <QrCodeScanner popupLayer={popupLayer} callback={callback} callbackType={callbackType} options={ {args, recordNos} } />,
    // body: <div>hoge</div>,
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: popup });
}

// DO SOMETHING WITH ENCRYPTED MNEMONICS
async function doSomethingWithEncryptedMnemonics(state, dispatch, mnemonicsEncrypted, callback, { args = ['keyPairs'], recordNos = [0] } = {}) {
  const keyPairs = [];
  const mnemonics = [];

  const argumentsAll = { keyPairs, mnemonics };
  const argumentsToPass = args.map( arg => argumentsAll[arg] );

  for (const recordNo of recordNos) {
    try {
      const pass = state.config.clientParameters.specialMessage;
      const salt = ['00', '00', '00', '00', '00', '00', '00', '72'];
      const iv = ['00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '01', 'bf', '52'];
      const mnemonic = await decrypt(state, dispatch, mnemonicsEncrypted[recordNo], pass, salt, iv);
      mnemonics.push(mnemonic);
      const keyPair = getKeyPairsFromMnemonic(mnemonic)[0];
      keyPairs.push(keyPair);
    }
    catch (error) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromTheKeyCard[state.language] });
    }
  }

  if (argumentsToPass.some( arg => arg.length === 0 )) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.cannotReadDataFromTheKeyCard[state.language] });
    throw new Error('noArgumentToPass');
  }

  callback(...argumentsToPass);
}

// ArrayBufferをBase64文字列に変換する関数
function arrayBufferToBase64(buffer) {
    // ArrayBufferからバイナリ文字列を生成
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    // window.btoa関数でバイナリ文字列をBase64にエンコード
    return window.btoa(binary);
}

// KEEP KEY PAIRS IN MEMORY
function keepKeyPairsInMemory(state, dispatch, keyPairs) {
  const now = new Date();

  for (const keyPair of keyPairs) {
    // アドレス導出
    let payment;
    let address;

    try {
      payment = bitcoin.payments.p2pkh({ pubkey: keyPair.publicKey, network: networkMona });
      address = payment.address;
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      continue;
    }

    const keyPairData = {
      keyPair: keyPair,
      expiration: now.getTime() + state.config.clientParameters.periodToKeepKeyPairs,
    };

    const keyPairsState = state.keyPairs;
    keyPairsState[address] = keyPairData;

    // dispatch({ type: 'setNotification', key: 'notification', value: 'keep' + address });
    // dispatch({ type: 'setStateMultiLayers', keys: ['keyPairs', address], value: keyPairData });
    dispatch({ type: 'setState', key: 'keyPairs', value: keyPairsState });
  }
}

// GET VALID KEY PAIRS
function getValidKeyPairs(state, dispatch) {
  const keyPairs = state.keyPairs;
  const validKeyPairs = {};
  const now = new Date();

  for (const address of Object.keys(keyPairs)) {
    if (keyPairs[address].expiration > now.getTime()) {
      validKeyPairs[address] = keyPairs[address];
    }
  }

  dispatch({ type: 'setState', key: 'keyPairs', value: validKeyPairs });

  return validKeyPairs;
}

async function hasCamera() {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.some(device => device.kind === 'videoinput');
  } catch (error) {
    devLog("An error occurred:", error);
    return false;
  }
}

// アドレスセクション＆ユーザー名セクション
function getAddressAndUserNameSections(state, dispatch) {
  // アドレスセクション・スイッチアイコン

  let addressSection;
  let switchIcon;

  if (state.configure.displayAddressSection) {
    addressSection = <AddressSection keys={['configure', 'addressMain']} />;
    switchIcon = iconCollapse;
  }
  else {
    switchIcon = iconExpand;
  }

  // ユーザー名セクション

  const userNameSection =
  <div className='flexRow justifyContentFlexStart alignItemsCenter '>
    <TextLine3 fieldName='userName' keys={['configure', 'userName']} face={words.userName[state.language]} tooltip='right' />
    <button className={'button1'} tabindex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'displayAddressSection'], value: state.configure.displayAddressSection ? false : true });
      }}
    >
      <img className='size2x2' src={switchIcon} alt='' />
    </button>
  </div>

  return { addressSection, userNameSection };
}


// HTTPリクエスト（同期バージョン2）
async function syncHttpRequest2(request, setResultKey, sortFunction, setNotificationKey, messages, dispatch) {
  if (request.headers === undefined) {
    request.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
  }

  if (request.method === undefined) {
    request.method = 'POST';
  }

  /*
  const method = 'POST';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
  */

  const result = await fetch(request.url, { method: request.method, headers: request.headers, body: request.body })
  .then( response => response.json() )
  .then( async json => {
           const applicationMessage = json.applicationMessage;

           devLog(applicationMessage, messages[applicationMessage], 'setNotificationKey', setNotificationKey);

           if (setNotificationKey !== undefined && setNotificationKey !== null) {
             devLog('inner', setNotificationKey);
             dispatch({ type: 'setNotification', key: setNotificationKey,
                        value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  
           }

           if (json.applicationStatus.substring(0,1) === '2') {
             let body = json.body;

             if (setResultKey !== undefined && setResultKey !== null) {
               devLog(setResultKey);
               devLog(JSON.stringify(body));

               if (sortFunction !== undefined && sortFunction !== null) {
                 body.sort(sortFunction);
               }

               dispatch({ type: 'setState', key: setResultKey, value: body });
             }

             return { status: 'fulfilled', body: body };
           }
           else {
             return { status: 'rejected', body: json.body };
           }
         }
  )
  .catch( error => {
           return { status: 'rejected', error: error };
          }
  );

  return result;
}

// HTTPリクエスト（同期バージョン）
async function syncHttpRequest(request) {
  if (request.headers === undefined) {
    request.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
  }

  return await fetch(request.url, { method: request.method, headers: request.headers, body: request.body })
  .then( response => response.json() )
  .then( json => {
    devLog('syncHttpRequest fulfilled', JSON.stringify(json));
    return { status: 'fulfilled', body: json };
  })
  .catch( error => {
    devLog('syncHttpRequest rejected', JSON.stringify(error));
    return { status: 'rejected', body: error };
  });
}

function toFloat(string) {
  if (Number.isFinite(string) || string === Infinity) {
    return string;
  }

  const numericCharacter = string.replace(/[^\d.]/, '');
  let float = parseFloat(numericCharacter);

  if (Number.isNaN(float)) {
    float = ''
  }

  return float;
}

// LOCAL TIME
function localTime(epoch, format) {
  const epochNum = parseInt(epoch, 10);
  let time;

  if (Number.isNaN(epochNum) || epochNum === '' || epochNum === undefined) {
    return '';
  }

  time = new Date(epochNum);

  if (format === 'yearToMinute') {
    return `${time.getFullYear()}/${(time.getMonth() + 1).toString().padStart(2, '0')}/${time.getDate().toString().padStart(2, '0')} ${time.getHours().toString().padStart(2, '0')}:${time.getMinutes().toString().padStart(2, '0')}`;
  }
  else if (format === 'digit14Num') {
    return parseInt(`${time.getFullYear()}${(time.getMonth() + 1).toString().padStart(2, '0')}${time.getDate().toString().padStart(2, '0')}${time.getHours().toString().padStart(2, '0')}${time.getMinutes().toString().padStart(2, '0')}${time.getSeconds().toString().padStart(2, '0')}`, 10);
  }
  else {
    return `${time.getFullYear()}/${(time.getMonth() + 1).toString().padStart(2, '0')}/${time.getDate().toString().padStart(2, '0')} ${time.getHours().toString().padStart(2, '0')}:${time.getMinutes().toString().padStart(2, '0')}:${time.getSeconds().toString().padStart(2, '0')}.${time.getMilliseconds()}`;
  }
}

// MINUTES AND SECONDS
function minutesAndSeconds(milliseconds) {
  if (milliseconds <= 0) {
    return '00:00';
  }

  const seconds = Math.floor(milliseconds / 1000); 
  return Math.floor(seconds / 60).toString().padStart(2, '0') + ':' + (seconds % 60).toString().padStart(2, '0');
}

// DECIMAL ADJUST
function decimalAdjust(type, value, exp) {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  // If value is Infinity...
  if (value === Infinity) {
    return Infinity;
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

// ADJUST MULTI LAYERS FLOAT
function adjustFloat(type, value, exp) {
  let number = parseFloat(value);

  if (Number.isNaN(number)) {
    number = ''
  }
  else if (type !== undefined) {
    number = decimalAdjust(type, number, exp);
  }

  return number;
}

// // URL PARAMS STRINGIFY
// function urlParamsStringify(urlParams) {
//   return urlParams.reduce( (acc, cur) => {
//     if (cur !== null) {
//       return acc + (acc === '' ? '?' : '&') + cur;
//     }
//     else {
//       return acc;
//     }
//   }, '' );
// }

// // COPY TO CLIPBOARD
// function copyToClipboard(text, textAreaRef) {
//   if (textAreaRef.current) {
//     textAreaRef.current.value = text;
//     textAreaRef.current.select();
//     document.execCommand('copy');
//   }
// }

// // DEVLOG
// function devLog(...words) {
//   if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
//     console.log(words.join(' '));
//   }
//   return 1;
// }

// REDUCER
function reducer(state, action) {
  let newState = { ...state };
  let numericCharacter;
  let number;
  let amountMona;
  let amountJpyc;
  let isChanged;
  let items;
  let item;
  let newIndex;

  switch (action.type) {
    case 'setState': {
      newState[action.key] = action.value;
      return newState;
    }

    case 'setStateMultiLayers': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;
        if (isLast) {
          acc[cur] = action.value;
          return acc[cur];
        }
        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // case 'setStateMultiLayers':
    //   action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
    //     if (idx === src.length - 1) {
    //       return acc;
    //     }
    //     if (idx === src.length - 2) {
    //       return acc[cur] = src[idx + 1];
    //     }
    //     else {
    //       return acc[cur];
    //     }
    //   }, newState );
    //   return newState;

    case 'setStateNum': {
      number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    }

    case 'setStateMultiLayersNum': {
      number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        number = ''
      }

      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc[cur] = number;
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    }

    case 'setStateFloat': {
      number = parseFloat(action.value);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    }

    case 'setStateMultiLayersFloat': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      const faceSource = action.value === undefined || action.value === null ? '' : String(action.value);
      const numericCharacter = faceSource.replace(/[^\d.]/, '');
      let number = parseFloat(numericCharacter);

      if (Number.isNaN(number)) {
        number = ''
      }
      else if (action.adjustType !== undefined) {
        number = decimalAdjust(action.adjustType, number, action.adjustExp);
      }

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;

        if (isLast) {
          const currentLeaf = acc[cur];
          let nextLeaf;

          if (currentLeaf && typeof currentLeaf === 'object' && !Array.isArray(currentLeaf)) {
            nextLeaf = { ...currentLeaf };
          }
          else {
            nextLeaf = {};
          }

          nextLeaf.face = numericCharacter;
          nextLeaf.value = number;

          acc[cur] = nextLeaf;
          return acc[cur];
        }

        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // // setStateMultiLayersFloat
    // case 'setStateMultiLayersFloat':
    //   numericCharacter = action.value.replace(/[^\d.]/, '');
    //   number = parseFloat(numericCharacter);

    //   if (Number.isNaN(number)) {
    //     number = ''
    //   }
    //   else if (action.adjustType !== undefined) {
    //     number = decimalAdjust(action.adjustType, number, action.adjustExp);
    //   }

    //   action.keys.reduce( (acc, cur, idx, src) => {
    //     if (idx === src.length - 1) {
    //       acc[cur].face = numericCharacter;
    //       acc[cur].value = number;
    //       return acc[cur];
    //     }
    //     else {
    //       return acc[cur];
    //     }
    //   }, newState );

    //   return newState;

    // adjustFace
    case 'adjustFace': {
      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          acc[cur].face = acc[cur].value;
          return acc[cur];
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    }

    // pushOut
    case 'pushOut': {
      const target = action.targetKeys.reduce( (acc, cur) => {
          return acc[cur];
      }, newState );

      action.keys.reduce( (acc, cur, idx, src) => {
        const pushedOut = target[cur];
        target[cur] = acc;
        return  pushedOut;
      }, action.value );

      return newState;
    }

    case 'setStateIfChange': {
      if (newState[action.key] != action.value) {
        newState[action.key] = action.value;
        return newState;
      }
      else {
        return state;
      }
    }

    case 'setStateMultiLayersIfChange': {
      isChanged = action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc;
        }
        if (idx === src.length - 2) {
          if (acc[cur] !== src[idx + 1]) {
            acc[cur] = src[idx + 1];
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return acc[cur];
        }
      }, newState );

      if (isChanged) {
        return newState;
      }
      else {
        return state;
      }
    }

    // setNotification
    case 'setNotification': {
      newState[action.key].body.push(action.value);

      if (newState[action.key].body.length > notificationMaxLength) {
        newState[action.key].body.shift();
      }

      newState[action.key].index = newState[action.key].body.length -1;

      newState[action.key].inAnimation = true;

      return newState;
    }

    case 'stopNotificationAnimation': {
      newState[action.key].inAnimation = false;
      return newState;
    }

    // itemReplace
    case 'itemReplace': {
      items = newState.items[newState.gallery.addressMain].itemPlacement[0].items;
      item = items[action.index];

      if (action.direction === 'left') {
        newIndex = action.index - 1 >= 0 ? action.index -1 : items.length - 1;
      }
      else { // right
        newIndex = action.index + 1 <= items.length - 1 ? action.index + 1 : 0;
      }

      items.splice(action.index, 1);
      items.splice(newIndex, 0, item);

      return newState;
    }

    // default
    default: {
      return state;
    }
  }
}

export default App;
export { NewCard, Village, Gallery, AllCard, Redirect, HowToUse, HowToUseAdvanced, HowToUseMpurse };
